// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@proj-client/assets/fonts/wallop/Wallop-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("@proj-client/assets/fonts/wallop/Wallop-Bold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: Lexend, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

[type='text'],input:where(:not([type])),[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus, input:where(:not([type])):focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(1px + 0px) #2563eb, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

input::-moz-placeholder, textarea::-moz-placeholder{
  color: #6b7280;
  opacity: 1;
}

input::placeholder,textarea::placeholder{
  color: #6b7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper{
  padding: 0;
}

::-webkit-date-and-time-value{
  min-height: 1.5em;
  text-align: inherit;
}

::-webkit-datetime-edit{
  display: inline-flex;
}

::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{
  padding-top: 0;
  padding-bottom: 0;
}

select{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[multiple],[size]:where(select:not([size="1"])){
  background-image: none;
  background-image: initial;
  background-position: 0 0;
  background-position: initial;
  background-repeat: repeat;
  background-repeat: initial;
  background-size: auto auto;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: inherit;
          print-color-adjust: inherit;
}

[type='checkbox'],[type='radio']{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  padding: 0;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

[type='checkbox']{
  border-radius: 0px;
}

[type='radio']{
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #2563eb, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked{
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@media (forced-colors: active) {

  [type='checkbox']:checked{
    -webkit-appearance: auto;
       -moz-appearance: auto;
            appearance: auto;
  }
}

[type='radio']:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media (forced-colors: active) {

  [type='radio']:checked{
    -webkit-appearance: auto;
       -moz-appearance: auto;
            appearance: auto;
  }
}

[type='checkbox']:checked:hover,[type='checkbox']:checked:focus,[type='radio']:checked:hover,[type='radio']:checked:focus{
  border-color: transparent;
  background-color: currentColor;
}

[type='checkbox']:indeterminate{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

@media (forced-colors: active) {

  [type='checkbox']:indeterminate{
    -webkit-appearance: auto;
       -moz-appearance: auto;
            appearance: auto;
  }
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus{
  border-color: transparent;
  background-color: currentColor;
}

[type='file']{
  background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  background: initial;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: inherit;
  line-height: inherit;
}

[type='file']:focus{
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}

@font-face{
  font-family: Wallop;
  font-feature-settings: 'ss01' 1, 'ss14' 1;
}

.font-display{
  font-family: "Wallop", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-feature-settings: 'ss01' 1, 'ss14' 1;
}

@font-face {
    font-family: "Wallop";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2");
    font-weight: normal;
    font-style: normal;
  }

@font-face {
    font-family: "Wallop";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2");
    font-weight: bold;
    font-weight: 600 700;
    font-style: normal;
  }

html {
    font-feature-settings: "calt", "clig", "kern", "liga", "locl", "rlig";
    font-weight: normal;
    font-family: "Lexend", sans-serif;
  }

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
.prose{
  color: var(--tw-prose-body);
  max-width: 65ch;
}
.prose :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-lead);
  font-size: 1.25em;
  line-height: 1.6;
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}
.prose :where(a):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-links);
  text-decoration: underline;
  font-weight: 500;
}
.prose :where(strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-bold);
  font-weight: 600;
}
.prose :where(a strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(blockquote strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(thead th strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: decimal;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
  padding-inline-start: 1.625em;
}
.prose :where(ol[type="A"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: upper-alpha;
}
.prose :where(ol[type="a"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: lower-alpha;
}
.prose :where(ol[type="A" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: upper-alpha;
}
.prose :where(ol[type="a" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: lower-alpha;
}
.prose :where(ol[type="I"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: upper-roman;
}
.prose :where(ol[type="i"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: lower-roman;
}
.prose :where(ol[type="I" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: upper-roman;
}
.prose :where(ol[type="i" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: lower-roman;
}
.prose :where(ol[type="1"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: decimal;
}
.prose :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: disc;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
  padding-inline-start: 1.625em;
}
.prose :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *))::marker{
  font-weight: 400;
  color: var(--tw-prose-counters);
}
.prose :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *))::marker{
  color: var(--tw-prose-bullets);
}
.prose :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-headings);
  font-weight: 600;
  margin-top: 1.25em;
}
.prose :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  border-color: var(--tw-prose-hr);
  border-top-width: 1px;
  margin-top: 3em;
  margin-bottom: 3em;
}
.prose :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-weight: 500;
  font-style: italic;
  color: var(--tw-prose-quotes);
  border-inline-start-width: 0.25rem;
  border-inline-start-color: var(--tw-prose-quote-borders);
  quotes: "\\201C""\\201D""\\2018""\\2019";
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-inline-start: 1em;
}
.prose :where(blockquote p:first-of-type):not(:where([class~="not-prose"],[class~="not-prose"] *))::before{
  content: open-quote;
}
.prose :where(blockquote p:last-of-type):not(:where([class~="not-prose"],[class~="not-prose"] *))::after{
  content: close-quote;
}
.prose :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-headings);
  font-weight: 800;
  font-size: 2.25em;
  margin-top: 0;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}
.prose :where(h1 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-weight: 900;
  color: inherit;
}
.prose :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-headings);
  font-weight: 700;
  font-size: 1.5em;
  margin-top: 2em;
  margin-bottom: 1em;
  line-height: 1.3333333;
}
.prose :where(h2 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-weight: 800;
  color: inherit;
}
.prose :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-headings);
  font-weight: 600;
  font-size: 1.25em;
  margin-top: 1.6em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}
.prose :where(h3 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-weight: 700;
  color: inherit;
}
.prose :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-headings);
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.5;
}
.prose :where(h4 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-weight: 700;
  color: inherit;
}
.prose :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  display: block;
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-weight: 500;
  font-family: inherit;
  color: var(--tw-prose-kbd);
  box-shadow: 0 0 0 1px rgb(var(--tw-prose-kbd-shadows) / 10%), 0 3px 0 rgb(var(--tw-prose-kbd-shadows) / 10%);
  font-size: 0.875em;
  border-radius: 0.3125rem;
  padding-top: 0.1875em;
  padding-inline-end: 0.375em;
  padding-bottom: 0.1875em;
  padding-inline-start: 0.375em;
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-code);
  font-weight: 600;
  font-size: 0.875em;
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))::before{
  content: "\`";
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))::after{
  content: "\`";
}
.prose :where(a code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(h1 code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
  font-size: 0.875em;
}
.prose :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
  font-size: 0.9em;
}
.prose :where(h4 code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(blockquote code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(thead th code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-pre-code);
  background-color: var(--tw-prose-pre-bg);
  overflow-x: auto;
  font-weight: 400;
  font-size: 0.875em;
  line-height: 1.7142857;
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
  border-radius: 0.375rem;
  padding-top: 0.8571429em;
  padding-inline-end: 1.1428571em;
  padding-bottom: 0.8571429em;
  padding-inline-start: 1.1428571em;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-weight: inherit;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *))::before{
  content: none;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *))::after{
  content: none;
}
.prose :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  width: 100%;
  table-layout: auto;
  text-align: start;
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: 0.875em;
  line-height: 1.7142857;
}
.prose :where(thead):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  border-bottom-width: 1px;
  border-bottom-color: var(--tw-prose-th-borders);
}
.prose :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-headings);
  font-weight: 600;
  vertical-align: bottom;
  padding-inline-end: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-inline-start: 0.5714286em;
}
.prose :where(tbody tr):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  border-bottom-width: 1px;
  border-bottom-color: var(--tw-prose-td-borders);
}
.prose :where(tbody tr:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  border-bottom-width: 0;
}
.prose :where(tbody td):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  vertical-align: baseline;
}
.prose :where(tfoot):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  border-top-width: 1px;
  border-top-color: var(--tw-prose-th-borders);
}
.prose :where(tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  vertical-align: top;
}
.prose :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
  margin-bottom: 0;
}
.prose :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-captions);
  font-size: 0.875em;
  line-height: 1.4285714;
  margin-top: 0.8571429em;
}
.prose{
  --tw-prose-body: #374151;
  --tw-prose-headings: #111827;
  --tw-prose-lead: #4b5563;
  --tw-prose-links: #111827;
  --tw-prose-bold: #111827;
  --tw-prose-counters: #6b7280;
  --tw-prose-bullets: #d1d5db;
  --tw-prose-hr: #e5e7eb;
  --tw-prose-quotes: #111827;
  --tw-prose-quote-borders: #e5e7eb;
  --tw-prose-captions: #6b7280;
  --tw-prose-kbd: #111827;
  --tw-prose-kbd-shadows: 17 24 39;
  --tw-prose-code: #111827;
  --tw-prose-pre-code: #e5e7eb;
  --tw-prose-pre-bg: #1f2937;
  --tw-prose-th-borders: #d1d5db;
  --tw-prose-td-borders: #e5e7eb;
  --tw-prose-invert-body: #d1d5db;
  --tw-prose-invert-headings: #fff;
  --tw-prose-invert-lead: #9ca3af;
  --tw-prose-invert-links: #fff;
  --tw-prose-invert-bold: #fff;
  --tw-prose-invert-counters: #9ca3af;
  --tw-prose-invert-bullets: #4b5563;
  --tw-prose-invert-hr: #374151;
  --tw-prose-invert-quotes: #f3f4f6;
  --tw-prose-invert-quote-borders: #374151;
  --tw-prose-invert-captions: #9ca3af;
  --tw-prose-invert-kbd: #fff;
  --tw-prose-invert-kbd-shadows: 255 255 255;
  --tw-prose-invert-code: #fff;
  --tw-prose-invert-pre-code: #d1d5db;
  --tw-prose-invert-pre-bg: rgb(0 0 0 / 50%);
  --tw-prose-invert-th-borders: #4b5563;
  --tw-prose-invert-td-borders: #374151;
  font-size: 1rem;
  line-height: 1.75;
}
.prose :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
  margin-bottom: 0;
}
.prose :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
.prose :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-inline-start: 0.375em;
}
.prose :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-inline-start: 0.375em;
}
.prose :where(.prose > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.prose :where(.prose > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.25em;
}
.prose :where(.prose > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-bottom: 1.25em;
}
.prose :where(.prose > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.25em;
}
.prose :where(.prose > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-bottom: 1.25em;
}
.prose :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.prose :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0.5em;
  padding-inline-start: 1.625em;
}
.prose :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-inline-start: 0;
}
.prose :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-inline-end: 0;
}
.prose :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-top: 0.5714286em;
  padding-inline-end: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-inline-start: 0.5714286em;
}
.prose :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-inline-start: 0;
}
.prose :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-inline-end: 0;
}
.prose :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(.prose > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose :where(.prose > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-bottom: 0;
}
.prose-sm{
  font-size: 0.875rem;
  line-height: 1.7142857;
}
.prose-sm :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
}
.prose-sm :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-size: 1.2857143em;
  line-height: 1.5555556;
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}
.prose-sm :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
  padding-inline-start: 1.1111111em;
}
.prose-sm :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-size: 2.1428571em;
  margin-top: 0;
  margin-bottom: 0.8em;
  line-height: 1.2;
}
.prose-sm :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-size: 1.4285714em;
  margin-top: 1.6em;
  margin-bottom: 0.8em;
  line-height: 1.4;
}
.prose-sm :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-size: 1.2857143em;
  margin-top: 1.5555556em;
  margin-bottom: 0.4444444em;
  line-height: 1.5555556;
}
.prose-sm :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.4285714em;
  margin-bottom: 0.5714286em;
  line-height: 1.4285714;
}
.prose-sm :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
  margin-bottom: 0;
}
.prose-sm :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-size: 0.8571429em;
  border-radius: 0.3125rem;
  padding-top: 0.1428571em;
  padding-inline-end: 0.3571429em;
  padding-bottom: 0.1428571em;
  padding-inline-start: 0.3571429em;
}
.prose-sm :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-size: 0.8571429em;
}
.prose-sm :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-size: 0.9em;
}
.prose-sm :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-size: 0.8888889em;
}
.prose-sm :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-size: 0.8571429em;
  line-height: 1.6666667;
  margin-top: 1.6666667em;
  margin-bottom: 1.6666667em;
  border-radius: 0.25rem;
  padding-top: 0.6666667em;
  padding-inline-end: 1em;
  padding-bottom: 0.6666667em;
  padding-inline-start: 1em;
}
.prose-sm :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
  padding-inline-start: 1.5714286em;
}
.prose-sm :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
  padding-inline-start: 1.5714286em;
}
.prose-sm :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0.2857143em;
  margin-bottom: 0.2857143em;
}
.prose-sm :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-inline-start: 0.4285714em;
}
.prose-sm :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-inline-start: 0.4285714em;
}
.prose-sm :where(.prose-sm > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0.5714286em;
  margin-bottom: 0.5714286em;
}
.prose-sm :where(.prose-sm > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.1428571em;
}
.prose-sm :where(.prose-sm > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-bottom: 1.1428571em;
}
.prose-sm :where(.prose-sm > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.1428571em;
}
.prose-sm :where(.prose-sm > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-bottom: 1.1428571em;
}
.prose-sm :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0.5714286em;
  margin-bottom: 0.5714286em;
}
.prose-sm :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
}
.prose-sm :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.1428571em;
}
.prose-sm :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0.2857143em;
  padding-inline-start: 1.5714286em;
}
.prose-sm :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 2.8571429em;
  margin-bottom: 2.8571429em;
}
.prose-sm :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose-sm :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose-sm :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose-sm :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose-sm :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-size: 0.8571429em;
  line-height: 1.5;
}
.prose-sm :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-inline-end: 1em;
  padding-bottom: 0.6666667em;
  padding-inline-start: 1em;
}
.prose-sm :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-inline-start: 0;
}
.prose-sm :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-inline-end: 0;
}
.prose-sm :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-top: 0.6666667em;
  padding-inline-end: 1em;
  padding-bottom: 0.6666667em;
  padding-inline-start: 1em;
}
.prose-sm :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-inline-start: 0;
}
.prose-sm :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-inline-end: 0;
}
.prose-sm :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
  margin-bottom: 0;
}
.prose-sm :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-size: 0.8571429em;
  line-height: 1.3333333;
  margin-top: 0.6666667em;
}
.prose-sm :where(.prose-sm > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose-sm :where(.prose-sm > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-bottom: 0;
}
.prose-slate{
  --tw-prose-body: #334155;
  --tw-prose-headings: #0f172a;
  --tw-prose-lead: #475569;
  --tw-prose-links: #0f172a;
  --tw-prose-bold: #0f172a;
  --tw-prose-counters: #64748b;
  --tw-prose-bullets: #cbd5e1;
  --tw-prose-hr: #e2e8f0;
  --tw-prose-quotes: #0f172a;
  --tw-prose-quote-borders: #e2e8f0;
  --tw-prose-captions: #64748b;
  --tw-prose-kbd: #0f172a;
  --tw-prose-kbd-shadows: 15 23 42;
  --tw-prose-code: #0f172a;
  --tw-prose-pre-code: #e2e8f0;
  --tw-prose-pre-bg: #1e293b;
  --tw-prose-th-borders: #cbd5e1;
  --tw-prose-td-borders: #e2e8f0;
  --tw-prose-invert-body: #cbd5e1;
  --tw-prose-invert-headings: #fff;
  --tw-prose-invert-lead: #94a3b8;
  --tw-prose-invert-links: #fff;
  --tw-prose-invert-bold: #fff;
  --tw-prose-invert-counters: #94a3b8;
  --tw-prose-invert-bullets: #475569;
  --tw-prose-invert-hr: #334155;
  --tw-prose-invert-quotes: #f1f5f9;
  --tw-prose-invert-quote-borders: #334155;
  --tw-prose-invert-captions: #94a3b8;
  --tw-prose-invert-kbd: #fff;
  --tw-prose-invert-kbd-shadows: 255 255 255;
  --tw-prose-invert-code: #fff;
  --tw-prose-invert-pre-code: #cbd5e1;
  --tw-prose-invert-pre-bg: rgb(0 0 0 / 50%);
  --tw-prose-invert-th-borders: #475569;
  --tw-prose-invert-td-borders: #334155;
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.not-sr-only{
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
.pointer-events-none{
  pointer-events: none;
}
.visible{
  visibility: visible;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-0\\.5{
  inset: 0.125rem;
}
.inset-5{
  inset: 1.25rem;
}
.inset-x-2{
  left: 0.5rem;
  right: 0.5rem;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.inset-y-2{
  top: 0.5rem;
  bottom: 0.5rem;
}
.-left-\\[100px\\]{
  left: -100px;
}
.-right-1{
  right: -0.25rem;
}
.-right-5{
  right: -1.25rem;
}
.-right-\\[200px\\]{
  right: -200px;
}
.-top-1{
  top: -0.25rem;
}
.-top-10{
  top: -2.5rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-20{
  bottom: 5rem;
}
.bottom-4{
  bottom: 1rem;
}
.left-0{
  left: 0px;
}
.left-4{
  left: 1rem;
}
.right-0{
  right: 0px;
}
.right-2{
  right: 0.5rem;
}
.right-4{
  right: 1rem;
}
.top-0{
  top: 0px;
}
.top-1\\/2{
  top: 50%;
}
.top-11{
  top: 2.75rem;
}
.top-2{
  top: 0.5rem;
}
.top-20{
  top: 5rem;
}
.top-4{
  top: 1rem;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.order-last{
  order: 9999;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-start-2{
  grid-column-start: 2;
}
.float-left{
  float: left;
}
.m-2{
  margin: 0.5rem;
}
.m-4{
  margin: 1rem;
}
.m-8{
  margin: 2rem;
}
.m-\\[5px\\]{
  margin: 5px;
}
.m-auto{
  margin: auto;
}
.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.\\!mb-2{
  margin-bottom: 0.5rem !important;
}
.\\!mt-0{
  margin-top: 0px !important;
}
.\\!mt-8{
  margin-top: 2rem !important;
}
.-mb-\\[17vh\\]{
  margin-bottom: -17vh;
}
.-ml-1{
  margin-left: -0.25rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.-mt-3{
  margin-top: -0.75rem;
}
.-mt-4{
  margin-top: -1rem;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-14{
  margin-bottom: 3.5rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-20{
  margin-bottom: 5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-\\[17vh\\]{
  margin-bottom: 17vh;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-8{
  margin-left: 2rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-0{
  margin-right: 0px;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-6{
  margin-right: 1.5rem;
}
.mr-auto{
  margin-right: auto;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-32{
  margin-top: 8rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.\\!hidden{
  display: none !important;
}
.hidden{
  display: none;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-1\\/3{
  height: 33.333333%;
}
.h-1\\/4{
  height: 25%;
}
.h-10{
  height: 2.5rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-2{
  height: 0.5rem;
}
.h-32{
  height: 8rem;
}
.h-36{
  height: 9rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-52{
  height: 13rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[111px\\]{
  height: 111px;
}
.h-\\[120px\\]{
  height: 120px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[44px\\]{
  height: 44px;
}
.h-\\[83\\.25px\\]{
  height: 83.25px;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.max-h-\\[600px\\]{
  max-height: 600px;
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-20{
  min-height: 5rem;
}
.min-h-32{
  min-height: 8rem;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1\\/12{
  width: 8.333333%;
}
.w-10{
  width: 2.5rem;
}
.w-10\\/12{
  width: 83.333333%;
}
.w-11{
  width: 2.75rem;
}
.w-11\\/12{
  width: 91.666667%;
}
.w-12{
  width: 3rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\/12{
  width: 16.666667%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-3\\/12{
  width: 25%;
}
.w-32{
  width: 8rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/12{
  width: 33.333333%;
}
.w-4\\/5{
  width: 80%;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-5\\/12{
  width: 41.666667%;
}
.w-6{
  width: 1.5rem;
}
.w-6\\/12{
  width: 50%;
}
.w-60{
  width: 15rem;
}
.w-7{
  width: 1.75rem;
}
.w-7\\/12{
  width: 58.333333%;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-8\\/12{
  width: 66.666667%;
}
.w-9{
  width: 2.25rem;
}
.w-9\\/12{
  width: 75%;
}
.w-\\[343px\\]{
  width: 343px;
}
.w-\\[392\\.25px\\]{
  width: 392.25px;
}
.w-\\[4\\.5rem\\]{
  width: 4.5rem;
}
.w-\\[44\\%\\]{
  width: 44%;
}
.w-\\[523px\\]{
  width: 523px;
}
.w-auto{
  width: auto;
}
.w-full{
  width: 100%;
}
.w-screen{
  width: 100vw;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.min-w-\\[3ch\\]{
  min-width: 3ch;
}
.min-w-full{
  min-width: 100%;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[10rem\\]{
  max-width: 10rem;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-fit{
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-prose{
  max-width: 65ch;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-auto{
  flex: 1 1 auto;
}
.flex-none{
  flex: none;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.flex-grow-0{
  flex-grow: 0;
}
.grow{
  flex-grow: 1;
}
.origin-bottom{
  transform-origin: bottom;
}
.origin-top-right{
  transform-origin: top right;
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), 0px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-full{
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), 100%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(180deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-125{
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.25) scaleY(1.25);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-150{
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.5) scaleY(1.5);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90{
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(.9) scaleY(.9);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(.95) scaleY(.95);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes currentWordOut{

  0%{
    transform: translateY(100%);
  }

  100%{
    transform: translateY(0);
  }
}
.animate-currentWordOut{
  animation: currentWordOut 1s forwards;
}
@keyframes fadeIn{

  0%{
    opacity: 0;
  }

  100%{
    opacity: 1;
  }
}
.animate-fadeIn{
  animation: fadeIn 300ms ease-in-out forwards;
}
@keyframes fadeOut{

  0%{
    opacity: 1;
  }

  100%{
    opacity: 0;
  }
}
.animate-fadeOut{
  animation: fadeOut 300ms ease-in-out forwards;
}
@keyframes nextWordIn{

  0%{
    transform: translateY(0);
  }

  100%{
    transform: translateY(-100%);
  }
}
.animate-nextWordIn{
  animation: nextWordIn 1s forwards;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.select-none{
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.resize{
  resize: both;
}
.list-inside{
  list-style-position: inside;
}
.list-outside{
  list-style-position: outside;
}
.list-disc{
  list-style-type: disc;
}
.appearance-none{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.grid-flow-row{
  grid-auto-flow: row;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-8{
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.place-content-between{
  place-content: space-between;
}
.place-content-around{
  place-content: space-around;
}
.place-items-center{
  place-items: center;
}
.content-center{
  align-content: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-items-start{
  justify-items: start;
}
.justify-items-center{
  justify-items: center;
}
.justify-items-stretch{
  justify-items: stretch;
}
.gap-0{
  gap: 0px;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-4{
  gap: 1rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-x-2{
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.space-x-0 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0px * 0);
  margin-right: calc(0px * var(--tw-space-x-reverse));
  margin-left: calc(0px * calc(1 - 0));
  margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * 0);
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - 0));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * 0);
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - 0));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * 0);
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - 0));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * 0);
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - 0));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - 0));
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * 0);
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - 0));
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * 0);
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - 0));
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * 0);
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - 0));
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * 0);
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - 0));
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * 0);
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.space-y-reverse > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 1;
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - 0));
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * 0);
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.place-self-center{
  place-self: center;
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.justify-self-start{
  justify-self: start;
}
.justify-self-end{
  justify-self: end;
}
.justify-self-center{
  justify-self: center;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.overflow-ellipsis{
  text-overflow: ellipsis;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre{
  white-space: pre;
}
.break-words{
  overflow-wrap: break-word;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-r{
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-bl-md{
  border-bottom-left-radius: 0.375rem;
}
.rounded-br-md{
  border-bottom-right-radius: 0.375rem;
}
.rounded-tl-md{
  border-top-left-radius: 0.375rem;
}
.rounded-tr-md{
  border-top-right-radius: 0.375rem;
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-8{
  border-width: 8px;
}
.border-\\[0\\.5px\\]{
  border-width: 0.5px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-r-0{
  border-right-width: 0px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.border-amber-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-amber-100{
    border-color: rgb(254 243 199 / var(--tw-border-opacity));
  }
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-amber-200{
    border-color: rgb(253 230 138 / var(--tw-border-opacity));
  }
}
.border-amber-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-amber-300{
    border-color: rgb(252 211 77 / var(--tw-border-opacity));
  }
}
.border-amber-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-amber-400{
    border-color: rgb(251 191 36 / var(--tw-border-opacity));
  }
}
.border-amber-50{
  --tw-border-opacity: 1;
  border-color: rgb(255 251 235 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-amber-50{
    border-color: rgb(255 251 235 / var(--tw-border-opacity));
  }
}
.border-amber-500{
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-amber-500{
    border-color: rgb(245 158 11 / var(--tw-border-opacity));
  }
}
.border-amber-600{
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-amber-600{
    border-color: rgb(217 119 6 / var(--tw-border-opacity));
  }
}
.border-amber-700{
  --tw-border-opacity: 1;
  border-color: rgb(180 83 9 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-amber-700{
    border-color: rgb(180 83 9 / var(--tw-border-opacity));
  }
}
.border-amber-800{
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-amber-800{
    border-color: rgb(146 64 14 / var(--tw-border-opacity));
  }
}
.border-amber-900{
  --tw-border-opacity: 1;
  border-color: rgb(120 53 15 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-amber-900{
    border-color: rgb(120 53 15 / var(--tw-border-opacity));
  }
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-black{
    border-color: rgb(0 0 0 / var(--tw-border-opacity));
  }
}
.border-blue-100{
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-blue-100{
    border-color: rgb(219 234 254 / var(--tw-border-opacity));
  }
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-blue-200{
    border-color: rgb(191 219 254 / var(--tw-border-opacity));
  }
}
.border-blue-300{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-blue-300{
    border-color: rgb(147 197 253 / var(--tw-border-opacity));
  }
}
.border-blue-400{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-blue-400{
    border-color: rgb(96 165 250 / var(--tw-border-opacity));
  }
}
.border-blue-50{
  --tw-border-opacity: 1;
  border-color: rgb(239 246 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-blue-50{
    border-color: rgb(239 246 255 / var(--tw-border-opacity));
  }
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-blue-500{
    border-color: rgb(59 130 246 / var(--tw-border-opacity));
  }
}
.border-blue-600{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-blue-600{
    border-color: rgb(37 99 235 / var(--tw-border-opacity));
  }
}
.border-blue-700{
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-blue-700{
    border-color: rgb(29 78 216 / var(--tw-border-opacity));
  }
}
.border-blue-800{
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-blue-800{
    border-color: rgb(30 64 175 / var(--tw-border-opacity));
  }
}
.border-blue-900{
  --tw-border-opacity: 1;
  border-color: rgb(30 58 138 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-blue-900{
    border-color: rgb(30 58 138 / var(--tw-border-opacity));
  }
}
.border-current{
  border-color: currentColor;
}
.border-cyan-100{
  --tw-border-opacity: 1;
  border-color: rgb(207 250 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-cyan-100{
    border-color: rgb(207 250 254 / var(--tw-border-opacity));
  }
}
.border-cyan-200{
  --tw-border-opacity: 1;
  border-color: rgb(165 243 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-cyan-200{
    border-color: rgb(165 243 252 / var(--tw-border-opacity));
  }
}
.border-cyan-300{
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-cyan-300{
    border-color: rgb(103 232 249 / var(--tw-border-opacity));
  }
}
.border-cyan-400{
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-cyan-400{
    border-color: rgb(34 211 238 / var(--tw-border-opacity));
  }
}
.border-cyan-50{
  --tw-border-opacity: 1;
  border-color: rgb(236 254 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-cyan-50{
    border-color: rgb(236 254 255 / var(--tw-border-opacity));
  }
}
.border-cyan-500{
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-cyan-500{
    border-color: rgb(6 182 212 / var(--tw-border-opacity));
  }
}
.border-cyan-600{
  --tw-border-opacity: 1;
  border-color: rgb(8 145 178 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-cyan-600{
    border-color: rgb(8 145 178 / var(--tw-border-opacity));
  }
}
.border-cyan-700{
  --tw-border-opacity: 1;
  border-color: rgb(14 116 144 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-cyan-700{
    border-color: rgb(14 116 144 / var(--tw-border-opacity));
  }
}
.border-cyan-800{
  --tw-border-opacity: 1;
  border-color: rgb(21 94 117 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-cyan-800{
    border-color: rgb(21 94 117 / var(--tw-border-opacity));
  }
}
.border-cyan-900{
  --tw-border-opacity: 1;
  border-color: rgb(22 78 99 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-cyan-900{
    border-color: rgb(22 78 99 / var(--tw-border-opacity));
  }
}
.border-emerald-100{
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-emerald-100{
    border-color: rgb(209 250 229 / var(--tw-border-opacity));
  }
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-emerald-200{
    border-color: rgb(167 243 208 / var(--tw-border-opacity));
  }
}
.border-emerald-300{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-emerald-300{
    border-color: rgb(110 231 183 / var(--tw-border-opacity));
  }
}
.border-emerald-400{
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-emerald-400{
    border-color: rgb(52 211 153 / var(--tw-border-opacity));
  }
}
.border-emerald-50{
  --tw-border-opacity: 1;
  border-color: rgb(236 253 245 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-emerald-50{
    border-color: rgb(236 253 245 / var(--tw-border-opacity));
  }
}
.border-emerald-500{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-emerald-500{
    border-color: rgb(16 185 129 / var(--tw-border-opacity));
  }
}
.border-emerald-600{
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-emerald-600{
    border-color: rgb(5 150 105 / var(--tw-border-opacity));
  }
}
.border-emerald-700{
  --tw-border-opacity: 1;
  border-color: rgb(4 120 87 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-emerald-700{
    border-color: rgb(4 120 87 / var(--tw-border-opacity));
  }
}
.border-emerald-800{
  --tw-border-opacity: 1;
  border-color: rgb(6 95 70 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-emerald-800{
    border-color: rgb(6 95 70 / var(--tw-border-opacity));
  }
}
.border-emerald-900{
  --tw-border-opacity: 1;
  border-color: rgb(6 78 59 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-emerald-900{
    border-color: rgb(6 78 59 / var(--tw-border-opacity));
  }
}
.border-fuchsia-100{
  --tw-border-opacity: 1;
  border-color: rgb(250 232 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-fuchsia-100{
    border-color: rgb(250 232 255 / var(--tw-border-opacity));
  }
}
.border-fuchsia-200{
  --tw-border-opacity: 1;
  border-color: rgb(245 208 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-fuchsia-200{
    border-color: rgb(245 208 254 / var(--tw-border-opacity));
  }
}
.border-fuchsia-300{
  --tw-border-opacity: 1;
  border-color: rgb(240 171 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-fuchsia-300{
    border-color: rgb(240 171 252 / var(--tw-border-opacity));
  }
}
.border-fuchsia-400{
  --tw-border-opacity: 1;
  border-color: rgb(232 121 249 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-fuchsia-400{
    border-color: rgb(232 121 249 / var(--tw-border-opacity));
  }
}
.border-fuchsia-50{
  --tw-border-opacity: 1;
  border-color: rgb(253 244 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-fuchsia-50{
    border-color: rgb(253 244 255 / var(--tw-border-opacity));
  }
}
.border-fuchsia-500{
  --tw-border-opacity: 1;
  border-color: rgb(217 70 239 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-fuchsia-500{
    border-color: rgb(217 70 239 / var(--tw-border-opacity));
  }
}
.border-fuchsia-600{
  --tw-border-opacity: 1;
  border-color: rgb(192 38 211 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-fuchsia-600{
    border-color: rgb(192 38 211 / var(--tw-border-opacity));
  }
}
.border-fuchsia-700{
  --tw-border-opacity: 1;
  border-color: rgb(162 28 175 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-fuchsia-700{
    border-color: rgb(162 28 175 / var(--tw-border-opacity));
  }
}
.border-fuchsia-800{
  --tw-border-opacity: 1;
  border-color: rgb(134 25 143 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-fuchsia-800{
    border-color: rgb(134 25 143 / var(--tw-border-opacity));
  }
}
.border-fuchsia-900{
  --tw-border-opacity: 1;
  border-color: rgb(112 26 117 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-fuchsia-900{
    border-color: rgb(112 26 117 / var(--tw-border-opacity));
  }
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-gray-100{
    border-color: rgb(243 244 246 / var(--tw-border-opacity));
  }
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-gray-200{
    border-color: rgb(229 231 235 / var(--tw-border-opacity));
  }
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-gray-300{
    border-color: rgb(209 213 219 / var(--tw-border-opacity));
  }
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-gray-400{
    border-color: rgb(156 163 175 / var(--tw-border-opacity));
  }
}
.border-gray-50{
  --tw-border-opacity: 1;
  border-color: rgb(249 250 251 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-gray-50{
    border-color: rgb(249 250 251 / var(--tw-border-opacity));
  }
}
.border-gray-500{
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-gray-500{
    border-color: rgb(107 114 128 / var(--tw-border-opacity));
  }
}
.border-gray-600{
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-gray-600{
    border-color: rgb(75 85 99 / var(--tw-border-opacity));
  }
}
.border-gray-700{
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-gray-700{
    border-color: rgb(55 65 81 / var(--tw-border-opacity));
  }
}
.border-gray-800{
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-gray-800{
    border-color: rgb(31 41 55 / var(--tw-border-opacity));
  }
}
.border-gray-900{
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-gray-900{
    border-color: rgb(17 24 39 / var(--tw-border-opacity));
  }
}
.border-green-100{
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-green-100{
    border-color: rgb(220 252 231 / var(--tw-border-opacity));
  }
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-green-200{
    border-color: rgb(187 247 208 / var(--tw-border-opacity));
  }
}
.border-green-300{
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-green-300{
    border-color: rgb(134 239 172 / var(--tw-border-opacity));
  }
}
.border-green-400{
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-green-400{
    border-color: rgb(74 222 128 / var(--tw-border-opacity));
  }
}
.border-green-50{
  --tw-border-opacity: 1;
  border-color: rgb(240 253 244 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-green-50{
    border-color: rgb(240 253 244 / var(--tw-border-opacity));
  }
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-green-500{
    border-color: rgb(34 197 94 / var(--tw-border-opacity));
  }
}
.border-green-600{
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-green-600{
    border-color: rgb(22 163 74 / var(--tw-border-opacity));
  }
}
.border-green-700{
  --tw-border-opacity: 1;
  border-color: rgb(21 128 61 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-green-700{
    border-color: rgb(21 128 61 / var(--tw-border-opacity));
  }
}
.border-green-800{
  --tw-border-opacity: 1;
  border-color: rgb(22 101 52 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-green-800{
    border-color: rgb(22 101 52 / var(--tw-border-opacity));
  }
}
.border-green-900{
  --tw-border-opacity: 1;
  border-color: rgb(20 83 45 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-green-900{
    border-color: rgb(20 83 45 / var(--tw-border-opacity));
  }
}
.border-indigo-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-indigo-100{
    border-color: rgb(224 231 255 / var(--tw-border-opacity));
  }
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-indigo-200{
    border-color: rgb(199 210 254 / var(--tw-border-opacity));
  }
}
.border-indigo-300{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-indigo-300{
    border-color: rgb(165 180 252 / var(--tw-border-opacity));
  }
}
.border-indigo-400{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-indigo-400{
    border-color: rgb(129 140 248 / var(--tw-border-opacity));
  }
}
.border-indigo-50{
  --tw-border-opacity: 1;
  border-color: rgb(238 242 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-indigo-50{
    border-color: rgb(238 242 255 / var(--tw-border-opacity));
  }
}
.border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-indigo-500{
    border-color: rgb(99 102 241 / var(--tw-border-opacity));
  }
}
.border-indigo-600{
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-indigo-600{
    border-color: rgb(79 70 229 / var(--tw-border-opacity));
  }
}
.border-indigo-700{
  --tw-border-opacity: 1;
  border-color: rgb(67 56 202 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-indigo-700{
    border-color: rgb(67 56 202 / var(--tw-border-opacity));
  }
}
.border-indigo-800{
  --tw-border-opacity: 1;
  border-color: rgb(55 48 163 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-indigo-800{
    border-color: rgb(55 48 163 / var(--tw-border-opacity));
  }
}
.border-indigo-900{
  --tw-border-opacity: 1;
  border-color: rgb(49 46 129 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-indigo-900{
    border-color: rgb(49 46 129 / var(--tw-border-opacity));
  }
}
.border-inherit{
  border-color: inherit;
}
.border-lime-100{
  --tw-border-opacity: 1;
  border-color: rgb(236 252 203 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-lime-100{
    border-color: rgb(236 252 203 / var(--tw-border-opacity));
  }
}
.border-lime-200{
  --tw-border-opacity: 1;
  border-color: rgb(217 249 157 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-lime-200{
    border-color: rgb(217 249 157 / var(--tw-border-opacity));
  }
}
.border-lime-300{
  --tw-border-opacity: 1;
  border-color: rgb(190 242 100 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-lime-300{
    border-color: rgb(190 242 100 / var(--tw-border-opacity));
  }
}
.border-lime-400{
  --tw-border-opacity: 1;
  border-color: rgb(163 230 53 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-lime-400{
    border-color: rgb(163 230 53 / var(--tw-border-opacity));
  }
}
.border-lime-50{
  --tw-border-opacity: 1;
  border-color: rgb(247 254 231 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-lime-50{
    border-color: rgb(247 254 231 / var(--tw-border-opacity));
  }
}
.border-lime-500{
  --tw-border-opacity: 1;
  border-color: rgb(132 204 22 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-lime-500{
    border-color: rgb(132 204 22 / var(--tw-border-opacity));
  }
}
.border-lime-600{
  --tw-border-opacity: 1;
  border-color: rgb(101 163 13 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-lime-600{
    border-color: rgb(101 163 13 / var(--tw-border-opacity));
  }
}
.border-lime-700{
  --tw-border-opacity: 1;
  border-color: rgb(77 124 15 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-lime-700{
    border-color: rgb(77 124 15 / var(--tw-border-opacity));
  }
}
.border-lime-800{
  --tw-border-opacity: 1;
  border-color: rgb(63 98 18 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-lime-800{
    border-color: rgb(63 98 18 / var(--tw-border-opacity));
  }
}
.border-lime-900{
  --tw-border-opacity: 1;
  border-color: rgb(54 83 20 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-lime-900{
    border-color: rgb(54 83 20 / var(--tw-border-opacity));
  }
}
.border-neutral-100{
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-neutral-100{
    border-color: rgb(245 245 245 / var(--tw-border-opacity));
  }
}
.border-neutral-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 229 229 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-neutral-200{
    border-color: rgb(229 229 229 / var(--tw-border-opacity));
  }
}
.border-neutral-300{
  --tw-border-opacity: 1;
  border-color: rgb(212 212 212 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-neutral-300{
    border-color: rgb(212 212 212 / var(--tw-border-opacity));
  }
}
.border-neutral-400{
  --tw-border-opacity: 1;
  border-color: rgb(163 163 163 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-neutral-400{
    border-color: rgb(163 163 163 / var(--tw-border-opacity));
  }
}
.border-neutral-50{
  --tw-border-opacity: 1;
  border-color: rgb(250 250 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-neutral-50{
    border-color: rgb(250 250 250 / var(--tw-border-opacity));
  }
}
.border-neutral-500{
  --tw-border-opacity: 1;
  border-color: rgb(115 115 115 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-neutral-500{
    border-color: rgb(115 115 115 / var(--tw-border-opacity));
  }
}
.border-neutral-600{
  --tw-border-opacity: 1;
  border-color: rgb(82 82 82 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-neutral-600{
    border-color: rgb(82 82 82 / var(--tw-border-opacity));
  }
}
.border-neutral-700{
  --tw-border-opacity: 1;
  border-color: rgb(64 64 64 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-neutral-700{
    border-color: rgb(64 64 64 / var(--tw-border-opacity));
  }
}
.border-neutral-800{
  --tw-border-opacity: 1;
  border-color: rgb(38 38 38 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-neutral-800{
    border-color: rgb(38 38 38 / var(--tw-border-opacity));
  }
}
.border-neutral-900{
  --tw-border-opacity: 1;
  border-color: rgb(23 23 23 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-neutral-900{
    border-color: rgb(23 23 23 / var(--tw-border-opacity));
  }
}
.border-orange-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-orange-100{
    border-color: rgb(255 237 213 / var(--tw-border-opacity));
  }
}
.border-orange-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-orange-200{
    border-color: rgb(254 215 170 / var(--tw-border-opacity));
  }
}
.border-orange-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-orange-300{
    border-color: rgb(253 186 116 / var(--tw-border-opacity));
  }
}
.border-orange-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-orange-400{
    border-color: rgb(251 146 60 / var(--tw-border-opacity));
  }
}
.border-orange-50{
  --tw-border-opacity: 1;
  border-color: rgb(255 247 237 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-orange-50{
    border-color: rgb(255 247 237 / var(--tw-border-opacity));
  }
}
.border-orange-500{
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-orange-500{
    border-color: rgb(249 115 22 / var(--tw-border-opacity));
  }
}
.border-orange-600{
  --tw-border-opacity: 1;
  border-color: rgb(234 88 12 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-orange-600{
    border-color: rgb(234 88 12 / var(--tw-border-opacity));
  }
}
.border-orange-700{
  --tw-border-opacity: 1;
  border-color: rgb(194 65 12 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-orange-700{
    border-color: rgb(194 65 12 / var(--tw-border-opacity));
  }
}
.border-orange-800{
  --tw-border-opacity: 1;
  border-color: rgb(154 52 18 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-orange-800{
    border-color: rgb(154 52 18 / var(--tw-border-opacity));
  }
}
.border-orange-900{
  --tw-border-opacity: 1;
  border-color: rgb(124 45 18 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-orange-900{
    border-color: rgb(124 45 18 / var(--tw-border-opacity));
  }
}
.border-pink-100{
  --tw-border-opacity: 1;
  border-color: rgb(252 231 243 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-pink-100{
    border-color: rgb(252 231 243 / var(--tw-border-opacity));
  }
}
.border-pink-200{
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-pink-200{
    border-color: rgb(251 207 232 / var(--tw-border-opacity));
  }
}
.border-pink-300{
  --tw-border-opacity: 1;
  border-color: rgb(249 168 212 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-pink-300{
    border-color: rgb(249 168 212 / var(--tw-border-opacity));
  }
}
.border-pink-400{
  --tw-border-opacity: 1;
  border-color: rgb(244 114 182 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-pink-400{
    border-color: rgb(244 114 182 / var(--tw-border-opacity));
  }
}
.border-pink-50{
  --tw-border-opacity: 1;
  border-color: rgb(253 242 248 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-pink-50{
    border-color: rgb(253 242 248 / var(--tw-border-opacity));
  }
}
.border-pink-500{
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-pink-500{
    border-color: rgb(236 72 153 / var(--tw-border-opacity));
  }
}
.border-pink-600{
  --tw-border-opacity: 1;
  border-color: rgb(219 39 119 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-pink-600{
    border-color: rgb(219 39 119 / var(--tw-border-opacity));
  }
}
.border-pink-700{
  --tw-border-opacity: 1;
  border-color: rgb(190 24 93 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-pink-700{
    border-color: rgb(190 24 93 / var(--tw-border-opacity));
  }
}
.border-pink-800{
  --tw-border-opacity: 1;
  border-color: rgb(157 23 77 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-pink-800{
    border-color: rgb(157 23 77 / var(--tw-border-opacity));
  }
}
.border-pink-900{
  --tw-border-opacity: 1;
  border-color: rgb(131 24 67 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-pink-900{
    border-color: rgb(131 24 67 / var(--tw-border-opacity));
  }
}
.border-purple-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-purple-100{
    border-color: rgb(243 232 255 / var(--tw-border-opacity));
  }
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-purple-200{
    border-color: rgb(233 213 255 / var(--tw-border-opacity));
  }
}
.border-purple-300{
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-purple-300{
    border-color: rgb(216 180 254 / var(--tw-border-opacity));
  }
}
.border-purple-400{
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-purple-400{
    border-color: rgb(192 132 252 / var(--tw-border-opacity));
  }
}
.border-purple-50{
  --tw-border-opacity: 1;
  border-color: rgb(250 245 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-purple-50{
    border-color: rgb(250 245 255 / var(--tw-border-opacity));
  }
}
.border-purple-500{
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-purple-500{
    border-color: rgb(168 85 247 / var(--tw-border-opacity));
  }
}
.border-purple-600{
  --tw-border-opacity: 1;
  border-color: rgb(147 51 234 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-purple-600{
    border-color: rgb(147 51 234 / var(--tw-border-opacity));
  }
}
.border-purple-700{
  --tw-border-opacity: 1;
  border-color: rgb(126 34 206 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-purple-700{
    border-color: rgb(126 34 206 / var(--tw-border-opacity));
  }
}
.border-purple-800{
  --tw-border-opacity: 1;
  border-color: rgb(107 33 168 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-purple-800{
    border-color: rgb(107 33 168 / var(--tw-border-opacity));
  }
}
.border-purple-900{
  --tw-border-opacity: 1;
  border-color: rgb(88 28 135 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-purple-900{
    border-color: rgb(88 28 135 / var(--tw-border-opacity));
  }
}
.border-red-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-red-100{
    border-color: rgb(254 226 226 / var(--tw-border-opacity));
  }
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-red-200{
    border-color: rgb(254 202 202 / var(--tw-border-opacity));
  }
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-red-300{
    border-color: rgb(252 165 165 / var(--tw-border-opacity));
  }
}
.border-red-400{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-red-400{
    border-color: rgb(248 113 113 / var(--tw-border-opacity));
  }
}
.border-red-50{
  --tw-border-opacity: 1;
  border-color: rgb(254 242 242 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-red-50{
    border-color: rgb(254 242 242 / var(--tw-border-opacity));
  }
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-red-500{
    border-color: rgb(239 68 68 / var(--tw-border-opacity));
  }
}
.border-red-600{
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-red-600{
    border-color: rgb(220 38 38 / var(--tw-border-opacity));
  }
}
.border-red-700{
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-red-700{
    border-color: rgb(185 28 28 / var(--tw-border-opacity));
  }
}
.border-red-800{
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-red-800{
    border-color: rgb(153 27 27 / var(--tw-border-opacity));
  }
}
.border-red-900{
  --tw-border-opacity: 1;
  border-color: rgb(127 29 29 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-red-900{
    border-color: rgb(127 29 29 / var(--tw-border-opacity));
  }
}
.border-rose-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-rose-100{
    border-color: rgb(255 228 230 / var(--tw-border-opacity));
  }
}
.border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-rose-200{
    border-color: rgb(254 205 211 / var(--tw-border-opacity));
  }
}
.border-rose-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-rose-300{
    border-color: rgb(253 164 175 / var(--tw-border-opacity));
  }
}
.border-rose-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 113 133 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-rose-400{
    border-color: rgb(251 113 133 / var(--tw-border-opacity));
  }
}
.border-rose-50{
  --tw-border-opacity: 1;
  border-color: rgb(255 241 242 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-rose-50{
    border-color: rgb(255 241 242 / var(--tw-border-opacity));
  }
}
.border-rose-500{
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-rose-500{
    border-color: rgb(244 63 94 / var(--tw-border-opacity));
  }
}
.border-rose-600{
  --tw-border-opacity: 1;
  border-color: rgb(225 29 72 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-rose-600{
    border-color: rgb(225 29 72 / var(--tw-border-opacity));
  }
}
.border-rose-700{
  --tw-border-opacity: 1;
  border-color: rgb(190 18 60 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-rose-700{
    border-color: rgb(190 18 60 / var(--tw-border-opacity));
  }
}
.border-rose-800{
  --tw-border-opacity: 1;
  border-color: rgb(159 18 57 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-rose-800{
    border-color: rgb(159 18 57 / var(--tw-border-opacity));
  }
}
.border-rose-900{
  --tw-border-opacity: 1;
  border-color: rgb(136 19 55 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-rose-900{
    border-color: rgb(136 19 55 / var(--tw-border-opacity));
  }
}
.border-sky-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-sky-100{
    border-color: rgb(224 242 254 / var(--tw-border-opacity));
  }
}
.border-sky-200{
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-sky-200{
    border-color: rgb(186 230 253 / var(--tw-border-opacity));
  }
}
.border-sky-300{
  --tw-border-opacity: 1;
  border-color: rgb(125 211 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-sky-300{
    border-color: rgb(125 211 252 / var(--tw-border-opacity));
  }
}
.border-sky-400{
  --tw-border-opacity: 1;
  border-color: rgb(56 189 248 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-sky-400{
    border-color: rgb(56 189 248 / var(--tw-border-opacity));
  }
}
.border-sky-50{
  --tw-border-opacity: 1;
  border-color: rgb(240 249 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-sky-50{
    border-color: rgb(240 249 255 / var(--tw-border-opacity));
  }
}
.border-sky-500{
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-sky-500{
    border-color: rgb(14 165 233 / var(--tw-border-opacity));
  }
}
.border-sky-600{
  --tw-border-opacity: 1;
  border-color: rgb(2 132 199 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-sky-600{
    border-color: rgb(2 132 199 / var(--tw-border-opacity));
  }
}
.border-sky-700{
  --tw-border-opacity: 1;
  border-color: rgb(3 105 161 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-sky-700{
    border-color: rgb(3 105 161 / var(--tw-border-opacity));
  }
}
.border-sky-800{
  --tw-border-opacity: 1;
  border-color: rgb(7 89 133 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-sky-800{
    border-color: rgb(7 89 133 / var(--tw-border-opacity));
  }
}
.border-sky-900{
  --tw-border-opacity: 1;
  border-color: rgb(12 74 110 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-sky-900{
    border-color: rgb(12 74 110 / var(--tw-border-opacity));
  }
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-slate-100{
    border-color: rgb(241 245 249 / var(--tw-border-opacity));
  }
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-slate-200{
    border-color: rgb(226 232 240 / var(--tw-border-opacity));
  }
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-slate-300{
    border-color: rgb(203 213 225 / var(--tw-border-opacity));
  }
}
.border-slate-400{
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-slate-400{
    border-color: rgb(148 163 184 / var(--tw-border-opacity));
  }
}
.border-slate-50{
  --tw-border-opacity: 1;
  border-color: rgb(248 250 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-slate-50{
    border-color: rgb(248 250 252 / var(--tw-border-opacity));
  }
}
.border-slate-500{
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-slate-500{
    border-color: rgb(100 116 139 / var(--tw-border-opacity));
  }
}
.border-slate-600{
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-slate-600{
    border-color: rgb(71 85 105 / var(--tw-border-opacity));
  }
}
.border-slate-700{
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-slate-700{
    border-color: rgb(51 65 85 / var(--tw-border-opacity));
  }
}
.border-slate-800{
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-slate-800{
    border-color: rgb(30 41 59 / var(--tw-border-opacity));
  }
}
.border-slate-900{
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-slate-900{
    border-color: rgb(15 23 42 / var(--tw-border-opacity));
  }
}
.border-stone-100{
  --tw-border-opacity: 1;
  border-color: rgb(245 245 244 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-stone-100{
    border-color: rgb(245 245 244 / var(--tw-border-opacity));
  }
}
.border-stone-200{
  --tw-border-opacity: 1;
  border-color: rgb(231 229 228 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-stone-200{
    border-color: rgb(231 229 228 / var(--tw-border-opacity));
  }
}
.border-stone-300{
  --tw-border-opacity: 1;
  border-color: rgb(214 211 209 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-stone-300{
    border-color: rgb(214 211 209 / var(--tw-border-opacity));
  }
}
.border-stone-400{
  --tw-border-opacity: 1;
  border-color: rgb(168 162 158 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-stone-400{
    border-color: rgb(168 162 158 / var(--tw-border-opacity));
  }
}
.border-stone-50{
  --tw-border-opacity: 1;
  border-color: rgb(250 250 249 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-stone-50{
    border-color: rgb(250 250 249 / var(--tw-border-opacity));
  }
}
.border-stone-500{
  --tw-border-opacity: 1;
  border-color: rgb(120 113 108 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-stone-500{
    border-color: rgb(120 113 108 / var(--tw-border-opacity));
  }
}
.border-stone-600{
  --tw-border-opacity: 1;
  border-color: rgb(87 83 78 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-stone-600{
    border-color: rgb(87 83 78 / var(--tw-border-opacity));
  }
}
.border-stone-700{
  --tw-border-opacity: 1;
  border-color: rgb(68 64 60 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-stone-700{
    border-color: rgb(68 64 60 / var(--tw-border-opacity));
  }
}
.border-stone-800{
  --tw-border-opacity: 1;
  border-color: rgb(41 37 36 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-stone-800{
    border-color: rgb(41 37 36 / var(--tw-border-opacity));
  }
}
.border-stone-900{
  --tw-border-opacity: 1;
  border-color: rgb(28 25 23 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-stone-900{
    border-color: rgb(28 25 23 / var(--tw-border-opacity));
  }
}
.border-teal-100{
  --tw-border-opacity: 1;
  border-color: rgb(204 251 241 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-teal-100{
    border-color: rgb(204 251 241 / var(--tw-border-opacity));
  }
}
.border-teal-200{
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-teal-200{
    border-color: rgb(153 246 228 / var(--tw-border-opacity));
  }
}
.border-teal-300{
  --tw-border-opacity: 1;
  border-color: rgb(94 234 212 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-teal-300{
    border-color: rgb(94 234 212 / var(--tw-border-opacity));
  }
}
.border-teal-400{
  --tw-border-opacity: 1;
  border-color: rgb(45 212 191 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-teal-400{
    border-color: rgb(45 212 191 / var(--tw-border-opacity));
  }
}
.border-teal-50{
  --tw-border-opacity: 1;
  border-color: rgb(240 253 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-teal-50{
    border-color: rgb(240 253 250 / var(--tw-border-opacity));
  }
}
.border-teal-500{
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-teal-500{
    border-color: rgb(20 184 166 / var(--tw-border-opacity));
  }
}
.border-teal-600{
  --tw-border-opacity: 1;
  border-color: rgb(13 148 136 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-teal-600{
    border-color: rgb(13 148 136 / var(--tw-border-opacity));
  }
}
.border-teal-700{
  --tw-border-opacity: 1;
  border-color: rgb(15 118 110 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-teal-700{
    border-color: rgb(15 118 110 / var(--tw-border-opacity));
  }
}
.border-teal-800{
  --tw-border-opacity: 1;
  border-color: rgb(17 94 89 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-teal-800{
    border-color: rgb(17 94 89 / var(--tw-border-opacity));
  }
}
.border-teal-900{
  --tw-border-opacity: 1;
  border-color: rgb(19 78 74 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-teal-900{
    border-color: rgb(19 78 74 / var(--tw-border-opacity));
  }
}
.border-transparent{
  border-color: transparent;
}
.border-violet-100{
  --tw-border-opacity: 1;
  border-color: rgb(237 233 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-violet-100{
    border-color: rgb(237 233 254 / var(--tw-border-opacity));
  }
}
.border-violet-200{
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-violet-200{
    border-color: rgb(221 214 254 / var(--tw-border-opacity));
  }
}
.border-violet-300{
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-violet-300{
    border-color: rgb(196 181 253 / var(--tw-border-opacity));
  }
}
.border-violet-400{
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-violet-400{
    border-color: rgb(167 139 250 / var(--tw-border-opacity));
  }
}
.border-violet-50{
  --tw-border-opacity: 1;
  border-color: rgb(245 243 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-violet-50{
    border-color: rgb(245 243 255 / var(--tw-border-opacity));
  }
}
.border-violet-500{
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-violet-500{
    border-color: rgb(139 92 246 / var(--tw-border-opacity));
  }
}
.border-violet-600{
  --tw-border-opacity: 1;
  border-color: rgb(124 58 237 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-violet-600{
    border-color: rgb(124 58 237 / var(--tw-border-opacity));
  }
}
.border-violet-700{
  --tw-border-opacity: 1;
  border-color: rgb(109 40 217 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-violet-700{
    border-color: rgb(109 40 217 / var(--tw-border-opacity));
  }
}
.border-violet-800{
  --tw-border-opacity: 1;
  border-color: rgb(91 33 182 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-violet-800{
    border-color: rgb(91 33 182 / var(--tw-border-opacity));
  }
}
.border-violet-900{
  --tw-border-opacity: 1;
  border-color: rgb(76 29 149 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-violet-900{
    border-color: rgb(76 29 149 / var(--tw-border-opacity));
  }
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-white{
    border-color: rgb(255 255 255 / var(--tw-border-opacity));
  }
}
.border-yellow-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 249 195 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-yellow-100{
    border-color: rgb(254 249 195 / var(--tw-border-opacity));
  }
}
.border-yellow-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-yellow-200{
    border-color: rgb(254 240 138 / var(--tw-border-opacity));
  }
}
.border-yellow-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-yellow-300{
    border-color: rgb(253 224 71 / var(--tw-border-opacity));
  }
}
.border-yellow-400{
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-yellow-400{
    border-color: rgb(250 204 21 / var(--tw-border-opacity));
  }
}
.border-yellow-50{
  --tw-border-opacity: 1;
  border-color: rgb(254 252 232 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-yellow-50{
    border-color: rgb(254 252 232 / var(--tw-border-opacity));
  }
}
.border-yellow-500{
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-yellow-500{
    border-color: rgb(234 179 8 / var(--tw-border-opacity));
  }
}
.border-yellow-600{
  --tw-border-opacity: 1;
  border-color: rgb(202 138 4 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-yellow-600{
    border-color: rgb(202 138 4 / var(--tw-border-opacity));
  }
}
.border-yellow-700{
  --tw-border-opacity: 1;
  border-color: rgb(161 98 7 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-yellow-700{
    border-color: rgb(161 98 7 / var(--tw-border-opacity));
  }
}
.border-yellow-800{
  --tw-border-opacity: 1;
  border-color: rgb(133 77 14 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-yellow-800{
    border-color: rgb(133 77 14 / var(--tw-border-opacity));
  }
}
.border-yellow-900{
  --tw-border-opacity: 1;
  border-color: rgb(113 63 18 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-yellow-900{
    border-color: rgb(113 63 18 / var(--tw-border-opacity));
  }
}
.border-zinc-100{
  --tw-border-opacity: 1;
  border-color: rgb(244 244 245 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-zinc-100{
    border-color: rgb(244 244 245 / var(--tw-border-opacity));
  }
}
.border-zinc-200{
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-zinc-200{
    border-color: rgb(228 228 231 / var(--tw-border-opacity));
  }
}
.border-zinc-300{
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-zinc-300{
    border-color: rgb(212 212 216 / var(--tw-border-opacity));
  }
}
.border-zinc-400{
  --tw-border-opacity: 1;
  border-color: rgb(161 161 170 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-zinc-400{
    border-color: rgb(161 161 170 / var(--tw-border-opacity));
  }
}
.border-zinc-50{
  --tw-border-opacity: 1;
  border-color: rgb(250 250 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-zinc-50{
    border-color: rgb(250 250 250 / var(--tw-border-opacity));
  }
}
.border-zinc-500{
  --tw-border-opacity: 1;
  border-color: rgb(113 113 122 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-zinc-500{
    border-color: rgb(113 113 122 / var(--tw-border-opacity));
  }
}
.border-zinc-600{
  --tw-border-opacity: 1;
  border-color: rgb(82 82 91 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-zinc-600{
    border-color: rgb(82 82 91 / var(--tw-border-opacity));
  }
}
.border-zinc-700{
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-zinc-700{
    border-color: rgb(63 63 70 / var(--tw-border-opacity));
  }
}
.border-zinc-800{
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-zinc-800{
    border-color: rgb(39 39 42 / var(--tw-border-opacity));
  }
}
.border-zinc-900{
  --tw-border-opacity: 1;
  border-color: rgb(24 24 27 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.border-zinc-900{
    border-color: rgb(24 24 27 / var(--tw-border-opacity));
  }
}
.border-opacity-10{
  --tw-border-opacity: 0.1;
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-amber-100{
    background-color: rgb(254 243 199 / var(--tw-bg-opacity));
  }
}
.bg-amber-200{
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-amber-200{
    background-color: rgb(253 230 138 / var(--tw-bg-opacity));
  }
}
.bg-amber-300{
  --tw-bg-opacity: 1;
  background-color: rgb(252 211 77 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-amber-300{
    background-color: rgb(252 211 77 / var(--tw-bg-opacity));
  }
}
.bg-amber-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-amber-400{
    background-color: rgb(251 191 36 / var(--tw-bg-opacity));
  }
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-amber-50{
    background-color: rgb(255 251 235 / var(--tw-bg-opacity));
  }
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-amber-500{
    background-color: rgb(245 158 11 / var(--tw-bg-opacity));
  }
}
.bg-amber-600{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-amber-600{
    background-color: rgb(217 119 6 / var(--tw-bg-opacity));
  }
}
.bg-amber-700{
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-amber-700{
    background-color: rgb(180 83 9 / var(--tw-bg-opacity));
  }
}
.bg-amber-800{
  --tw-bg-opacity: 1;
  background-color: rgb(146 64 14 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-amber-800{
    background-color: rgb(146 64 14 / var(--tw-bg-opacity));
  }
}
.bg-amber-900{
  --tw-bg-opacity: 1;
  background-color: rgb(120 53 15 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-amber-900{
    background-color: rgb(120 53 15 / var(--tw-bg-opacity));
  }
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-black{
    background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  }
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-blue-100{
    background-color: rgb(219 234 254 / var(--tw-bg-opacity));
  }
}
.bg-blue-200{
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-blue-200{
    background-color: rgb(191 219 254 / var(--tw-bg-opacity));
  }
}
.bg-blue-300{
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-blue-300{
    background-color: rgb(147 197 253 / var(--tw-bg-opacity));
  }
}
.bg-blue-400{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-blue-400{
    background-color: rgb(96 165 250 / var(--tw-bg-opacity));
  }
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-blue-50{
    background-color: rgb(239 246 255 / var(--tw-bg-opacity));
  }
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-blue-500{
    background-color: rgb(59 130 246 / var(--tw-bg-opacity));
  }
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-blue-600{
    background-color: rgb(37 99 235 / var(--tw-bg-opacity));
  }
}
.bg-blue-700{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-blue-700{
    background-color: rgb(29 78 216 / var(--tw-bg-opacity));
  }
}
.bg-blue-800{
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-blue-800{
    background-color: rgb(30 64 175 / var(--tw-bg-opacity));
  }
}
.bg-blue-900{
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-blue-900{
    background-color: rgb(30 58 138 / var(--tw-bg-opacity));
  }
}
.bg-current{
  background-color: currentColor;
}
.bg-cyan-100{
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-cyan-100{
    background-color: rgb(207 250 254 / var(--tw-bg-opacity));
  }
}
.bg-cyan-200{
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-cyan-200{
    background-color: rgb(165 243 252 / var(--tw-bg-opacity));
  }
}
.bg-cyan-300{
  --tw-bg-opacity: 1;
  background-color: rgb(103 232 249 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-cyan-300{
    background-color: rgb(103 232 249 / var(--tw-bg-opacity));
  }
}
.bg-cyan-400{
  --tw-bg-opacity: 1;
  background-color: rgb(34 211 238 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-cyan-400{
    background-color: rgb(34 211 238 / var(--tw-bg-opacity));
  }
}
.bg-cyan-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-cyan-50{
    background-color: rgb(236 254 255 / var(--tw-bg-opacity));
  }
}
.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-cyan-500{
    background-color: rgb(6 182 212 / var(--tw-bg-opacity));
  }
}
.bg-cyan-600{
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-cyan-600{
    background-color: rgb(8 145 178 / var(--tw-bg-opacity));
  }
}
.bg-cyan-700{
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-cyan-700{
    background-color: rgb(14 116 144 / var(--tw-bg-opacity));
  }
}
.bg-cyan-800{
  --tw-bg-opacity: 1;
  background-color: rgb(21 94 117 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-cyan-800{
    background-color: rgb(21 94 117 / var(--tw-bg-opacity));
  }
}
.bg-cyan-900{
  --tw-bg-opacity: 1;
  background-color: rgb(22 78 99 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-cyan-900{
    background-color: rgb(22 78 99 / var(--tw-bg-opacity));
  }
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-emerald-100{
    background-color: rgb(209 250 229 / var(--tw-bg-opacity));
  }
}
.bg-emerald-200{
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-emerald-200{
    background-color: rgb(167 243 208 / var(--tw-bg-opacity));
  }
}
.bg-emerald-300{
  --tw-bg-opacity: 1;
  background-color: rgb(110 231 183 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-emerald-300{
    background-color: rgb(110 231 183 / var(--tw-bg-opacity));
  }
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-emerald-400{
    background-color: rgb(52 211 153 / var(--tw-bg-opacity));
  }
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-emerald-50{
    background-color: rgb(236 253 245 / var(--tw-bg-opacity));
  }
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-emerald-500{
    background-color: rgb(16 185 129 / var(--tw-bg-opacity));
  }
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-emerald-600{
    background-color: rgb(5 150 105 / var(--tw-bg-opacity));
  }
}
.bg-emerald-700{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-emerald-700{
    background-color: rgb(4 120 87 / var(--tw-bg-opacity));
  }
}
.bg-emerald-800{
  --tw-bg-opacity: 1;
  background-color: rgb(6 95 70 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-emerald-800{
    background-color: rgb(6 95 70 / var(--tw-bg-opacity));
  }
}
.bg-emerald-900{
  --tw-bg-opacity: 1;
  background-color: rgb(6 78 59 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-emerald-900{
    background-color: rgb(6 78 59 / var(--tw-bg-opacity));
  }
}
.bg-fuchsia-100{
  --tw-bg-opacity: 1;
  background-color: rgb(250 232 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-fuchsia-100{
    background-color: rgb(250 232 255 / var(--tw-bg-opacity));
  }
}
.bg-fuchsia-200{
  --tw-bg-opacity: 1;
  background-color: rgb(245 208 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-fuchsia-200{
    background-color: rgb(245 208 254 / var(--tw-bg-opacity));
  }
}
.bg-fuchsia-300{
  --tw-bg-opacity: 1;
  background-color: rgb(240 171 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-fuchsia-300{
    background-color: rgb(240 171 252 / var(--tw-bg-opacity));
  }
}
.bg-fuchsia-400{
  --tw-bg-opacity: 1;
  background-color: rgb(232 121 249 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-fuchsia-400{
    background-color: rgb(232 121 249 / var(--tw-bg-opacity));
  }
}
.bg-fuchsia-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 244 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-fuchsia-50{
    background-color: rgb(253 244 255 / var(--tw-bg-opacity));
  }
}
.bg-fuchsia-500{
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-fuchsia-500{
    background-color: rgb(217 70 239 / var(--tw-bg-opacity));
  }
}
.bg-fuchsia-600{
  --tw-bg-opacity: 1;
  background-color: rgb(192 38 211 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-fuchsia-600{
    background-color: rgb(192 38 211 / var(--tw-bg-opacity));
  }
}
.bg-fuchsia-700{
  --tw-bg-opacity: 1;
  background-color: rgb(162 28 175 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-fuchsia-700{
    background-color: rgb(162 28 175 / var(--tw-bg-opacity));
  }
}
.bg-fuchsia-800{
  --tw-bg-opacity: 1;
  background-color: rgb(134 25 143 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-fuchsia-800{
    background-color: rgb(134 25 143 / var(--tw-bg-opacity));
  }
}
.bg-fuchsia-900{
  --tw-bg-opacity: 1;
  background-color: rgb(112 26 117 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-fuchsia-900{
    background-color: rgb(112 26 117 / var(--tw-bg-opacity));
  }
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-gray-100{
    background-color: rgb(243 244 246 / var(--tw-bg-opacity));
  }
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-gray-200{
    background-color: rgb(229 231 235 / var(--tw-bg-opacity));
  }
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-gray-300{
    background-color: rgb(209 213 219 / var(--tw-bg-opacity));
  }
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-gray-400{
    background-color: rgb(156 163 175 / var(--tw-bg-opacity));
  }
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-gray-50{
    background-color: rgb(249 250 251 / var(--tw-bg-opacity));
  }
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-gray-500{
    background-color: rgb(107 114 128 / var(--tw-bg-opacity));
  }
}
.bg-gray-600{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-gray-600{
    background-color: rgb(75 85 99 / var(--tw-bg-opacity));
  }
}
.bg-gray-700{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-gray-700{
    background-color: rgb(55 65 81 / var(--tw-bg-opacity));
  }
}
.bg-gray-800{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-gray-800{
    background-color: rgb(31 41 55 / var(--tw-bg-opacity));
  }
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-gray-900{
    background-color: rgb(17 24 39 / var(--tw-bg-opacity));
  }
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-green-100{
    background-color: rgb(220 252 231 / var(--tw-bg-opacity));
  }
}
.bg-green-200{
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-green-200{
    background-color: rgb(187 247 208 / var(--tw-bg-opacity));
  }
}
.bg-green-300{
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-green-300{
    background-color: rgb(134 239 172 / var(--tw-bg-opacity));
  }
}
.bg-green-400{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-green-400{
    background-color: rgb(74 222 128 / var(--tw-bg-opacity));
  }
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-green-50{
    background-color: rgb(240 253 244 / var(--tw-bg-opacity));
  }
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-green-500{
    background-color: rgb(34 197 94 / var(--tw-bg-opacity));
  }
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-green-600{
    background-color: rgb(22 163 74 / var(--tw-bg-opacity));
  }
}
.bg-green-700{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-green-700{
    background-color: rgb(21 128 61 / var(--tw-bg-opacity));
  }
}
.bg-green-800{
  --tw-bg-opacity: 1;
  background-color: rgb(22 101 52 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-green-800{
    background-color: rgb(22 101 52 / var(--tw-bg-opacity));
  }
}
.bg-green-900{
  --tw-bg-opacity: 1;
  background-color: rgb(20 83 45 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-green-900{
    background-color: rgb(20 83 45 / var(--tw-bg-opacity));
  }
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-indigo-100{
    background-color: rgb(224 231 255 / var(--tw-bg-opacity));
  }
}
.bg-indigo-100\\/90{
  background-color: rgb(224 231 255 / 0.9);
}
.bg-indigo-200{
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-indigo-200{
    background-color: rgb(199 210 254 / var(--tw-bg-opacity));
  }
}
.bg-indigo-300{
  --tw-bg-opacity: 1;
  background-color: rgb(165 180 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-indigo-300{
    background-color: rgb(165 180 252 / var(--tw-bg-opacity));
  }
}
.bg-indigo-400{
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-indigo-400{
    background-color: rgb(129 140 248 / var(--tw-bg-opacity));
  }
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-indigo-50{
    background-color: rgb(238 242 255 / var(--tw-bg-opacity));
  }
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-indigo-500{
    background-color: rgb(99 102 241 / var(--tw-bg-opacity));
  }
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-indigo-600{
    background-color: rgb(79 70 229 / var(--tw-bg-opacity));
  }
}
.bg-indigo-700{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-indigo-700{
    background-color: rgb(67 56 202 / var(--tw-bg-opacity));
  }
}
.bg-indigo-800{
  --tw-bg-opacity: 1;
  background-color: rgb(55 48 163 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-indigo-800{
    background-color: rgb(55 48 163 / var(--tw-bg-opacity));
  }
}
.bg-indigo-900{
  --tw-bg-opacity: 1;
  background-color: rgb(49 46 129 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-indigo-900{
    background-color: rgb(49 46 129 / var(--tw-bg-opacity));
  }
}
.bg-inherit{
  background-color: inherit;
}
.bg-lime-100{
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-lime-100{
    background-color: rgb(236 252 203 / var(--tw-bg-opacity));
  }
}
.bg-lime-200{
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-lime-200{
    background-color: rgb(217 249 157 / var(--tw-bg-opacity));
  }
}
.bg-lime-300{
  --tw-bg-opacity: 1;
  background-color: rgb(190 242 100 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-lime-300{
    background-color: rgb(190 242 100 / var(--tw-bg-opacity));
  }
}
.bg-lime-400{
  --tw-bg-opacity: 1;
  background-color: rgb(163 230 53 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-lime-400{
    background-color: rgb(163 230 53 / var(--tw-bg-opacity));
  }
}
.bg-lime-50{
  --tw-bg-opacity: 1;
  background-color: rgb(247 254 231 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-lime-50{
    background-color: rgb(247 254 231 / var(--tw-bg-opacity));
  }
}
.bg-lime-500{
  --tw-bg-opacity: 1;
  background-color: rgb(132 204 22 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-lime-500{
    background-color: rgb(132 204 22 / var(--tw-bg-opacity));
  }
}
.bg-lime-600{
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-lime-600{
    background-color: rgb(101 163 13 / var(--tw-bg-opacity));
  }
}
.bg-lime-700{
  --tw-bg-opacity: 1;
  background-color: rgb(77 124 15 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-lime-700{
    background-color: rgb(77 124 15 / var(--tw-bg-opacity));
  }
}
.bg-lime-800{
  --tw-bg-opacity: 1;
  background-color: rgb(63 98 18 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-lime-800{
    background-color: rgb(63 98 18 / var(--tw-bg-opacity));
  }
}
.bg-lime-900{
  --tw-bg-opacity: 1;
  background-color: rgb(54 83 20 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-lime-900{
    background-color: rgb(54 83 20 / var(--tw-bg-opacity));
  }
}
.bg-neutral-100{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-neutral-100{
    background-color: rgb(245 245 245 / var(--tw-bg-opacity));
  }
}
.bg-neutral-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 229 229 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-neutral-200{
    background-color: rgb(229 229 229 / var(--tw-bg-opacity));
  }
}
.bg-neutral-300{
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-neutral-300{
    background-color: rgb(212 212 212 / var(--tw-bg-opacity));
  }
}
.bg-neutral-400{
  --tw-bg-opacity: 1;
  background-color: rgb(163 163 163 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-neutral-400{
    background-color: rgb(163 163 163 / var(--tw-bg-opacity));
  }
}
.bg-neutral-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-neutral-50{
    background-color: rgb(250 250 250 / var(--tw-bg-opacity));
  }
}
.bg-neutral-500{
  --tw-bg-opacity: 1;
  background-color: rgb(115 115 115 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-neutral-500{
    background-color: rgb(115 115 115 / var(--tw-bg-opacity));
  }
}
.bg-neutral-600{
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 82 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-neutral-600{
    background-color: rgb(82 82 82 / var(--tw-bg-opacity));
  }
}
.bg-neutral-700{
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-neutral-700{
    background-color: rgb(64 64 64 / var(--tw-bg-opacity));
  }
}
.bg-neutral-800{
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-neutral-800{
    background-color: rgb(38 38 38 / var(--tw-bg-opacity));
  }
}
.bg-neutral-900{
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-neutral-900{
    background-color: rgb(23 23 23 / var(--tw-bg-opacity));
  }
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-orange-100{
    background-color: rgb(255 237 213 / var(--tw-bg-opacity));
  }
}
.bg-orange-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-orange-200{
    background-color: rgb(254 215 170 / var(--tw-bg-opacity));
  }
}
.bg-orange-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-orange-300{
    background-color: rgb(253 186 116 / var(--tw-bg-opacity));
  }
}
.bg-orange-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-orange-400{
    background-color: rgb(251 146 60 / var(--tw-bg-opacity));
  }
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-orange-50{
    background-color: rgb(255 247 237 / var(--tw-bg-opacity));
  }
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-orange-500{
    background-color: rgb(249 115 22 / var(--tw-bg-opacity));
  }
}
.bg-orange-600{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-orange-600{
    background-color: rgb(234 88 12 / var(--tw-bg-opacity));
  }
}
.bg-orange-700{
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-orange-700{
    background-color: rgb(194 65 12 / var(--tw-bg-opacity));
  }
}
.bg-orange-800{
  --tw-bg-opacity: 1;
  background-color: rgb(154 52 18 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-orange-800{
    background-color: rgb(154 52 18 / var(--tw-bg-opacity));
  }
}
.bg-orange-900{
  --tw-bg-opacity: 1;
  background-color: rgb(124 45 18 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-orange-900{
    background-color: rgb(124 45 18 / var(--tw-bg-opacity));
  }
}
.bg-pink-100{
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-pink-100{
    background-color: rgb(252 231 243 / var(--tw-bg-opacity));
  }
}
.bg-pink-200{
  --tw-bg-opacity: 1;
  background-color: rgb(251 207 232 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-pink-200{
    background-color: rgb(251 207 232 / var(--tw-bg-opacity));
  }
}
.bg-pink-300{
  --tw-bg-opacity: 1;
  background-color: rgb(249 168 212 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-pink-300{
    background-color: rgb(249 168 212 / var(--tw-bg-opacity));
  }
}
.bg-pink-400{
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-pink-400{
    background-color: rgb(244 114 182 / var(--tw-bg-opacity));
  }
}
.bg-pink-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-pink-50{
    background-color: rgb(253 242 248 / var(--tw-bg-opacity));
  }
}
.bg-pink-500{
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-pink-500{
    background-color: rgb(236 72 153 / var(--tw-bg-opacity));
  }
}
.bg-pink-600{
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-pink-600{
    background-color: rgb(219 39 119 / var(--tw-bg-opacity));
  }
}
.bg-pink-700{
  --tw-bg-opacity: 1;
  background-color: rgb(190 24 93 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-pink-700{
    background-color: rgb(190 24 93 / var(--tw-bg-opacity));
  }
}
.bg-pink-800{
  --tw-bg-opacity: 1;
  background-color: rgb(157 23 77 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-pink-800{
    background-color: rgb(157 23 77 / var(--tw-bg-opacity));
  }
}
.bg-pink-900{
  --tw-bg-opacity: 1;
  background-color: rgb(131 24 67 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-pink-900{
    background-color: rgb(131 24 67 / var(--tw-bg-opacity));
  }
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-purple-100{
    background-color: rgb(243 232 255 / var(--tw-bg-opacity));
  }
}
.bg-purple-200{
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-purple-200{
    background-color: rgb(233 213 255 / var(--tw-bg-opacity));
  }
}
.bg-purple-300{
  --tw-bg-opacity: 1;
  background-color: rgb(216 180 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-purple-300{
    background-color: rgb(216 180 254 / var(--tw-bg-opacity));
  }
}
.bg-purple-400{
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-purple-400{
    background-color: rgb(192 132 252 / var(--tw-bg-opacity));
  }
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-purple-50{
    background-color: rgb(250 245 255 / var(--tw-bg-opacity));
  }
}
.bg-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-purple-500{
    background-color: rgb(168 85 247 / var(--tw-bg-opacity));
  }
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-purple-600{
    background-color: rgb(147 51 234 / var(--tw-bg-opacity));
  }
}
.bg-purple-700{
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-purple-700{
    background-color: rgb(126 34 206 / var(--tw-bg-opacity));
  }
}
.bg-purple-800{
  --tw-bg-opacity: 1;
  background-color: rgb(107 33 168 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-purple-800{
    background-color: rgb(107 33 168 / var(--tw-bg-opacity));
  }
}
.bg-purple-900{
  --tw-bg-opacity: 1;
  background-color: rgb(88 28 135 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-purple-900{
    background-color: rgb(88 28 135 / var(--tw-bg-opacity));
  }
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-red-100{
    background-color: rgb(254 226 226 / var(--tw-bg-opacity));
  }
}
.bg-red-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-red-200{
    background-color: rgb(254 202 202 / var(--tw-bg-opacity));
  }
}
.bg-red-300{
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-red-300{
    background-color: rgb(252 165 165 / var(--tw-bg-opacity));
  }
}
.bg-red-400{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-red-400{
    background-color: rgb(248 113 113 / var(--tw-bg-opacity));
  }
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-red-50{
    background-color: rgb(254 242 242 / var(--tw-bg-opacity));
  }
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-red-500{
    background-color: rgb(239 68 68 / var(--tw-bg-opacity));
  }
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-red-600{
    background-color: rgb(220 38 38 / var(--tw-bg-opacity));
  }
}
.bg-red-700{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-red-700{
    background-color: rgb(185 28 28 / var(--tw-bg-opacity));
  }
}
.bg-red-800{
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-red-800{
    background-color: rgb(153 27 27 / var(--tw-bg-opacity));
  }
}
.bg-red-900{
  --tw-bg-opacity: 1;
  background-color: rgb(127 29 29 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-red-900{
    background-color: rgb(127 29 29 / var(--tw-bg-opacity));
  }
}
.bg-rose-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-rose-100{
    background-color: rgb(255 228 230 / var(--tw-bg-opacity));
  }
}
.bg-rose-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 205 211 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-rose-200{
    background-color: rgb(254 205 211 / var(--tw-bg-opacity));
  }
}
.bg-rose-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 164 175 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-rose-300{
    background-color: rgb(253 164 175 / var(--tw-bg-opacity));
  }
}
.bg-rose-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 113 133 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-rose-400{
    background-color: rgb(251 113 133 / var(--tw-bg-opacity));
  }
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-rose-50{
    background-color: rgb(255 241 242 / var(--tw-bg-opacity));
  }
}
.bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-rose-500{
    background-color: rgb(244 63 94 / var(--tw-bg-opacity));
  }
}
.bg-rose-600{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-rose-600{
    background-color: rgb(225 29 72 / var(--tw-bg-opacity));
  }
}
.bg-rose-700{
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-rose-700{
    background-color: rgb(190 18 60 / var(--tw-bg-opacity));
  }
}
.bg-rose-800{
  --tw-bg-opacity: 1;
  background-color: rgb(159 18 57 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-rose-800{
    background-color: rgb(159 18 57 / var(--tw-bg-opacity));
  }
}
.bg-rose-900{
  --tw-bg-opacity: 1;
  background-color: rgb(136 19 55 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-rose-900{
    background-color: rgb(136 19 55 / var(--tw-bg-opacity));
  }
}
.bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-sky-100{
    background-color: rgb(224 242 254 / var(--tw-bg-opacity));
  }
}
.bg-sky-200{
  --tw-bg-opacity: 1;
  background-color: rgb(186 230 253 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-sky-200{
    background-color: rgb(186 230 253 / var(--tw-bg-opacity));
  }
}
.bg-sky-300{
  --tw-bg-opacity: 1;
  background-color: rgb(125 211 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-sky-300{
    background-color: rgb(125 211 252 / var(--tw-bg-opacity));
  }
}
.bg-sky-400{
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-sky-400{
    background-color: rgb(56 189 248 / var(--tw-bg-opacity));
  }
}
.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-sky-50{
    background-color: rgb(240 249 255 / var(--tw-bg-opacity));
  }
}
.bg-sky-500{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-sky-500{
    background-color: rgb(14 165 233 / var(--tw-bg-opacity));
  }
}
.bg-sky-600{
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-sky-600{
    background-color: rgb(2 132 199 / var(--tw-bg-opacity));
  }
}
.bg-sky-700{
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-sky-700{
    background-color: rgb(3 105 161 / var(--tw-bg-opacity));
  }
}
.bg-sky-800{
  --tw-bg-opacity: 1;
  background-color: rgb(7 89 133 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-sky-800{
    background-color: rgb(7 89 133 / var(--tw-bg-opacity));
  }
}
.bg-sky-900{
  --tw-bg-opacity: 1;
  background-color: rgb(12 74 110 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-sky-900{
    background-color: rgb(12 74 110 / var(--tw-bg-opacity));
  }
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-slate-100{
    background-color: rgb(241 245 249 / var(--tw-bg-opacity));
  }
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-slate-200{
    background-color: rgb(226 232 240 / var(--tw-bg-opacity));
  }
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-slate-300{
    background-color: rgb(203 213 225 / var(--tw-bg-opacity));
  }
}
.bg-slate-400{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-slate-400{
    background-color: rgb(148 163 184 / var(--tw-bg-opacity));
  }
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-slate-50{
    background-color: rgb(248 250 252 / var(--tw-bg-opacity));
  }
}
.bg-slate-500{
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-slate-500{
    background-color: rgb(100 116 139 / var(--tw-bg-opacity));
  }
}
.bg-slate-600{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-slate-600{
    background-color: rgb(71 85 105 / var(--tw-bg-opacity));
  }
}
.bg-slate-700{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-slate-700{
    background-color: rgb(51 65 85 / var(--tw-bg-opacity));
  }
}
.bg-slate-800{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-slate-800{
    background-color: rgb(30 41 59 / var(--tw-bg-opacity));
  }
}
.bg-slate-900{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-slate-900{
    background-color: rgb(15 23 42 / var(--tw-bg-opacity));
  }
}
.bg-stone-100{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 244 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-stone-100{
    background-color: rgb(245 245 244 / var(--tw-bg-opacity));
  }
}
.bg-stone-200{
  --tw-bg-opacity: 1;
  background-color: rgb(231 229 228 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-stone-200{
    background-color: rgb(231 229 228 / var(--tw-bg-opacity));
  }
}
.bg-stone-300{
  --tw-bg-opacity: 1;
  background-color: rgb(214 211 209 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-stone-300{
    background-color: rgb(214 211 209 / var(--tw-bg-opacity));
  }
}
.bg-stone-400{
  --tw-bg-opacity: 1;
  background-color: rgb(168 162 158 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-stone-400{
    background-color: rgb(168 162 158 / var(--tw-bg-opacity));
  }
}
.bg-stone-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 249 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-stone-50{
    background-color: rgb(250 250 249 / var(--tw-bg-opacity));
  }
}
.bg-stone-500{
  --tw-bg-opacity: 1;
  background-color: rgb(120 113 108 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-stone-500{
    background-color: rgb(120 113 108 / var(--tw-bg-opacity));
  }
}
.bg-stone-600{
  --tw-bg-opacity: 1;
  background-color: rgb(87 83 78 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-stone-600{
    background-color: rgb(87 83 78 / var(--tw-bg-opacity));
  }
}
.bg-stone-700{
  --tw-bg-opacity: 1;
  background-color: rgb(68 64 60 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-stone-700{
    background-color: rgb(68 64 60 / var(--tw-bg-opacity));
  }
}
.bg-stone-800{
  --tw-bg-opacity: 1;
  background-color: rgb(41 37 36 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-stone-800{
    background-color: rgb(41 37 36 / var(--tw-bg-opacity));
  }
}
.bg-stone-900{
  --tw-bg-opacity: 1;
  background-color: rgb(28 25 23 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-stone-900{
    background-color: rgb(28 25 23 / var(--tw-bg-opacity));
  }
}
.bg-teal-100{
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-teal-100{
    background-color: rgb(204 251 241 / var(--tw-bg-opacity));
  }
}
.bg-teal-200{
  --tw-bg-opacity: 1;
  background-color: rgb(153 246 228 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-teal-200{
    background-color: rgb(153 246 228 / var(--tw-bg-opacity));
  }
}
.bg-teal-300{
  --tw-bg-opacity: 1;
  background-color: rgb(94 234 212 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-teal-300{
    background-color: rgb(94 234 212 / var(--tw-bg-opacity));
  }
}
.bg-teal-400{
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-teal-400{
    background-color: rgb(45 212 191 / var(--tw-bg-opacity));
  }
}
.bg-teal-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-teal-50{
    background-color: rgb(240 253 250 / var(--tw-bg-opacity));
  }
}
.bg-teal-500{
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-teal-500{
    background-color: rgb(20 184 166 / var(--tw-bg-opacity));
  }
}
.bg-teal-600{
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-teal-600{
    background-color: rgb(13 148 136 / var(--tw-bg-opacity));
  }
}
.bg-teal-700{
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-teal-700{
    background-color: rgb(15 118 110 / var(--tw-bg-opacity));
  }
}
.bg-teal-800{
  --tw-bg-opacity: 1;
  background-color: rgb(17 94 89 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-teal-800{
    background-color: rgb(17 94 89 / var(--tw-bg-opacity));
  }
}
.bg-teal-900{
  --tw-bg-opacity: 1;
  background-color: rgb(19 78 74 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-teal-900{
    background-color: rgb(19 78 74 / var(--tw-bg-opacity));
  }
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-100{
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-violet-100{
    background-color: rgb(237 233 254 / var(--tw-bg-opacity));
  }
}
.bg-violet-200{
  --tw-bg-opacity: 1;
  background-color: rgb(221 214 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-violet-200{
    background-color: rgb(221 214 254 / var(--tw-bg-opacity));
  }
}
.bg-violet-300{
  --tw-bg-opacity: 1;
  background-color: rgb(196 181 253 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-violet-300{
    background-color: rgb(196 181 253 / var(--tw-bg-opacity));
  }
}
.bg-violet-400{
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-violet-400{
    background-color: rgb(167 139 250 / var(--tw-bg-opacity));
  }
}
.bg-violet-50{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-violet-50{
    background-color: rgb(245 243 255 / var(--tw-bg-opacity));
  }
}
.bg-violet-500{
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-violet-500{
    background-color: rgb(139 92 246 / var(--tw-bg-opacity));
  }
}
.bg-violet-600{
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-violet-600{
    background-color: rgb(124 58 237 / var(--tw-bg-opacity));
  }
}
.bg-violet-700{
  --tw-bg-opacity: 1;
  background-color: rgb(109 40 217 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-violet-700{
    background-color: rgb(109 40 217 / var(--tw-bg-opacity));
  }
}
.bg-violet-800{
  --tw-bg-opacity: 1;
  background-color: rgb(91 33 182 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-violet-800{
    background-color: rgb(91 33 182 / var(--tw-bg-opacity));
  }
}
.bg-violet-900{
  --tw-bg-opacity: 1;
  background-color: rgb(76 29 149 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-violet-900{
    background-color: rgb(76 29 149 / var(--tw-bg-opacity));
  }
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-white{
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-yellow-100{
    background-color: rgb(254 249 195 / var(--tw-bg-opacity));
  }
}
.bg-yellow-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-yellow-200{
    background-color: rgb(254 240 138 / var(--tw-bg-opacity));
  }
}
.bg-yellow-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-yellow-300{
    background-color: rgb(253 224 71 / var(--tw-bg-opacity));
  }
}
.bg-yellow-400{
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-yellow-400{
    background-color: rgb(250 204 21 / var(--tw-bg-opacity));
  }
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-yellow-50{
    background-color: rgb(254 252 232 / var(--tw-bg-opacity));
  }
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-yellow-500{
    background-color: rgb(234 179 8 / var(--tw-bg-opacity));
  }
}
.bg-yellow-600{
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-yellow-600{
    background-color: rgb(202 138 4 / var(--tw-bg-opacity));
  }
}
.bg-yellow-700{
  --tw-bg-opacity: 1;
  background-color: rgb(161 98 7 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-yellow-700{
    background-color: rgb(161 98 7 / var(--tw-bg-opacity));
  }
}
.bg-yellow-800{
  --tw-bg-opacity: 1;
  background-color: rgb(133 77 14 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-yellow-800{
    background-color: rgb(133 77 14 / var(--tw-bg-opacity));
  }
}
.bg-yellow-900{
  --tw-bg-opacity: 1;
  background-color: rgb(113 63 18 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-yellow-900{
    background-color: rgb(113 63 18 / var(--tw-bg-opacity));
  }
}
.bg-zinc-100{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-zinc-100{
    background-color: rgb(244 244 245 / var(--tw-bg-opacity));
  }
}
.bg-zinc-200{
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-zinc-200{
    background-color: rgb(228 228 231 / var(--tw-bg-opacity));
  }
}
.bg-zinc-300{
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 216 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-zinc-300{
    background-color: rgb(212 212 216 / var(--tw-bg-opacity));
  }
}
.bg-zinc-400{
  --tw-bg-opacity: 1;
  background-color: rgb(161 161 170 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-zinc-400{
    background-color: rgb(161 161 170 / var(--tw-bg-opacity));
  }
}
.bg-zinc-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-zinc-50{
    background-color: rgb(250 250 250 / var(--tw-bg-opacity));
  }
}
.bg-zinc-500{
  --tw-bg-opacity: 1;
  background-color: rgb(113 113 122 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-zinc-500{
    background-color: rgb(113 113 122 / var(--tw-bg-opacity));
  }
}
.bg-zinc-600{
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 91 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-zinc-600{
    background-color: rgb(82 82 91 / var(--tw-bg-opacity));
  }
}
.bg-zinc-700{
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-zinc-700{
    background-color: rgb(63 63 70 / var(--tw-bg-opacity));
  }
}
.bg-zinc-800{
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-zinc-800{
    background-color: rgb(39 39 42 / var(--tw-bg-opacity));
  }
}
.bg-zinc-900{
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.bg-zinc-900{
    background-color: rgb(24 24 27 / var(--tw-bg-opacity));
  }
}
.bg-opacity-30{
  --tw-bg-opacity: 0.3;
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-opacity-75{
  --tw-bg-opacity: 0.75;
}
.bg-opacity-90{
  --tw-bg-opacity: 0.9;
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-indigo-300{
  --tw-gradient-from: #a5b4fc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(165 180 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-500{
  --tw-gradient-from: #f43f5e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 63 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-emerald-300{
  --tw-gradient-to: rgb(110 231 183 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #6ee7b7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-yellow-500{
  --tw-gradient-to: rgb(234 179 8 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #eab308 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-green-300{
  --tw-gradient-to: #86efac var(--tw-gradient-to-position);
}
.to-green-500{
  --tw-gradient-to: #22c55e var(--tw-gradient-to-position);
}
.bg-contain{
  background-size: contain;
}
.bg-cover{
  background-size: cover;
}
.bg-fixed{
  background-attachment: fixed;
}
.bg-center{
  background-position: center;
}
.bg-no-repeat{
  background-repeat: no-repeat;
}
.fill-amber-300{
  fill: #fcd34d;
}
.fill-blue-300{
  fill: #93c5fd;
}
.fill-cyan-300{
  fill: #67e8f9;
}
.fill-emerald-300{
  fill: #6ee7b7;
}
.fill-emerald-500{
  fill: #10b981;
}
.fill-fuchsia-300{
  fill: #f0abfc;
}
.fill-indigo-200{
  fill: #c7d2fe;
}
.fill-lime-300{
  fill: #bef264;
}
.fill-sky-300{
  fill: #7dd3fc;
}
.fill-teal-300{
  fill: #5eead4;
}
.fill-yellow-300{
  fill: #fde047;
}
.stroke-amber-300{
  stroke: #fcd34d;
}
.stroke-blue-300{
  stroke: #93c5fd;
}
.stroke-cyan-300{
  stroke: #67e8f9;
}
.stroke-emerald-300{
  stroke: #6ee7b7;
}
.stroke-fuchsia-300{
  stroke: #f0abfc;
}
.stroke-indigo-200{
  stroke: #c7d2fe;
}
.stroke-lime-300{
  stroke: #bef264;
}
.stroke-sky-300{
  stroke: #7dd3fc;
}
.stroke-teal-300{
  stroke: #5eead4;
}
.stroke-yellow-300{
  stroke: #fde047;
}
.object-cover{
  -o-object-fit: cover;
     object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[5px\\]{
  padding: 5px;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-px{
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-20{
  padding-bottom: 5rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.align-bottom{
  vertical-align: bottom;
}
.font-display{
  font-family: "Wallop", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.font-mono{
  font-family: Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;
}
.\\!text-sm{
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[1\\.7rem\\]{
  font-size: 1.7rem;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.italic{
  font-style: italic;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-normal{
  line-height: 1.5;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.text-amber-100{
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-amber-100{
    color: rgb(254 243 199 / var(--tw-text-opacity));
  }
}
.text-amber-200{
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-amber-200{
    color: rgb(253 230 138 / var(--tw-text-opacity));
  }
}
.text-amber-300{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-amber-300{
    color: rgb(252 211 77 / var(--tw-text-opacity));
  }
}
.text-amber-400{
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-amber-400{
    color: rgb(251 191 36 / var(--tw-text-opacity));
  }
}
.text-amber-50{
  --tw-text-opacity: 1;
  color: rgb(255 251 235 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-amber-50{
    color: rgb(255 251 235 / var(--tw-text-opacity));
  }
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-amber-500{
    color: rgb(245 158 11 / var(--tw-text-opacity));
  }
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-amber-600{
    color: rgb(217 119 6 / var(--tw-text-opacity));
  }
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-amber-700{
    color: rgb(180 83 9 / var(--tw-text-opacity));
  }
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-amber-800{
    color: rgb(146 64 14 / var(--tw-text-opacity));
  }
}
.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-amber-900{
    color: rgb(120 53 15 / var(--tw-text-opacity));
  }
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-black{
    color: rgb(0 0 0 / var(--tw-text-opacity));
  }
}
.text-blue-100{
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-blue-100{
    color: rgb(219 234 254 / var(--tw-text-opacity));
  }
}
.text-blue-200{
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-blue-200{
    color: rgb(191 219 254 / var(--tw-text-opacity));
  }
}
.text-blue-300{
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-blue-300{
    color: rgb(147 197 253 / var(--tw-text-opacity));
  }
}
.text-blue-400{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-blue-400{
    color: rgb(96 165 250 / var(--tw-text-opacity));
  }
}
.text-blue-50{
  --tw-text-opacity: 1;
  color: rgb(239 246 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-blue-50{
    color: rgb(239 246 255 / var(--tw-text-opacity));
  }
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-blue-500{
    color: rgb(59 130 246 / var(--tw-text-opacity));
  }
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-blue-600{
    color: rgb(37 99 235 / var(--tw-text-opacity));
  }
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-blue-700{
    color: rgb(29 78 216 / var(--tw-text-opacity));
  }
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-blue-800{
    color: rgb(30 64 175 / var(--tw-text-opacity));
  }
}
.text-blue-900{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-blue-900{
    color: rgb(30 58 138 / var(--tw-text-opacity));
  }
}
.text-current{
  color: currentColor;
}
.text-cyan-100{
  --tw-text-opacity: 1;
  color: rgb(207 250 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-cyan-100{
    color: rgb(207 250 254 / var(--tw-text-opacity));
  }
}
.text-cyan-200{
  --tw-text-opacity: 1;
  color: rgb(165 243 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-cyan-200{
    color: rgb(165 243 252 / var(--tw-text-opacity));
  }
}
.text-cyan-300{
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-cyan-300{
    color: rgb(103 232 249 / var(--tw-text-opacity));
  }
}
.text-cyan-400{
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-cyan-400{
    color: rgb(34 211 238 / var(--tw-text-opacity));
  }
}
.text-cyan-50{
  --tw-text-opacity: 1;
  color: rgb(236 254 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-cyan-50{
    color: rgb(236 254 255 / var(--tw-text-opacity));
  }
}
.text-cyan-500{
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-cyan-500{
    color: rgb(6 182 212 / var(--tw-text-opacity));
  }
}
.text-cyan-600{
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-cyan-600{
    color: rgb(8 145 178 / var(--tw-text-opacity));
  }
}
.text-cyan-700{
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-cyan-700{
    color: rgb(14 116 144 / var(--tw-text-opacity));
  }
}
.text-cyan-800{
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-cyan-800{
    color: rgb(21 94 117 / var(--tw-text-opacity));
  }
}
.text-cyan-900{
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-cyan-900{
    color: rgb(22 78 99 / var(--tw-text-opacity));
  }
}
.text-emerald-100{
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-emerald-100{
    color: rgb(209 250 229 / var(--tw-text-opacity));
  }
}
.text-emerald-200{
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-emerald-200{
    color: rgb(167 243 208 / var(--tw-text-opacity));
  }
}
.text-emerald-300{
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-emerald-300{
    color: rgb(110 231 183 / var(--tw-text-opacity));
  }
}
.text-emerald-400{
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-emerald-400{
    color: rgb(52 211 153 / var(--tw-text-opacity));
  }
}
.text-emerald-50{
  --tw-text-opacity: 1;
  color: rgb(236 253 245 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-emerald-50{
    color: rgb(236 253 245 / var(--tw-text-opacity));
  }
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-emerald-500{
    color: rgb(16 185 129 / var(--tw-text-opacity));
  }
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-emerald-600{
    color: rgb(5 150 105 / var(--tw-text-opacity));
  }
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-emerald-700{
    color: rgb(4 120 87 / var(--tw-text-opacity));
  }
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-emerald-800{
    color: rgb(6 95 70 / var(--tw-text-opacity));
  }
}
.text-emerald-900{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-emerald-900{
    color: rgb(6 78 59 / var(--tw-text-opacity));
  }
}
.text-fuchsia-100{
  --tw-text-opacity: 1;
  color: rgb(250 232 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-fuchsia-100{
    color: rgb(250 232 255 / var(--tw-text-opacity));
  }
}
.text-fuchsia-200{
  --tw-text-opacity: 1;
  color: rgb(245 208 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-fuchsia-200{
    color: rgb(245 208 254 / var(--tw-text-opacity));
  }
}
.text-fuchsia-300{
  --tw-text-opacity: 1;
  color: rgb(240 171 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-fuchsia-300{
    color: rgb(240 171 252 / var(--tw-text-opacity));
  }
}
.text-fuchsia-400{
  --tw-text-opacity: 1;
  color: rgb(232 121 249 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-fuchsia-400{
    color: rgb(232 121 249 / var(--tw-text-opacity));
  }
}
.text-fuchsia-50{
  --tw-text-opacity: 1;
  color: rgb(253 244 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-fuchsia-50{
    color: rgb(253 244 255 / var(--tw-text-opacity));
  }
}
.text-fuchsia-500{
  --tw-text-opacity: 1;
  color: rgb(217 70 239 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-fuchsia-500{
    color: rgb(217 70 239 / var(--tw-text-opacity));
  }
}
.text-fuchsia-600{
  --tw-text-opacity: 1;
  color: rgb(192 38 211 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-fuchsia-600{
    color: rgb(192 38 211 / var(--tw-text-opacity));
  }
}
.text-fuchsia-700{
  --tw-text-opacity: 1;
  color: rgb(162 28 175 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-fuchsia-700{
    color: rgb(162 28 175 / var(--tw-text-opacity));
  }
}
.text-fuchsia-800{
  --tw-text-opacity: 1;
  color: rgb(134 25 143 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-fuchsia-800{
    color: rgb(134 25 143 / var(--tw-text-opacity));
  }
}
.text-fuchsia-900{
  --tw-text-opacity: 1;
  color: rgb(112 26 117 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-fuchsia-900{
    color: rgb(112 26 117 / var(--tw-text-opacity));
  }
}
.text-gray-100{
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-gray-100{
    color: rgb(243 244 246 / var(--tw-text-opacity));
  }
}
.text-gray-200{
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-gray-200{
    color: rgb(229 231 235 / var(--tw-text-opacity));
  }
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-gray-300{
    color: rgb(209 213 219 / var(--tw-text-opacity));
  }
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-gray-400{
    color: rgb(156 163 175 / var(--tw-text-opacity));
  }
}
.text-gray-50{
  --tw-text-opacity: 1;
  color: rgb(249 250 251 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-gray-50{
    color: rgb(249 250 251 / var(--tw-text-opacity));
  }
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-gray-500{
    color: rgb(107 114 128 / var(--tw-text-opacity));
  }
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-gray-600{
    color: rgb(75 85 99 / var(--tw-text-opacity));
  }
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-gray-700{
    color: rgb(55 65 81 / var(--tw-text-opacity));
  }
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-gray-800{
    color: rgb(31 41 55 / var(--tw-text-opacity));
  }
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-gray-900{
    color: rgb(17 24 39 / var(--tw-text-opacity));
  }
}
.text-green-100{
  --tw-text-opacity: 1;
  color: rgb(220 252 231 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-green-100{
    color: rgb(220 252 231 / var(--tw-text-opacity));
  }
}
.text-green-200{
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-green-200{
    color: rgb(187 247 208 / var(--tw-text-opacity));
  }
}
.text-green-300{
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-green-300{
    color: rgb(134 239 172 / var(--tw-text-opacity));
  }
}
.text-green-400{
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-green-400{
    color: rgb(74 222 128 / var(--tw-text-opacity));
  }
}
.text-green-50{
  --tw-text-opacity: 1;
  color: rgb(240 253 244 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-green-50{
    color: rgb(240 253 244 / var(--tw-text-opacity));
  }
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-green-500{
    color: rgb(34 197 94 / var(--tw-text-opacity));
  }
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-green-600{
    color: rgb(22 163 74 / var(--tw-text-opacity));
  }
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-green-700{
    color: rgb(21 128 61 / var(--tw-text-opacity));
  }
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-green-800{
    color: rgb(22 101 52 / var(--tw-text-opacity));
  }
}
.text-green-900{
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-green-900{
    color: rgb(20 83 45 / var(--tw-text-opacity));
  }
}
.text-indigo-100{
  --tw-text-opacity: 1;
  color: rgb(224 231 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-indigo-100{
    color: rgb(224 231 255 / var(--tw-text-opacity));
  }
}
.text-indigo-200{
  --tw-text-opacity: 1;
  color: rgb(199 210 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-indigo-200{
    color: rgb(199 210 254 / var(--tw-text-opacity));
  }
}
.text-indigo-300{
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-indigo-300{
    color: rgb(165 180 252 / var(--tw-text-opacity));
  }
}
.text-indigo-400{
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-indigo-400{
    color: rgb(129 140 248 / var(--tw-text-opacity));
  }
}
.text-indigo-50{
  --tw-text-opacity: 1;
  color: rgb(238 242 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-indigo-50{
    color: rgb(238 242 255 / var(--tw-text-opacity));
  }
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-indigo-500{
    color: rgb(99 102 241 / var(--tw-text-opacity));
  }
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-indigo-600{
    color: rgb(79 70 229 / var(--tw-text-opacity));
  }
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-indigo-700{
    color: rgb(67 56 202 / var(--tw-text-opacity));
  }
}
.text-indigo-800{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-indigo-800{
    color: rgb(55 48 163 / var(--tw-text-opacity));
  }
}
.text-indigo-900{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-indigo-900{
    color: rgb(49 46 129 / var(--tw-text-opacity));
  }
}
.text-inherit{
  color: inherit;
}
.text-lime-100{
  --tw-text-opacity: 1;
  color: rgb(236 252 203 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-lime-100{
    color: rgb(236 252 203 / var(--tw-text-opacity));
  }
}
.text-lime-200{
  --tw-text-opacity: 1;
  color: rgb(217 249 157 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-lime-200{
    color: rgb(217 249 157 / var(--tw-text-opacity));
  }
}
.text-lime-300{
  --tw-text-opacity: 1;
  color: rgb(190 242 100 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-lime-300{
    color: rgb(190 242 100 / var(--tw-text-opacity));
  }
}
.text-lime-400{
  --tw-text-opacity: 1;
  color: rgb(163 230 53 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-lime-400{
    color: rgb(163 230 53 / var(--tw-text-opacity));
  }
}
.text-lime-50{
  --tw-text-opacity: 1;
  color: rgb(247 254 231 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-lime-50{
    color: rgb(247 254 231 / var(--tw-text-opacity));
  }
}
.text-lime-500{
  --tw-text-opacity: 1;
  color: rgb(132 204 22 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-lime-500{
    color: rgb(132 204 22 / var(--tw-text-opacity));
  }
}
.text-lime-600{
  --tw-text-opacity: 1;
  color: rgb(101 163 13 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-lime-600{
    color: rgb(101 163 13 / var(--tw-text-opacity));
  }
}
.text-lime-700{
  --tw-text-opacity: 1;
  color: rgb(77 124 15 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-lime-700{
    color: rgb(77 124 15 / var(--tw-text-opacity));
  }
}
.text-lime-800{
  --tw-text-opacity: 1;
  color: rgb(63 98 18 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-lime-800{
    color: rgb(63 98 18 / var(--tw-text-opacity));
  }
}
.text-lime-900{
  --tw-text-opacity: 1;
  color: rgb(54 83 20 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-lime-900{
    color: rgb(54 83 20 / var(--tw-text-opacity));
  }
}
.text-neutral-100{
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-neutral-100{
    color: rgb(245 245 245 / var(--tw-text-opacity));
  }
}
.text-neutral-200{
  --tw-text-opacity: 1;
  color: rgb(229 229 229 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-neutral-200{
    color: rgb(229 229 229 / var(--tw-text-opacity));
  }
}
.text-neutral-300{
  --tw-text-opacity: 1;
  color: rgb(212 212 212 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-neutral-300{
    color: rgb(212 212 212 / var(--tw-text-opacity));
  }
}
.text-neutral-400{
  --tw-text-opacity: 1;
  color: rgb(163 163 163 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-neutral-400{
    color: rgb(163 163 163 / var(--tw-text-opacity));
  }
}
.text-neutral-50{
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-neutral-50{
    color: rgb(250 250 250 / var(--tw-text-opacity));
  }
}
.text-neutral-500{
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-neutral-500{
    color: rgb(115 115 115 / var(--tw-text-opacity));
  }
}
.text-neutral-600{
  --tw-text-opacity: 1;
  color: rgb(82 82 82 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-neutral-600{
    color: rgb(82 82 82 / var(--tw-text-opacity));
  }
}
.text-neutral-700{
  --tw-text-opacity: 1;
  color: rgb(64 64 64 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-neutral-700{
    color: rgb(64 64 64 / var(--tw-text-opacity));
  }
}
.text-neutral-800{
  --tw-text-opacity: 1;
  color: rgb(38 38 38 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-neutral-800{
    color: rgb(38 38 38 / var(--tw-text-opacity));
  }
}
.text-neutral-900{
  --tw-text-opacity: 1;
  color: rgb(23 23 23 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-neutral-900{
    color: rgb(23 23 23 / var(--tw-text-opacity));
  }
}
.text-orange-100{
  --tw-text-opacity: 1;
  color: rgb(255 237 213 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-orange-100{
    color: rgb(255 237 213 / var(--tw-text-opacity));
  }
}
.text-orange-200{
  --tw-text-opacity: 1;
  color: rgb(254 215 170 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-orange-200{
    color: rgb(254 215 170 / var(--tw-text-opacity));
  }
}
.text-orange-300{
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-orange-300{
    color: rgb(253 186 116 / var(--tw-text-opacity));
  }
}
.text-orange-400{
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-orange-400{
    color: rgb(251 146 60 / var(--tw-text-opacity));
  }
}
.text-orange-50{
  --tw-text-opacity: 1;
  color: rgb(255 247 237 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-orange-50{
    color: rgb(255 247 237 / var(--tw-text-opacity));
  }
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-orange-500{
    color: rgb(249 115 22 / var(--tw-text-opacity));
  }
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-orange-600{
    color: rgb(234 88 12 / var(--tw-text-opacity));
  }
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-orange-700{
    color: rgb(194 65 12 / var(--tw-text-opacity));
  }
}
.text-orange-800{
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-orange-800{
    color: rgb(154 52 18 / var(--tw-text-opacity));
  }
}
.text-orange-900{
  --tw-text-opacity: 1;
  color: rgb(124 45 18 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-orange-900{
    color: rgb(124 45 18 / var(--tw-text-opacity));
  }
}
.text-pink-100{
  --tw-text-opacity: 1;
  color: rgb(252 231 243 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-pink-100{
    color: rgb(252 231 243 / var(--tw-text-opacity));
  }
}
.text-pink-200{
  --tw-text-opacity: 1;
  color: rgb(251 207 232 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-pink-200{
    color: rgb(251 207 232 / var(--tw-text-opacity));
  }
}
.text-pink-300{
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-pink-300{
    color: rgb(249 168 212 / var(--tw-text-opacity));
  }
}
.text-pink-400{
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-pink-400{
    color: rgb(244 114 182 / var(--tw-text-opacity));
  }
}
.text-pink-50{
  --tw-text-opacity: 1;
  color: rgb(253 242 248 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-pink-50{
    color: rgb(253 242 248 / var(--tw-text-opacity));
  }
}
.text-pink-500{
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-pink-500{
    color: rgb(236 72 153 / var(--tw-text-opacity));
  }
}
.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-pink-600{
    color: rgb(219 39 119 / var(--tw-text-opacity));
  }
}
.text-pink-700{
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-pink-700{
    color: rgb(190 24 93 / var(--tw-text-opacity));
  }
}
.text-pink-800{
  --tw-text-opacity: 1;
  color: rgb(157 23 77 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-pink-800{
    color: rgb(157 23 77 / var(--tw-text-opacity));
  }
}
.text-pink-900{
  --tw-text-opacity: 1;
  color: rgb(131 24 67 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-pink-900{
    color: rgb(131 24 67 / var(--tw-text-opacity));
  }
}
.text-purple-100{
  --tw-text-opacity: 1;
  color: rgb(243 232 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-purple-100{
    color: rgb(243 232 255 / var(--tw-text-opacity));
  }
}
.text-purple-200{
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-purple-200{
    color: rgb(233 213 255 / var(--tw-text-opacity));
  }
}
.text-purple-300{
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-purple-300{
    color: rgb(216 180 254 / var(--tw-text-opacity));
  }
}
.text-purple-400{
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-purple-400{
    color: rgb(192 132 252 / var(--tw-text-opacity));
  }
}
.text-purple-50{
  --tw-text-opacity: 1;
  color: rgb(250 245 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-purple-50{
    color: rgb(250 245 255 / var(--tw-text-opacity));
  }
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-purple-500{
    color: rgb(168 85 247 / var(--tw-text-opacity));
  }
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-purple-600{
    color: rgb(147 51 234 / var(--tw-text-opacity));
  }
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-purple-700{
    color: rgb(126 34 206 / var(--tw-text-opacity));
  }
}
.text-purple-800{
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-purple-800{
    color: rgb(107 33 168 / var(--tw-text-opacity));
  }
}
.text-purple-900{
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-purple-900{
    color: rgb(88 28 135 / var(--tw-text-opacity));
  }
}
.text-red-100{
  --tw-text-opacity: 1;
  color: rgb(254 226 226 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-red-100{
    color: rgb(254 226 226 / var(--tw-text-opacity));
  }
}
.text-red-200{
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-red-200{
    color: rgb(254 202 202 / var(--tw-text-opacity));
  }
}
.text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-red-300{
    color: rgb(252 165 165 / var(--tw-text-opacity));
  }
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-red-400{
    color: rgb(248 113 113 / var(--tw-text-opacity));
  }
}
.text-red-50{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-red-50{
    color: rgb(254 242 242 / var(--tw-text-opacity));
  }
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-red-500{
    color: rgb(239 68 68 / var(--tw-text-opacity));
  }
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-red-600{
    color: rgb(220 38 38 / var(--tw-text-opacity));
  }
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-red-700{
    color: rgb(185 28 28 / var(--tw-text-opacity));
  }
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-red-800{
    color: rgb(153 27 27 / var(--tw-text-opacity));
  }
}
.text-red-900{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-red-900{
    color: rgb(127 29 29 / var(--tw-text-opacity));
  }
}
.text-rose-100{
  --tw-text-opacity: 1;
  color: rgb(255 228 230 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-rose-100{
    color: rgb(255 228 230 / var(--tw-text-opacity));
  }
}
.text-rose-200{
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-rose-200{
    color: rgb(254 205 211 / var(--tw-text-opacity));
  }
}
.text-rose-300{
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-rose-300{
    color: rgb(253 164 175 / var(--tw-text-opacity));
  }
}
.text-rose-400{
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-rose-400{
    color: rgb(251 113 133 / var(--tw-text-opacity));
  }
}
.text-rose-50{
  --tw-text-opacity: 1;
  color: rgb(255 241 242 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-rose-50{
    color: rgb(255 241 242 / var(--tw-text-opacity));
  }
}
.text-rose-500{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-rose-500{
    color: rgb(244 63 94 / var(--tw-text-opacity));
  }
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-rose-600{
    color: rgb(225 29 72 / var(--tw-text-opacity));
  }
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-rose-700{
    color: rgb(190 18 60 / var(--tw-text-opacity));
  }
}
.text-rose-800{
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-rose-800{
    color: rgb(159 18 57 / var(--tw-text-opacity));
  }
}
.text-rose-900{
  --tw-text-opacity: 1;
  color: rgb(136 19 55 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-rose-900{
    color: rgb(136 19 55 / var(--tw-text-opacity));
  }
}
.text-sky-100{
  --tw-text-opacity: 1;
  color: rgb(224 242 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-sky-100{
    color: rgb(224 242 254 / var(--tw-text-opacity));
  }
}
.text-sky-200{
  --tw-text-opacity: 1;
  color: rgb(186 230 253 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-sky-200{
    color: rgb(186 230 253 / var(--tw-text-opacity));
  }
}
.text-sky-300{
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-sky-300{
    color: rgb(125 211 252 / var(--tw-text-opacity));
  }
}
.text-sky-400{
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-sky-400{
    color: rgb(56 189 248 / var(--tw-text-opacity));
  }
}
.text-sky-50{
  --tw-text-opacity: 1;
  color: rgb(240 249 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-sky-50{
    color: rgb(240 249 255 / var(--tw-text-opacity));
  }
}
.text-sky-500{
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-sky-500{
    color: rgb(14 165 233 / var(--tw-text-opacity));
  }
}
.text-sky-600{
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-sky-600{
    color: rgb(2 132 199 / var(--tw-text-opacity));
  }
}
.text-sky-700{
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-sky-700{
    color: rgb(3 105 161 / var(--tw-text-opacity));
  }
}
.text-sky-800{
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-sky-800{
    color: rgb(7 89 133 / var(--tw-text-opacity));
  }
}
.text-sky-900{
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-sky-900{
    color: rgb(12 74 110 / var(--tw-text-opacity));
  }
}
.text-slate-100{
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-slate-100{
    color: rgb(241 245 249 / var(--tw-text-opacity));
  }
}
.text-slate-200{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-slate-200{
    color: rgb(226 232 240 / var(--tw-text-opacity));
  }
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-slate-300{
    color: rgb(203 213 225 / var(--tw-text-opacity));
  }
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-slate-400{
    color: rgb(148 163 184 / var(--tw-text-opacity));
  }
}
.text-slate-50{
  --tw-text-opacity: 1;
  color: rgb(248 250 252 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-slate-50{
    color: rgb(248 250 252 / var(--tw-text-opacity));
  }
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-slate-500{
    color: rgb(100 116 139 / var(--tw-text-opacity));
  }
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-slate-600{
    color: rgb(71 85 105 / var(--tw-text-opacity));
  }
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-slate-700{
    color: rgb(51 65 85 / var(--tw-text-opacity));
  }
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-slate-800{
    color: rgb(30 41 59 / var(--tw-text-opacity));
  }
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-slate-900{
    color: rgb(15 23 42 / var(--tw-text-opacity));
  }
}
.text-stone-100{
  --tw-text-opacity: 1;
  color: rgb(245 245 244 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-stone-100{
    color: rgb(245 245 244 / var(--tw-text-opacity));
  }
}
.text-stone-200{
  --tw-text-opacity: 1;
  color: rgb(231 229 228 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-stone-200{
    color: rgb(231 229 228 / var(--tw-text-opacity));
  }
}
.text-stone-300{
  --tw-text-opacity: 1;
  color: rgb(214 211 209 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-stone-300{
    color: rgb(214 211 209 / var(--tw-text-opacity));
  }
}
.text-stone-400{
  --tw-text-opacity: 1;
  color: rgb(168 162 158 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-stone-400{
    color: rgb(168 162 158 / var(--tw-text-opacity));
  }
}
.text-stone-50{
  --tw-text-opacity: 1;
  color: rgb(250 250 249 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-stone-50{
    color: rgb(250 250 249 / var(--tw-text-opacity));
  }
}
.text-stone-500{
  --tw-text-opacity: 1;
  color: rgb(120 113 108 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-stone-500{
    color: rgb(120 113 108 / var(--tw-text-opacity));
  }
}
.text-stone-600{
  --tw-text-opacity: 1;
  color: rgb(87 83 78 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-stone-600{
    color: rgb(87 83 78 / var(--tw-text-opacity));
  }
}
.text-stone-700{
  --tw-text-opacity: 1;
  color: rgb(68 64 60 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-stone-700{
    color: rgb(68 64 60 / var(--tw-text-opacity));
  }
}
.text-stone-800{
  --tw-text-opacity: 1;
  color: rgb(41 37 36 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-stone-800{
    color: rgb(41 37 36 / var(--tw-text-opacity));
  }
}
.text-stone-900{
  --tw-text-opacity: 1;
  color: rgb(28 25 23 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-stone-900{
    color: rgb(28 25 23 / var(--tw-text-opacity));
  }
}
.text-teal-100{
  --tw-text-opacity: 1;
  color: rgb(204 251 241 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-teal-100{
    color: rgb(204 251 241 / var(--tw-text-opacity));
  }
}
.text-teal-200{
  --tw-text-opacity: 1;
  color: rgb(153 246 228 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-teal-200{
    color: rgb(153 246 228 / var(--tw-text-opacity));
  }
}
.text-teal-300{
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-teal-300{
    color: rgb(94 234 212 / var(--tw-text-opacity));
  }
}
.text-teal-400{
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-teal-400{
    color: rgb(45 212 191 / var(--tw-text-opacity));
  }
}
.text-teal-50{
  --tw-text-opacity: 1;
  color: rgb(240 253 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-teal-50{
    color: rgb(240 253 250 / var(--tw-text-opacity));
  }
}
.text-teal-500{
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-teal-500{
    color: rgb(20 184 166 / var(--tw-text-opacity));
  }
}
.text-teal-600{
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-teal-600{
    color: rgb(13 148 136 / var(--tw-text-opacity));
  }
}
.text-teal-700{
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-teal-700{
    color: rgb(15 118 110 / var(--tw-text-opacity));
  }
}
.text-teal-800{
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-teal-800{
    color: rgb(17 94 89 / var(--tw-text-opacity));
  }
}
.text-teal-900{
  --tw-text-opacity: 1;
  color: rgb(19 78 74 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-teal-900{
    color: rgb(19 78 74 / var(--tw-text-opacity));
  }
}
.text-transparent{
  color: transparent;
}
.text-violet-100{
  --tw-text-opacity: 1;
  color: rgb(237 233 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-violet-100{
    color: rgb(237 233 254 / var(--tw-text-opacity));
  }
}
.text-violet-200{
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-violet-200{
    color: rgb(221 214 254 / var(--tw-text-opacity));
  }
}
.text-violet-300{
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-violet-300{
    color: rgb(196 181 253 / var(--tw-text-opacity));
  }
}
.text-violet-400{
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-violet-400{
    color: rgb(167 139 250 / var(--tw-text-opacity));
  }
}
.text-violet-50{
  --tw-text-opacity: 1;
  color: rgb(245 243 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-violet-50{
    color: rgb(245 243 255 / var(--tw-text-opacity));
  }
}
.text-violet-500{
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-violet-500{
    color: rgb(139 92 246 / var(--tw-text-opacity));
  }
}
.text-violet-600{
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-violet-600{
    color: rgb(124 58 237 / var(--tw-text-opacity));
  }
}
.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-violet-700{
    color: rgb(109 40 217 / var(--tw-text-opacity));
  }
}
.text-violet-800{
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-violet-800{
    color: rgb(91 33 182 / var(--tw-text-opacity));
  }
}
.text-violet-900{
  --tw-text-opacity: 1;
  color: rgb(76 29 149 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-violet-900{
    color: rgb(76 29 149 / var(--tw-text-opacity));
  }
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-white{
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}
.text-yellow-100{
  --tw-text-opacity: 1;
  color: rgb(254 249 195 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-yellow-100{
    color: rgb(254 249 195 / var(--tw-text-opacity));
  }
}
.text-yellow-200{
  --tw-text-opacity: 1;
  color: rgb(254 240 138 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-yellow-200{
    color: rgb(254 240 138 / var(--tw-text-opacity));
  }
}
.text-yellow-300{
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-yellow-300{
    color: rgb(253 224 71 / var(--tw-text-opacity));
  }
}
.text-yellow-400{
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-yellow-400{
    color: rgb(250 204 21 / var(--tw-text-opacity));
  }
}
.text-yellow-50{
  --tw-text-opacity: 1;
  color: rgb(254 252 232 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-yellow-50{
    color: rgb(254 252 232 / var(--tw-text-opacity));
  }
}
.text-yellow-500{
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-yellow-500{
    color: rgb(234 179 8 / var(--tw-text-opacity));
  }
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-yellow-600{
    color: rgb(202 138 4 / var(--tw-text-opacity));
  }
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-yellow-700{
    color: rgb(161 98 7 / var(--tw-text-opacity));
  }
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-yellow-800{
    color: rgb(133 77 14 / var(--tw-text-opacity));
  }
}
.text-yellow-900{
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-yellow-900{
    color: rgb(113 63 18 / var(--tw-text-opacity));
  }
}
.text-zinc-100{
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-zinc-100{
    color: rgb(244 244 245 / var(--tw-text-opacity));
  }
}
.text-zinc-200{
  --tw-text-opacity: 1;
  color: rgb(228 228 231 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-zinc-200{
    color: rgb(228 228 231 / var(--tw-text-opacity));
  }
}
.text-zinc-300{
  --tw-text-opacity: 1;
  color: rgb(212 212 216 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-zinc-300{
    color: rgb(212 212 216 / var(--tw-text-opacity));
  }
}
.text-zinc-400{
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-zinc-400{
    color: rgb(161 161 170 / var(--tw-text-opacity));
  }
}
.text-zinc-50{
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-zinc-50{
    color: rgb(250 250 250 / var(--tw-text-opacity));
  }
}
.text-zinc-500{
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-zinc-500{
    color: rgb(113 113 122 / var(--tw-text-opacity));
  }
}
.text-zinc-600{
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-zinc-600{
    color: rgb(82 82 91 / var(--tw-text-opacity));
  }
}
.text-zinc-700{
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-zinc-700{
    color: rgb(63 63 70 / var(--tw-text-opacity));
  }
}
.text-zinc-800{
  --tw-text-opacity: 1;
  color: rgb(39 39 42 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-zinc-800{
    color: rgb(39 39 42 / var(--tw-text-opacity));
  }
}
.text-zinc-900{
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / 1);
}
@supports (color: rgb(0 0 0 / 0)){
.text-zinc-900{
    color: rgb(24 24 27 / var(--tw-text-opacity));
  }
}
.text-opacity-50{
  --tw-text-opacity: 0.5;
}
.underline{
  text-decoration-line: underline;
}
.decoration-dotted{
  text-decoration-style: dotted;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-100{
  opacity: 1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_10px_38px_-10px_rgba\\(22\\2c _23\\2c _24\\2c _0\\.35\\)\\2c _0px_10px_20px_-15px_rgba\\(22\\2c _23\\2c _24\\2c _0\\.2\\)\\]{
  --tw-shadow: 0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2);
  --tw-shadow-colored: 0px 10px 38px -10px var(--tw-shadow-color), 0px 10px 20px -15px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, 0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-slate-950\\/5{
  --tw-shadow-color: rgb(2 6 23 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline{
  outline-style: solid;
}
.outline-dashed{
  outline-style: dashed;
}
.outline-1{
  outline-width: 1px;
}
.outline-offset-2{
  outline-offset: 2px;
}
.outline-slate-400{
  outline-color: #94a3b8;
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(1px + 0px) #2563eb, 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity));
}
.ring-opacity-10{
  --tw-ring-opacity: 0.1;
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: blur(64px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-lg{
  --tw-blur: blur(16px);
  filter: blur(16px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-xl{
  --tw-drop-shadow: drop-shadow(0 20px 13px rgb(0 0 0 / 0.03)) drop-shadow(0 8px 5px rgb(0 0 0 / 0.08));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 20px 13px rgb(0 0 0 / 0.03)) drop-shadow(0 8px 5px rgb(0 0 0 / 0.08));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: blur(4px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: blur(4px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[filter\\]{
  transition-property: filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-200{
  transition-delay: 200ms;
}
.duration-100{
  transition-duration: 100ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-\\[opacity\\2c transform\\]{
  will-change: opacity,transform;
}



.btn-indigo{
  font-feature-settings: 'ss01' 1, 'ss14' 1;
  border-radius: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-family: "Wallop", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-weight: 600;
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}



.btn-indigo:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #2563eb, 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 0.75;
}

.idtn-header-modal{
  font-feature-settings: 'ss01' 1, 'ss14' 1;
  font-family: "Wallop", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 700;
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}

@media (min-width: 768px){

  .idtn-header-modal{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}

/* Colors */

.idtn-primary-bg-color{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / 1);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-primary-bg-color{
    background-color: rgb(225 29 72 / var(--tw-bg-opacity));
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}

.idtn-primary-bg-color-elevated{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / 1);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-primary-bg-color-elevated{
    background-color: rgb(79 70 229 / var(--tw-bg-opacity));
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}

.idtn-secondary-bg-color{
  background-color: rgb(30 41 59 / 0.1);
  --tw-bg-opacity: 0.1;
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-secondary-bg-color{
    background-color: rgb(30 41 59 / var(--tw-bg-opacity));
    color: rgb(30 41 59 / var(--tw-text-opacity));
  }
}

/* Buttons */

.idtn-btn{
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  text-align: center;
  font-weight: 500;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.idtn-btn:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}


/* Buttons: Sizes */

.idtn-btn-sm{
  border-radius: 0.125rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.idtn-btn-md{
  border-radius: 0.375rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.idtn-btn-lg{
  border-radius: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

@media (min-width: 768px){

  .idtn-btn-lg{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

.idtn-btn-xl{
  border-radius: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

@media (min-width: 768px){

  .idtn-btn-xl{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}



.idtn-btn-circle {

  /*button */

  cursor: pointer;

  -webkit-user-select: none;

     -moz-user-select: none;

          user-select: none;

  outline: 2px solid transparent;

  outline-offset: 2px;

}



.idtn-btn-circle:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}



.idtn-btn-circle{
  display: flex;
  height: 5rem;
  width: 5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border-width: 4px;
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / 1);
  background-image: conic-gradient(at left, var(--tw-gradient-stops));
  --tw-gradient-from: #e11d48 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(225 29 72 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-stops: var(--tw-gradient-from), #db2777 var(--tw-gradient-via-position), var(--tw-gradient-to);
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
  padding: 1.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}



@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-circle{
    border-color: rgb(255 255 255 / var(--tw-border-opacity));
    --tw-gradient-to: rgb(219 39 119 / 0)  var(--tw-gradient-to-position);
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}



.idtn-btn-circle:hover{
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.25) scaleY(1.25);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}



.idtn-btn-circle:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 224 71 / var(--tw-ring-opacity));
}



.idtn-btn-circle:active{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}



@media (min-width: 768px){

  .idtn-btn-circle{
    height: 6rem;
    width: 6rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}



.idtn-btn-circle {

  /* Beveled Border Effect */
  box-shadow: inset 0 1px 2px rgba(255, 255, 0, 0.3), 0 2px 6px rgba(0, 0, 0, 0.3);

}

.idtn-btn-floating {

/*button */

cursor: pointer;

-webkit-user-select: none;

   -moz-user-select: none;

        user-select: none;

outline: 2px solid transparent;

outline-offset: 2px;

}

.idtn-btn-floating:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-floating{
  display: flex;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(225 29 72 / 1);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / 1);
  padding: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / 1);
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-floating{
    border-color: rgb(225 29 72 / var(--tw-border-opacity));
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
    color: rgb(225 29 72 / var(--tw-text-opacity));
  }
}

.idtn-btn-floating:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 224 71 / var(--tw-ring-opacity));
}

.idtn-btn-floating:active{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@media (min-width: 768px){

  .idtn-btn-floating{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .idtn-btn-floating:hover{
    --tw-scale-x: 1.25;
    --tw-scale-y: 1.25;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.25) scaleY(1.25);
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}

.idtn-btn-floating {

/* Beveled Border Effect */
box-shadow: inset 0 1px 2px rgba(255, 255, 0, 0.3), 0 2px 6px rgba(0, 0, 0, 0.3);

}


/* Buttons: Colors */


.idtn-btn-naked{
  border-width: 0px;
  background-color: rgb(241 245 249 / 0);
  --tw-bg-opacity: 0;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}


@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-naked{
    background-color: rgb(241 245 249 / var(--tw-bg-opacity));
  }
}


.idtn-btn-naked:hover{
  --tw-bg-opacity: 1;
}


.idtn-btn-naked:focus{
  border-width: 0px;
}


.idtn-btn-naked:active{
  border-width: 0px;
  --tw-bg-opacity: 1;
}

.idtn-btn-secondary{
  background-color: rgb(30 41 59 / 0.1);
  --tw-bg-opacity: 0.1;
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / 1);
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  text-align: center;
  font-weight: 500;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-secondary{
    background-color: rgb(30 41 59 / var(--tw-bg-opacity));
    color: rgb(30 41 59 / var(--tw-text-opacity));
  }
}

.idtn-btn-secondary:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-secondary:hover{
  opacity: 0.8;
}

.idtn-btn-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / 1);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  text-align: center;
  font-weight: 500;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-primary{
    background-color: rgb(225 29 72 / var(--tw-bg-opacity));
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}

.idtn-btn-primary:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-primary:hover{
  --tw-shadow-color: #f43f5e;
  --tw-shadow: var(--tw-shadow-colored);
  --tw-drop-shadow: drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.idtn-btn-primary-elevated{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / 1);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  text-align: center;
  font-weight: 500;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-primary-elevated{
    background-color: rgb(79 70 229 / var(--tw-bg-opacity));
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}

.idtn-btn-primary-elevated:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-primary-elevated:hover{
  --tw-shadow-color: #6366f1;
  --tw-shadow: var(--tw-shadow-colored);
  --tw-drop-shadow: drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

/* Buttons: Composites */

.idtn-btn-naked-sm{
  border-radius: 0.125rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  border-width: 0px;
  background-color: rgb(241 245 249 / 0);
  --tw-bg-opacity: 0;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-naked-sm{
    background-color: rgb(241 245 249 / var(--tw-bg-opacity));
  }
}

.idtn-btn-naked-sm:hover{
  --tw-bg-opacity: 1;
}

.idtn-btn-naked-sm:focus{
  border-width: 0px;
}

.idtn-btn-naked-sm:active{
  border-width: 0px;
  --tw-bg-opacity: 1;
}

.idtn-btn-naked-md{
  border-radius: 0.375rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  border-width: 0px;
  background-color: rgb(241 245 249 / 0);
  --tw-bg-opacity: 0;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-naked-md{
    background-color: rgb(241 245 249 / var(--tw-bg-opacity));
  }
}

.idtn-btn-naked-md:hover{
  --tw-bg-opacity: 1;
}

.idtn-btn-naked-md:focus{
  border-width: 0px;
}

.idtn-btn-naked-md:active{
  border-width: 0px;
  --tw-bg-opacity: 1;
}

.idtn-btn-secondary-md{
  border-radius: 0.375rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  background-color: rgb(30 41 59 / 0.1);
  --tw-bg-opacity: 0.1;
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / 1);
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  text-align: center;
  font-weight: 500;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-secondary-md{
    background-color: rgb(30 41 59 / var(--tw-bg-opacity));
    color: rgb(30 41 59 / var(--tw-text-opacity));
  }
}

.idtn-btn-secondary-md:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-secondary-md:hover{
  opacity: 0.8;
}

.idtn-btn-secondary-sm{
  border-radius: 0.125rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  background-color: rgb(30 41 59 / 0.1);
  --tw-bg-opacity: 0.1;
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / 1);
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  text-align: center;
  font-weight: 500;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-secondary-sm{
    background-color: rgb(30 41 59 / var(--tw-bg-opacity));
    color: rgb(30 41 59 / var(--tw-text-opacity));
  }
}

.idtn-btn-secondary-sm:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-secondary-sm:hover{
  opacity: 0.8;
}

.idtn-btn-primary-md{
  border-radius: 0.375rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / 1);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  text-align: center;
  font-weight: 500;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-primary-md{
    background-color: rgb(225 29 72 / var(--tw-bg-opacity));
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}

.idtn-btn-primary-md:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-primary-md:hover{
  --tw-shadow-color: #f43f5e;
  --tw-shadow: var(--tw-shadow-colored);
  --tw-drop-shadow: drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.idtn-btn-primary-circle {

  /*button */

  cursor: pointer;

  -webkit-user-select: none;

     -moz-user-select: none;

          user-select: none;

  outline: 2px solid transparent;

  outline-offset: 2px;

}

.idtn-btn-primary-circle:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-primary-circle{
  display: flex;
  height: 5rem;
  width: 5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border-width: 4px;
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / 1);
  background-image: conic-gradient(at left, var(--tw-gradient-stops));
  --tw-gradient-from: #e11d48 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(225 29 72 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-stops: var(--tw-gradient-from), #db2777 var(--tw-gradient-via-position), var(--tw-gradient-to);
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
  padding: 1.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-primary-circle{
    border-color: rgb(255 255 255 / var(--tw-border-opacity));
    --tw-gradient-to: rgb(219 39 119 / 0)  var(--tw-gradient-to-position);
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}

.idtn-btn-primary-circle:hover{
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.25) scaleY(1.25);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.idtn-btn-primary-circle:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 224 71 / var(--tw-ring-opacity));
}

.idtn-btn-primary-circle:active{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@media (min-width: 768px){

  .idtn-btn-primary-circle{
    height: 6rem;
    width: 6rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

.idtn-btn-primary-circle {

  /* Beveled Border Effect */
  box-shadow: inset 0 1px 2px rgba(255, 255, 0, 0.3), 0 2px 6px rgba(0, 0, 0, 0.3);

}

.idtn-btn-primary-elevated-md{
  border-radius: 0.375rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / 1);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  text-align: center;
  font-weight: 500;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-primary-elevated-md{
    background-color: rgb(79 70 229 / var(--tw-bg-opacity));
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}

.idtn-btn-primary-elevated-md:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-primary-elevated-md:hover{
  --tw-shadow-color: #6366f1;
  --tw-shadow: var(--tw-shadow-colored);
  --tw-drop-shadow: drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.idtn-btn-secondary-lg{
  border-radius: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

@media (min-width: 768px){

  .idtn-btn-secondary-lg{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

.idtn-btn-secondary-lg{
  background-color: rgb(30 41 59 / 0.1);
  --tw-bg-opacity: 0.1;
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / 1);
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  text-align: center;
  font-weight: 500;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-secondary-lg{
    background-color: rgb(30 41 59 / var(--tw-bg-opacity));
    color: rgb(30 41 59 / var(--tw-text-opacity));
  }
}

.idtn-btn-secondary-lg:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-secondary-lg:hover{
  opacity: 0.8;
}

.idtn-btn-primary-lg{
  border-radius: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

@media (min-width: 768px){

  .idtn-btn-primary-lg{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

.idtn-btn-primary-lg{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / 1);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  text-align: center;
  font-weight: 500;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-primary-lg{
    background-color: rgb(225 29 72 / var(--tw-bg-opacity));
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}

.idtn-btn-primary-lg:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-primary-lg:hover{
  --tw-shadow-color: #f43f5e;
  --tw-shadow: var(--tw-shadow-colored);
  --tw-drop-shadow: drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.idtn-btn-primary-elevated-lg{
  border-radius: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

@media (min-width: 768px){

  .idtn-btn-primary-elevated-lg{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

.idtn-btn-primary-elevated-lg{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / 1);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  text-align: center;
  font-weight: 500;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-primary-elevated-lg{
    background-color: rgb(79 70 229 / var(--tw-bg-opacity));
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}

.idtn-btn-primary-elevated-lg:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-primary-elevated-lg:hover{
  --tw-shadow-color: #6366f1;
  --tw-shadow: var(--tw-shadow-colored);
  --tw-drop-shadow: drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.idtn-btn-secondary-xl{
  border-radius: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

@media (min-width: 768px){

  .idtn-btn-secondary-xl{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

.idtn-btn-secondary-xl{
  background-color: rgb(30 41 59 / 0.1);
  --tw-bg-opacity: 0.1;
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / 1);
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  text-align: center;
  font-weight: 500;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-secondary-xl{
    background-color: rgb(30 41 59 / var(--tw-bg-opacity));
    color: rgb(30 41 59 / var(--tw-text-opacity));
  }
}

.idtn-btn-secondary-xl:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-secondary-xl:hover{
  opacity: 0.8;
}

.idtn-btn-primary-xl{
  border-radius: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

@media (min-width: 768px){

  .idtn-btn-primary-xl{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

.idtn-btn-primary-xl{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / 1);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  text-align: center;
  font-weight: 500;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-primary-xl{
    background-color: rgb(225 29 72 / var(--tw-bg-opacity));
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}

.idtn-btn-primary-xl:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-primary-xl:hover{
  --tw-shadow-color: #f43f5e;
  --tw-shadow: var(--tw-shadow-colored);
  --tw-drop-shadow: drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.idtn-btn-primary-elevated-xl{
  border-radius: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

@media (min-width: 768px){

  .idtn-btn-primary-elevated-xl{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

.idtn-btn-primary-elevated-xl{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / 1);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  text-align: center;
  font-weight: 500;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-primary-elevated-xl{
    background-color: rgb(79 70 229 / var(--tw-bg-opacity));
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}

.idtn-btn-primary-elevated-xl:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.idtn-btn-primary-elevated-xl:hover{
  --tw-shadow-color: #6366f1;
  --tw-shadow: var(--tw-shadow-colored);
  --tw-drop-shadow: drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 0 5px rgba(244,63,94,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.idtn-btn-google-xl{
  margin-bottom: 0.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(66 133 244 / 1);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: center;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-btn-google-xl{
    background-color: rgb(66 133 244 / var(--tw-bg-opacity));
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}

.idtn-btn-google-xl:hover{
  background-color: rgb(66 133 244 / 0.9);
}

.idtn-btn-google-xl:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(66 133 244 / 0.5);
}

.idtn-btn-google-xl:disabled{
  cursor: not-allowed;
  background-color: rgb(66 133 244 / 0.7);
}

@media (min-width: 768px){

  .idtn-btn-google-xl{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

/* Inputs */

.textarea{
  display: block;
  width: 100%;
  border-radius: 0.375rem;
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / 1);
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@supports (color: rgb(0 0 0 / 0)){
.textarea{
    border-color: rgb(203 213 225 / var(--tw-border-opacity));
  }
}

.textarea:focus{
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / 1);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(79 70 229 / var(--tw-ring-opacity));
}

@supports (color: rgb(0 0 0 / 0)){
.textarea:focus{
    border-color: rgb(79 70 229 / var(--tw-border-opacity));
  }
}

.input{
  display: block;
  width: 100%;
  border-radius: 0.375rem;
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / 1);
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@supports (color: rgb(0 0 0 / 0)){
.input{
    border-color: rgb(203 213 225 / var(--tw-border-opacity));
  }
}

.input:focus{
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / 1);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(79 70 229 / var(--tw-ring-opacity));
}

@supports (color: rgb(0 0 0 / 0)){
.input:focus{
    border-color: rgb(79 70 229 / var(--tw-border-opacity));
  }
}

/* Labels */

.idtn-label{
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  line-height: 1.25rem;
  letter-spacing: 0.05em;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / 1);
  opacity: 0.5;
}

@supports (color: rgb(0 0 0 / 0)){
.idtn-label{
    color: rgb(17 24 39 / var(--tw-text-opacity));
  }
}

@media (min-width: 768px){

  .idtn-label{
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

/* Radix styles */

/* Tabs */

.tabs-list{
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / 1);
  padding: 0.25rem;
}

@supports (color: rgb(0 0 0 / 0)){
.tabs-list{
    border-color: rgb(229 231 235 / var(--tw-border-opacity));
  }
}

@media (min-width: 768px){

  .tabs-list > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * 0);
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - 0));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .tabs-list{
    padding: 1rem;
  }
}

.tabs-trigger{
  margin: 0.25rem;
  display: flex;
  height: 35px;
  flex: 1 1;
  cursor: default;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / 1);
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 1;
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / 1);
  outline: 2px solid transparent;
  outline-offset: 2px;
}

@supports (color: rgb(0 0 0 / 0)){
.tabs-trigger{
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
    color: rgb(30 41 59 / var(--tw-text-opacity));
  }
}

.tabs-trigger:hover{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.tabs-trigger:hover{
    color: rgb(71 85 105 / var(--tw-text-opacity));
  }
}

.tabs-trigger[data-state=active]{
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / 1);
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.tabs-trigger[data-state=active]{
    background-color: rgb(199 210 254 / var(--tw-bg-opacity));
    color: rgb(55 48 163 / var(--tw-text-opacity));
  }
}

.tabs-trigger:focus[data-state=active]{
  position: relative;
}

@media (min-width: 768px){

  .tabs-trigger{
    margin: 0px;
    height: 45px;
    padding-left: 2rem;
    padding-right: 2rem;
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

/* Drop-down */

.nav-dropdown-item{
  display: flex;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  align-items: center;
  padding-right: 0.25rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.nav-dropdown-item[data-disabled]{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.nav-dropdown-item[data-disabled]{
    color: rgb(71 85 105 / var(--tw-text-opacity));
  }
}

@media (min-width: 640px){

  .sm\\:prose-sm{
    font-size: 0.875rem;
    line-height: 1.7142857;
  }

  .sm\\:prose-sm :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .sm\\:prose-sm :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 1.2857143em;
    line-height: 1.5555556;
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .sm\\:prose-sm :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
    padding-inline-start: 1.1111111em;
  }

  .sm\\:prose-sm :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 2.1428571em;
    margin-top: 0;
    margin-bottom: 0.8em;
    line-height: 1.2;
  }

  .sm\\:prose-sm :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 1.4285714em;
    margin-top: 1.6em;
    margin-bottom: 0.8em;
    line-height: 1.4;
  }

  .sm\\:prose-sm :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 1.2857143em;
    margin-top: 1.5555556em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }

  .sm\\:prose-sm :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.4285714em;
    margin-bottom: 0.5714286em;
    line-height: 1.4285714;
  }

  .sm\\:prose-sm :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .sm\\:prose-sm :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .sm\\:prose-sm :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0;
    margin-bottom: 0;
  }

  .sm\\:prose-sm :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .sm\\:prose-sm :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 0.8571429em;
    border-radius: 0.3125rem;
    padding-top: 0.1428571em;
    padding-inline-end: 0.3571429em;
    padding-bottom: 0.1428571em;
    padding-inline-start: 0.3571429em;
  }

  .sm\\:prose-sm :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 0.8571429em;
  }

  .sm\\:prose-sm :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 0.9em;
  }

  .sm\\:prose-sm :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 0.8888889em;
  }

  .sm\\:prose-sm :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 0.8571429em;
    line-height: 1.6666667;
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    border-radius: 0.25rem;
    padding-top: 0.6666667em;
    padding-inline-end: 1em;
    padding-bottom: 0.6666667em;
    padding-inline-start: 1em;
  }

  .sm\\:prose-sm :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
    padding-inline-start: 1.5714286em;
  }

  .sm\\:prose-sm :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
    padding-inline-start: 1.5714286em;
  }

  .sm\\:prose-sm :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0.2857143em;
    margin-bottom: 0.2857143em;
  }

  .sm\\:prose-sm :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-inline-start: 0.4285714em;
  }

  .sm\\:prose-sm :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-inline-start: 0.4285714em;
  }

  .sm\\:prose-sm :where(.sm\\:prose-sm > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }

  .sm\\:prose-sm :where(.sm\\:prose-sm > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.1428571em;
  }

  .sm\\:prose-sm :where(.sm\\:prose-sm > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-bottom: 1.1428571em;
  }

  .sm\\:prose-sm :where(.sm\\:prose-sm > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.1428571em;
  }

  .sm\\:prose-sm :where(.sm\\:prose-sm > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-bottom: 1.1428571em;
  }

  .sm\\:prose-sm :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }

  .sm\\:prose-sm :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .sm\\:prose-sm :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.1428571em;
  }

  .sm\\:prose-sm :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0.2857143em;
    padding-inline-start: 1.5714286em;
  }

  .sm\\:prose-sm :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 2.8571429em;
    margin-bottom: 2.8571429em;
  }

  .sm\\:prose-sm :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0;
  }

  .sm\\:prose-sm :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0;
  }

  .sm\\:prose-sm :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0;
  }

  .sm\\:prose-sm :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0;
  }

  .sm\\:prose-sm :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 0.8571429em;
    line-height: 1.5;
  }

  .sm\\:prose-sm :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-inline-end: 1em;
    padding-bottom: 0.6666667em;
    padding-inline-start: 1em;
  }

  .sm\\:prose-sm :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-inline-start: 0;
  }

  .sm\\:prose-sm :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-inline-end: 0;
  }

  .sm\\:prose-sm :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-top: 0.6666667em;
    padding-inline-end: 1em;
    padding-bottom: 0.6666667em;
    padding-inline-start: 1em;
  }

  .sm\\:prose-sm :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-inline-start: 0;
  }

  .sm\\:prose-sm :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-inline-end: 0;
  }

  .sm\\:prose-sm :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .sm\\:prose-sm :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0;
    margin-bottom: 0;
  }

  .sm\\:prose-sm :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 0.8571429em;
    line-height: 1.3333333;
    margin-top: 0.6666667em;
  }

  .sm\\:prose-sm :where(.sm\\:prose-sm > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0;
  }

  .sm\\:prose-sm :where(.sm\\:prose-sm > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-bottom: 0;
  }
}

@media (min-width: 768px){

  .md\\:container{
    width: 100%;
  }

  @media (min-width: 640px){

    .md\\:container{
      max-width: 640px;
    }
  }

  @media (min-width: 768px){

    .md\\:container{
      max-width: 768px;
    }
  }

  @media (min-width: 1024px){

    .md\\:container{
      max-width: 1024px;
    }
  }

  @media (min-width: 1280px){

    .md\\:container{
      max-width: 1280px;
    }
  }

  @media (min-width: 1536px){

    .md\\:container{
      max-width: 1536px;
    }
  }

  .md\\:prose-base{
    font-size: 1rem;
    line-height: 1.75;
  }

  .md\\:prose-base :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .md\\:prose-base :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 1.25em;
    line-height: 1.6;
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .md\\:prose-base :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-inline-start: 1em;
  }

  .md\\:prose-base :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 2.25em;
    margin-top: 0;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }

  .md\\:prose-base :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 1.5em;
    margin-top: 2em;
    margin-bottom: 1em;
    line-height: 1.3333333;
  }

  .md\\:prose-base :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 1.25em;
    margin-top: 1.6em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }

  .md\\:prose-base :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    line-height: 1.5;
  }

  .md\\:prose-base :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .md\\:prose-base :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .md\\:prose-base :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0;
    margin-bottom: 0;
  }

  .md\\:prose-base :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .md\\:prose-base :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 0.875em;
    border-radius: 0.3125rem;
    padding-top: 0.1875em;
    padding-inline-end: 0.375em;
    padding-bottom: 0.1875em;
    padding-inline-start: 0.375em;
  }

  .md\\:prose-base :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 0.875em;
  }

  .md\\:prose-base :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 0.875em;
  }

  .md\\:prose-base :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 0.9em;
  }

  .md\\:prose-base :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 0.875em;
    line-height: 1.7142857;
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
    border-radius: 0.375rem;
    padding-top: 0.8571429em;
    padding-inline-end: 1.1428571em;
    padding-bottom: 0.8571429em;
    padding-inline-start: 1.1428571em;
  }

  .md\\:prose-base :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.25em;
    margin-bottom: 1.25em;
    padding-inline-start: 1.625em;
  }

  .md\\:prose-base :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.25em;
    margin-bottom: 1.25em;
    padding-inline-start: 1.625em;
  }

  .md\\:prose-base :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .md\\:prose-base :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-inline-start: 0.375em;
  }

  .md\\:prose-base :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-inline-start: 0.375em;
  }

  .md\\:prose-base :where(.md\\:prose-base > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }

  .md\\:prose-base :where(.md\\:prose-base > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.25em;
  }

  .md\\:prose-base :where(.md\\:prose-base > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-bottom: 1.25em;
  }

  .md\\:prose-base :where(.md\\:prose-base > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.25em;
  }

  .md\\:prose-base :where(.md\\:prose-base > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-bottom: 1.25em;
  }

  .md\\:prose-base :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }

  .md\\:prose-base :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .md\\:prose-base :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 1.25em;
  }

  .md\\:prose-base :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0.5em;
    padding-inline-start: 1.625em;
  }

  .md\\:prose-base :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .md\\:prose-base :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0;
  }

  .md\\:prose-base :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0;
  }

  .md\\:prose-base :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0;
  }

  .md\\:prose-base :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0;
  }

  .md\\:prose-base :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 0.875em;
    line-height: 1.7142857;
  }

  .md\\:prose-base :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-inline-end: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-inline-start: 0.5714286em;
  }

  .md\\:prose-base :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-inline-start: 0;
  }

  .md\\:prose-base :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-inline-end: 0;
  }

  .md\\:prose-base :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-top: 0.5714286em;
    padding-inline-end: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-inline-start: 0.5714286em;
  }

  .md\\:prose-base :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-inline-start: 0;
  }

  .md\\:prose-base :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    padding-inline-end: 0;
  }

  .md\\:prose-base :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .md\\:prose-base :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0;
    margin-bottom: 0;
  }

  .md\\:prose-base :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    font-size: 0.875em;
    line-height: 1.4285714;
    margin-top: 0.8571429em;
  }

  .md\\:prose-base :where(.md\\:prose-base > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-top: 0;
  }

  .md\\:prose-base :where(.md\\:prose-base > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
    margin-bottom: 0;
  }
}

@media (min-width: 1024px){

  .lg\\:container{
    width: 100%;
  }

  @media (min-width: 640px){

    .lg\\:container{
      max-width: 640px;
    }
  }

  @media (min-width: 768px){

    .lg\\:container{
      max-width: 768px;
    }
  }

  @media (min-width: 1024px){

    .lg\\:container{
      max-width: 1024px;
    }
  }

  @media (min-width: 1280px){

    .lg\\:container{
      max-width: 1280px;
    }
  }

  @media (min-width: 1536px){

    .lg\\:container{
      max-width: 1536px;
    }
  }
}

.before\\:h-5::before{
  content: var(--tw-content);
  height: 1.25rem;
}

.before\\:w-5::before{
  content: var(--tw-content);
  width: 1.25rem;
}

.before\\:rounded-full::before{
  content: var(--tw-content);
  border-radius: 9999px;
}

.before\\:bg-white::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.before\\:bg-white::before{
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }
}

.before\\:shadow-sm::before{
  content: var(--tw-content);
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.before\\:transition-transform::before{
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.before\\:duration-150::before{
  content: var(--tw-content);
  transition-duration: 150ms;
}

.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}

.checked\\:border-blue-600:checked{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.checked\\:border-blue-600:checked{
    border-color: rgb(37 99 235 / var(--tw-border-opacity));
  }
}

.checked\\:border-transparent:checked{
  border-color: transparent;
}

.checked\\:bg-blue-600:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.checked\\:bg-blue-600:checked{
    background-color: rgb(37 99 235 / var(--tw-bg-opacity));
  }
}

.hover\\:scale-100:hover{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-indigo-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:border-indigo-500:hover{
    border-color: rgb(99 102 241 / var(--tw-border-opacity));
  }
}

.hover\\:border-indigo-700:hover{
  --tw-border-opacity: 1;
  border-color: rgb(67 56 202 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:border-indigo-700:hover{
    border-color: rgb(67 56 202 / var(--tw-border-opacity));
  }
}

.hover\\:border-rose-700:hover{
  --tw-border-opacity: 1;
  border-color: rgb(190 18 60 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:border-rose-700:hover{
    border-color: rgb(190 18 60 / var(--tw-border-opacity));
  }
}

.hover\\:bg-amber-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-amber-100:hover{
    background-color: rgb(254 243 199 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-amber-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-amber-200:hover{
    background-color: rgb(253 230 138 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-amber-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(252 211 77 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-amber-300:hover{
    background-color: rgb(252 211 77 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-amber-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-amber-400:hover{
    background-color: rgb(251 191 36 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-amber-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-amber-50:hover{
    background-color: rgb(255 251 235 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-amber-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-amber-500:hover{
    background-color: rgb(245 158 11 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-amber-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-amber-600:hover{
    background-color: rgb(217 119 6 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-amber-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-amber-700:hover{
    background-color: rgb(180 83 9 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-amber-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(146 64 14 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-amber-800:hover{
    background-color: rgb(146 64 14 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-amber-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(120 53 15 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-amber-900:hover{
    background-color: rgb(120 53 15 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-black:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-black:hover{
    background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-blue-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-blue-100:hover{
    background-color: rgb(219 234 254 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-blue-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-blue-200:hover{
    background-color: rgb(191 219 254 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-blue-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-blue-300:hover{
    background-color: rgb(147 197 253 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-blue-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-blue-400:hover{
    background-color: rgb(96 165 250 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-blue-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-blue-50:hover{
    background-color: rgb(239 246 255 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-blue-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-blue-500:hover{
    background-color: rgb(59 130 246 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-blue-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-blue-600:hover{
    background-color: rgb(37 99 235 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-blue-700:hover{
    background-color: rgb(29 78 216 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-blue-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-blue-800:hover{
    background-color: rgb(30 64 175 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-blue-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-blue-900:hover{
    background-color: rgb(30 58 138 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-current:hover{
  background-color: currentColor;
}

.hover\\:bg-cyan-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-cyan-100:hover{
    background-color: rgb(207 250 254 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-cyan-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-cyan-200:hover{
    background-color: rgb(165 243 252 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-cyan-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(103 232 249 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-cyan-300:hover{
    background-color: rgb(103 232 249 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-cyan-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(34 211 238 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-cyan-400:hover{
    background-color: rgb(34 211 238 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-cyan-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-cyan-50:hover{
    background-color: rgb(236 254 255 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-cyan-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-cyan-500:hover{
    background-color: rgb(6 182 212 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-cyan-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-cyan-600:hover{
    background-color: rgb(8 145 178 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-cyan-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-cyan-700:hover{
    background-color: rgb(14 116 144 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-cyan-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 94 117 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-cyan-800:hover{
    background-color: rgb(21 94 117 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-cyan-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(22 78 99 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-cyan-900:hover{
    background-color: rgb(22 78 99 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-emerald-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-emerald-100:hover{
    background-color: rgb(209 250 229 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-emerald-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-emerald-200:hover{
    background-color: rgb(167 243 208 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-emerald-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(110 231 183 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-emerald-300:hover{
    background-color: rgb(110 231 183 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-emerald-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-emerald-400:hover{
    background-color: rgb(52 211 153 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-emerald-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-emerald-50:hover{
    background-color: rgb(236 253 245 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-emerald-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-emerald-500:hover{
    background-color: rgb(16 185 129 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-emerald-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-emerald-600:hover{
    background-color: rgb(5 150 105 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-emerald-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-emerald-700:hover{
    background-color: rgb(4 120 87 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-emerald-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(6 95 70 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-emerald-800:hover{
    background-color: rgb(6 95 70 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-emerald-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(6 78 59 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-emerald-900:hover{
    background-color: rgb(6 78 59 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-fuchsia-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 232 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-fuchsia-100:hover{
    background-color: rgb(250 232 255 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-fuchsia-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 208 254 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-fuchsia-200:hover{
    background-color: rgb(245 208 254 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-fuchsia-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 171 252 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-fuchsia-300:hover{
    background-color: rgb(240 171 252 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-fuchsia-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(232 121 249 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-fuchsia-400:hover{
    background-color: rgb(232 121 249 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-fuchsia-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 244 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-fuchsia-50:hover{
    background-color: rgb(253 244 255 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-fuchsia-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-fuchsia-500:hover{
    background-color: rgb(217 70 239 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-fuchsia-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(192 38 211 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-fuchsia-600:hover{
    background-color: rgb(192 38 211 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-fuchsia-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(162 28 175 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-fuchsia-700:hover{
    background-color: rgb(162 28 175 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-fuchsia-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(134 25 143 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-fuchsia-800:hover{
    background-color: rgb(134 25 143 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-fuchsia-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(112 26 117 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-fuchsia-900:hover{
    background-color: rgb(112 26 117 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-gray-100:hover{
    background-color: rgb(243 244 246 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-gray-200:hover{
    background-color: rgb(229 231 235 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-gray-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-gray-300:hover{
    background-color: rgb(209 213 219 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-gray-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-gray-400:hover{
    background-color: rgb(156 163 175 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-gray-50:hover{
    background-color: rgb(249 250 251 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-gray-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-gray-500:hover{
    background-color: rgb(107 114 128 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-gray-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-gray-600:hover{
    background-color: rgb(75 85 99 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-gray-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-gray-700:hover{
    background-color: rgb(55 65 81 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-gray-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-gray-800:hover{
    background-color: rgb(31 41 55 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-gray-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-gray-900:hover{
    background-color: rgb(17 24 39 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-green-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-green-100:hover{
    background-color: rgb(220 252 231 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-green-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-green-200:hover{
    background-color: rgb(187 247 208 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-green-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-green-300:hover{
    background-color: rgb(134 239 172 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-green-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-green-400:hover{
    background-color: rgb(74 222 128 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-green-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-green-50:hover{
    background-color: rgb(240 253 244 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-green-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-green-500:hover{
    background-color: rgb(34 197 94 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-green-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-green-600:hover{
    background-color: rgb(22 163 74 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-green-700:hover{
    background-color: rgb(21 128 61 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-green-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(22 101 52 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-green-800:hover{
    background-color: rgb(22 101 52 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-green-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(20 83 45 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-green-900:hover{
    background-color: rgb(20 83 45 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-indigo-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-indigo-100:hover{
    background-color: rgb(224 231 255 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-indigo-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-indigo-200:hover{
    background-color: rgb(199 210 254 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-indigo-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(165 180 252 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-indigo-300:hover{
    background-color: rgb(165 180 252 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-indigo-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-indigo-400:hover{
    background-color: rgb(129 140 248 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-indigo-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-indigo-50:hover{
    background-color: rgb(238 242 255 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-indigo-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-indigo-500:hover{
    background-color: rgb(99 102 241 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-indigo-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-indigo-600:hover{
    background-color: rgb(79 70 229 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-indigo-700:hover{
    background-color: rgb(67 56 202 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-indigo-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(55 48 163 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-indigo-800:hover{
    background-color: rgb(55 48 163 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-indigo-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(49 46 129 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-indigo-900:hover{
    background-color: rgb(49 46 129 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-inherit:hover{
  background-color: inherit;
}

.hover\\:bg-lime-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-lime-100:hover{
    background-color: rgb(236 252 203 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-lime-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-lime-200:hover{
    background-color: rgb(217 249 157 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-lime-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(190 242 100 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-lime-300:hover{
    background-color: rgb(190 242 100 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-lime-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(163 230 53 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-lime-400:hover{
    background-color: rgb(163 230 53 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-lime-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(247 254 231 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-lime-50:hover{
    background-color: rgb(247 254 231 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-lime-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(132 204 22 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-lime-500:hover{
    background-color: rgb(132 204 22 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-lime-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-lime-600:hover{
    background-color: rgb(101 163 13 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-lime-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(77 124 15 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-lime-700:hover{
    background-color: rgb(77 124 15 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-lime-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(63 98 18 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-lime-800:hover{
    background-color: rgb(63 98 18 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-lime-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(54 83 20 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-lime-900:hover{
    background-color: rgb(54 83 20 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-neutral-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-neutral-100:hover{
    background-color: rgb(245 245 245 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-neutral-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 229 229 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-neutral-200:hover{
    background-color: rgb(229 229 229 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-neutral-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-neutral-300:hover{
    background-color: rgb(212 212 212 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-neutral-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(163 163 163 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-neutral-400:hover{
    background-color: rgb(163 163 163 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-neutral-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-neutral-50:hover{
    background-color: rgb(250 250 250 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-neutral-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(115 115 115 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-neutral-500:hover{
    background-color: rgb(115 115 115 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-neutral-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 82 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-neutral-600:hover{
    background-color: rgb(82 82 82 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-neutral-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-neutral-700:hover{
    background-color: rgb(64 64 64 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-neutral-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-neutral-800:hover{
    background-color: rgb(38 38 38 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-neutral-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-neutral-900:hover{
    background-color: rgb(23 23 23 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-orange-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-orange-100:hover{
    background-color: rgb(255 237 213 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-orange-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-orange-200:hover{
    background-color: rgb(254 215 170 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-orange-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-orange-300:hover{
    background-color: rgb(253 186 116 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-orange-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-orange-400:hover{
    background-color: rgb(251 146 60 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-orange-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-orange-50:hover{
    background-color: rgb(255 247 237 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-orange-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-orange-500:hover{
    background-color: rgb(249 115 22 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-orange-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-orange-600:hover{
    background-color: rgb(234 88 12 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-orange-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-orange-700:hover{
    background-color: rgb(194 65 12 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-orange-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(154 52 18 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-orange-800:hover{
    background-color: rgb(154 52 18 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-orange-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(124 45 18 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-orange-900:hover{
    background-color: rgb(124 45 18 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-pink-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-pink-100:hover{
    background-color: rgb(252 231 243 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-pink-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(251 207 232 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-pink-200:hover{
    background-color: rgb(251 207 232 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-pink-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 168 212 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-pink-300:hover{
    background-color: rgb(249 168 212 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-pink-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-pink-400:hover{
    background-color: rgb(244 114 182 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-pink-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-pink-50:hover{
    background-color: rgb(253 242 248 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-pink-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-pink-500:hover{
    background-color: rgb(236 72 153 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-pink-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-pink-600:hover{
    background-color: rgb(219 39 119 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-pink-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(190 24 93 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-pink-700:hover{
    background-color: rgb(190 24 93 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-pink-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(157 23 77 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-pink-800:hover{
    background-color: rgb(157 23 77 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-pink-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(131 24 67 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-pink-900:hover{
    background-color: rgb(131 24 67 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-purple-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-purple-100:hover{
    background-color: rgb(243 232 255 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-purple-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-purple-200:hover{
    background-color: rgb(233 213 255 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-purple-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(216 180 254 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-purple-300:hover{
    background-color: rgb(216 180 254 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-purple-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-purple-400:hover{
    background-color: rgb(192 132 252 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-purple-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-purple-50:hover{
    background-color: rgb(250 245 255 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-purple-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-purple-500:hover{
    background-color: rgb(168 85 247 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-purple-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-purple-600:hover{
    background-color: rgb(147 51 234 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-purple-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-purple-700:hover{
    background-color: rgb(126 34 206 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-purple-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(107 33 168 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-purple-800:hover{
    background-color: rgb(107 33 168 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-purple-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(88 28 135 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-purple-900:hover{
    background-color: rgb(88 28 135 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-red-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-red-100:hover{
    background-color: rgb(254 226 226 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-red-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-red-200:hover{
    background-color: rgb(254 202 202 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-red-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-red-300:hover{
    background-color: rgb(252 165 165 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-red-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-red-400:hover{
    background-color: rgb(248 113 113 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-red-50:hover{
    background-color: rgb(254 242 242 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-red-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-red-500:hover{
    background-color: rgb(239 68 68 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-red-600:hover{
    background-color: rgb(220 38 38 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-red-700:hover{
    background-color: rgb(185 28 28 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-red-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-red-800:hover{
    background-color: rgb(153 27 27 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-red-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(127 29 29 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-red-900:hover{
    background-color: rgb(127 29 29 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-rose-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-rose-100:hover{
    background-color: rgb(255 228 230 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-rose-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 205 211 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-rose-200:hover{
    background-color: rgb(254 205 211 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-rose-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 164 175 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-rose-300:hover{
    background-color: rgb(253 164 175 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-rose-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(251 113 133 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-rose-400:hover{
    background-color: rgb(251 113 133 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-rose-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-rose-50:hover{
    background-color: rgb(255 241 242 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-rose-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-rose-500:hover{
    background-color: rgb(244 63 94 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-rose-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-rose-600:hover{
    background-color: rgb(225 29 72 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-rose-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-rose-700:hover{
    background-color: rgb(190 18 60 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-rose-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(159 18 57 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-rose-800:hover{
    background-color: rgb(159 18 57 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-rose-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(136 19 55 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-rose-900:hover{
    background-color: rgb(136 19 55 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-sky-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-sky-100:hover{
    background-color: rgb(224 242 254 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-sky-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(186 230 253 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-sky-200:hover{
    background-color: rgb(186 230 253 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-sky-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(125 211 252 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-sky-300:hover{
    background-color: rgb(125 211 252 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-sky-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-sky-400:hover{
    background-color: rgb(56 189 248 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-sky-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-sky-50:hover{
    background-color: rgb(240 249 255 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-sky-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-sky-500:hover{
    background-color: rgb(14 165 233 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-sky-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-sky-600:hover{
    background-color: rgb(2 132 199 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-sky-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-sky-700:hover{
    background-color: rgb(3 105 161 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-sky-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(7 89 133 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-sky-800:hover{
    background-color: rgb(7 89 133 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-sky-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(12 74 110 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-sky-900:hover{
    background-color: rgb(12 74 110 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-slate-100:hover{
    background-color: rgb(241 245 249 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-slate-200:hover{
    background-color: rgb(226 232 240 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-slate-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-slate-300:hover{
    background-color: rgb(203 213 225 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-slate-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-slate-400:hover{
    background-color: rgb(148 163 184 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-slate-50:hover{
    background-color: rgb(248 250 252 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-slate-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-slate-500:hover{
    background-color: rgb(100 116 139 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-slate-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-slate-600:hover{
    background-color: rgb(71 85 105 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-slate-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-slate-700:hover{
    background-color: rgb(51 65 85 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-slate-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-slate-800:hover{
    background-color: rgb(30 41 59 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-slate-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-slate-900:hover{
    background-color: rgb(15 23 42 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-stone-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 244 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-stone-100:hover{
    background-color: rgb(245 245 244 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-stone-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(231 229 228 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-stone-200:hover{
    background-color: rgb(231 229 228 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-stone-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(214 211 209 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-stone-300:hover{
    background-color: rgb(214 211 209 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-stone-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(168 162 158 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-stone-400:hover{
    background-color: rgb(168 162 158 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-stone-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 249 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-stone-50:hover{
    background-color: rgb(250 250 249 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-stone-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(120 113 108 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-stone-500:hover{
    background-color: rgb(120 113 108 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-stone-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(87 83 78 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-stone-600:hover{
    background-color: rgb(87 83 78 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-stone-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(68 64 60 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-stone-700:hover{
    background-color: rgb(68 64 60 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-stone-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(41 37 36 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-stone-800:hover{
    background-color: rgb(41 37 36 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-stone-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(28 25 23 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-stone-900:hover{
    background-color: rgb(28 25 23 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-teal-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-teal-100:hover{
    background-color: rgb(204 251 241 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-teal-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(153 246 228 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-teal-200:hover{
    background-color: rgb(153 246 228 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-teal-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(94 234 212 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-teal-300:hover{
    background-color: rgb(94 234 212 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-teal-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-teal-400:hover{
    background-color: rgb(45 212 191 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-teal-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-teal-50:hover{
    background-color: rgb(240 253 250 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-teal-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-teal-500:hover{
    background-color: rgb(20 184 166 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-teal-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-teal-600:hover{
    background-color: rgb(13 148 136 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-teal-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-teal-700:hover{
    background-color: rgb(15 118 110 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-teal-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(17 94 89 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-teal-800:hover{
    background-color: rgb(17 94 89 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-teal-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(19 78 74 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-teal-900:hover{
    background-color: rgb(19 78 74 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-transparent:hover{
  background-color: transparent;
}

.hover\\:bg-violet-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-violet-100:hover{
    background-color: rgb(237 233 254 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-violet-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(221 214 254 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-violet-200:hover{
    background-color: rgb(221 214 254 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-violet-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(196 181 253 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-violet-300:hover{
    background-color: rgb(196 181 253 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-violet-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-violet-400:hover{
    background-color: rgb(167 139 250 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-violet-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-violet-50:hover{
    background-color: rgb(245 243 255 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-violet-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-violet-500:hover{
    background-color: rgb(139 92 246 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-violet-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-violet-600:hover{
    background-color: rgb(124 58 237 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-violet-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(109 40 217 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-violet-700:hover{
    background-color: rgb(109 40 217 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-violet-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(91 33 182 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-violet-800:hover{
    background-color: rgb(91 33 182 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-violet-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(76 29 149 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-violet-900:hover{
    background-color: rgb(76 29 149 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-white:hover{
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-yellow-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-yellow-100:hover{
    background-color: rgb(254 249 195 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-yellow-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-yellow-200:hover{
    background-color: rgb(254 240 138 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-yellow-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-yellow-300:hover{
    background-color: rgb(253 224 71 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-yellow-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-yellow-400:hover{
    background-color: rgb(250 204 21 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-yellow-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-yellow-50:hover{
    background-color: rgb(254 252 232 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-yellow-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-yellow-500:hover{
    background-color: rgb(234 179 8 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-yellow-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-yellow-600:hover{
    background-color: rgb(202 138 4 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-yellow-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(161 98 7 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-yellow-700:hover{
    background-color: rgb(161 98 7 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-yellow-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(133 77 14 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-yellow-800:hover{
    background-color: rgb(133 77 14 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-yellow-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(113 63 18 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-yellow-900:hover{
    background-color: rgb(113 63 18 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-zinc-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-zinc-100:hover{
    background-color: rgb(244 244 245 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-zinc-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-zinc-200:hover{
    background-color: rgb(228 228 231 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-zinc-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 216 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-zinc-300:hover{
    background-color: rgb(212 212 216 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-zinc-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(161 161 170 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-zinc-400:hover{
    background-color: rgb(161 161 170 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-zinc-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-zinc-50:hover{
    background-color: rgb(250 250 250 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-zinc-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(113 113 122 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-zinc-500:hover{
    background-color: rgb(113 113 122 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-zinc-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 91 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-zinc-600:hover{
    background-color: rgb(82 82 91 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-zinc-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-zinc-700:hover{
    background-color: rgb(63 63 70 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-zinc-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-zinc-800:hover{
    background-color: rgb(39 39 42 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-zinc-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:bg-zinc-900:hover{
    background-color: rgb(24 24 27 / var(--tw-bg-opacity));
  }
}

.hover\\:bg-opacity-20:hover{
  --tw-bg-opacity: 0.2;
}

.hover\\:text-slate-600:hover{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.hover\\:text-slate-600:hover{
    color: rgb(71 85 105 / var(--tw-text-opacity));
  }
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-90:hover{
  opacity: 0.9;
}

.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:border-gray-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.focus\\:border-gray-500:focus{
    border-color: rgb(107 114 128 / var(--tw-border-opacity));
  }
}

.focus\\:border-indigo-600:focus{
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.focus\\:border-indigo-600:focus{
    border-color: rgb(79 70 229 / var(--tw-border-opacity));
  }
}

.focus\\:border-indigo-700:focus{
  --tw-border-opacity: 1;
  border-color: rgb(67 56 202 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.focus\\:border-indigo-700:focus{
    border-color: rgb(67 56 202 / var(--tw-border-opacity));
  }
}

.focus\\:border-rose-700:focus{
  --tw-border-opacity: 1;
  border-color: rgb(190 18 60 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.focus\\:border-rose-700:focus{
    border-color: rgb(190 18 60 / var(--tw-border-opacity));
  }
}

.focus\\:border-transparent:focus{
  border-color: transparent;
}

.focus\\:border-violet-600:focus{
  --tw-border-opacity: 1;
  border-color: rgb(124 58 237 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.focus\\:border-violet-600:focus{
    border-color: rgb(124 58 237 / var(--tw-border-opacity));
  }
}

.focus\\:bg-white:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.focus\\:bg-white:focus{
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:outline:focus{
  outline-style: solid;
}

.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #2563eb, 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-inset:focus{
  --tw-ring-inset: inset;
}

.focus\\:ring-indigo-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity));
}

.active\\:bg-white:active{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.active\\:bg-white:active{
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:bg-gray-300:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.disabled\\:bg-gray-300:disabled{
    background-color: rgb(209 213 219 / var(--tw-bg-opacity));
  }
}

.disabled\\:bg-gray-400:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.disabled\\:bg-gray-400:disabled{
    background-color: rgb(156 163 175 / var(--tw-bg-opacity));
  }
}

.disabled\\:bg-slate-100:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.disabled\\:bg-slate-100:disabled{
    background-color: rgb(241 245 249 / var(--tw-bg-opacity));
  }
}

.disabled\\:bg-slate-200:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.disabled\\:bg-slate-200:disabled{
    background-color: rgb(226 232 240 / var(--tw-bg-opacity));
  }
}

.disabled\\:bg-slate-300:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.disabled\\:bg-slate-300:disabled{
    background-color: rgb(203 213 225 / var(--tw-bg-opacity));
  }
}

.disabled\\:bg-violet-400:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.disabled\\:bg-violet-400:disabled{
    background-color: rgb(167 139 250 / var(--tw-bg-opacity));
  }
}

.disabled\\:text-gray-500:disabled{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.disabled\\:text-gray-500:disabled{
    color: rgb(107 114 128 / var(--tw-text-opacity));
  }
}

.disabled\\:text-gray-600:disabled{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.disabled\\:text-gray-600:disabled{
    color: rgb(75 85 99 / var(--tw-text-opacity));
  }
}

.disabled\\:text-slate-500:disabled{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.disabled\\:text-slate-500:disabled{
    color: rgb(100 116 139 / var(--tw-text-opacity));
  }
}

.disabled\\:hover\\:bg-gray-400:hover:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.disabled\\:hover\\:bg-gray-400:hover:disabled{
    background-color: rgb(156 163 175 / var(--tw-bg-opacity));
  }
}

.disabled\\:hover\\:bg-slate-200:hover:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.disabled\\:hover\\:bg-slate-200:hover:disabled{
    background-color: rgb(226 232 240 / var(--tw-bg-opacity));
  }
}

.disabled\\:hover\\:bg-slate-300:hover:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.disabled\\:hover\\:bg-slate-300:hover:disabled{
    background-color: rgb(203 213 225 / var(--tw-bg-opacity));
  }
}

.disabled\\:hover\\:text-gray-600:hover:disabled{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.disabled\\:hover\\:text-gray-600:hover:disabled{
    color: rgb(75 85 99 / var(--tw-text-opacity));
  }
}

.peer:checked ~ .peer-checked\\:bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / 1);
}

@supports (color: rgb(0 0 0 / 0)){
.peer:checked ~ .peer-checked\\:bg-rose-500{
    background-color: rgb(244 63 94 / var(--tw-bg-opacity));
  }
}

.peer:checked ~ .peer-checked\\:before\\:translate-x-full::before{
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(100%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus-visible ~ .peer-focus-visible\\:outline{
  outline-style: solid;
}

.peer:focus-visible ~ .peer-focus-visible\\:outline-offset-2{
  outline-offset: 2px;
}

.peer:focus-visible ~ .peer-focus-visible\\:outline-gray-400{
  outline-color: #9ca3af;
}

.peer:checked:focus-visible ~ .peer-checked\\:peer-focus-visible\\:outline-indigo-500{
  outline-color: #6366f1;
}

@media not all and (min-width: 768px){

  .max-md\\:hidden{
    display: none;
  }

  .max-md\\:text-center{
    text-align: center;
  }
}

@media (min-width: 640px){

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .sm\\:col-start-2{
    grid-column-start: 2;
  }

  .sm\\:col-start-3{
    grid-column-start: 3;
  }

  .sm\\:-mx-6{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .sm\\:ml-4{
    margin-left: 1rem;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:mt-12{
    margin-top: 3rem;
  }

  .sm\\:mt-5{
    margin-top: 1.25rem;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:h-10{
    height: 2.5rem;
  }

  .sm\\:h-12{
    height: 3rem;
  }

  .sm\\:h-5{
    height: 1.25rem;
  }

  .sm\\:h-8{
    height: 2rem;
  }

  .sm\\:w-10{
    width: 2.5rem;
  }

  .sm\\:w-12{
    width: 3rem;
  }

  .sm\\:w-40{
    width: 10rem;
  }

  .sm\\:w-full{
    width: 100%;
  }

  .sm\\:max-w-lg{
    max-width: 32rem;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:max-w-xl{
    max-width: 36rem;
  }

  .sm\\:flex-shrink-0{
    flex-shrink: 0;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:flex-row-reverse{
    flex-direction: row-reverse;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:items-start{
    align-items: flex-start;
  }

  .sm\\:gap-y-0{
    row-gap: 0px;
  }

  .sm\\:divide-y > :not([hidden]) ~ :not([hidden]){
    --tw-divide-y-reverse: 0;
    border-top-width: calc(1px * calc(1 - 0));
    border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(1px * 0);
    border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
  }

  .sm\\:divide-slate-200 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-opacity: 1;
    border-color: rgb(226 232 240 / 1);
  }

@supports (color: rgb(0 0 0 / 0)){
.sm\\:divide-slate-200 > :not([hidden]) ~ :not([hidden]){
      border-color: rgb(226 232 240 / var(--tw-divide-opacity));
    }
}

  .sm\\:rounded-lg{
    border-radius: 0.5rem;
  }

  .sm\\:p-0{
    padding: 0px;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:pb-16{
    padding-bottom: 4rem;
  }

  .sm\\:pb-4{
    padding-bottom: 1rem;
  }

  .sm\\:pt-6{
    padding-top: 1.5rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-center{
    text-align: center;
  }

  .sm\\:text-right{
    text-align: right;
  }

  .sm\\:align-middle{
    vertical-align: middle;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:leading-5{
    line-height: 1.25rem;
  }
}

@media (min-width: 768px){

  .md\\:sr-only{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .md\\:bottom-8{
    bottom: 2rem;
  }

  .md\\:right-8{
    right: 2rem;
  }

  .md\\:top-8{
    top: 2rem;
  }

  .md\\:order-1{
    order: 1;
  }

  .md\\:order-10{
    order: 10;
  }

  .md\\:order-11{
    order: 11;
  }

  .md\\:order-12{
    order: 12;
  }

  .md\\:order-2{
    order: 2;
  }

  .md\\:order-3{
    order: 3;
  }

  .md\\:order-4{
    order: 4;
  }

  .md\\:order-5{
    order: 5;
  }

  .md\\:order-6{
    order: 6;
  }

  .md\\:order-7{
    order: 7;
  }

  .md\\:order-8{
    order: 8;
  }

  .md\\:order-9{
    order: 9;
  }

  .md\\:order-\\[13\\]{
    order: 13;
  }

  .md\\:order-\\[14\\]{
    order: 14;
  }

  .md\\:order-\\[15\\]{
    order: 15;
  }

  .md\\:order-\\[16\\]{
    order: 16;
  }

  .md\\:order-\\[17\\]{
    order: 17;
  }

  .md\\:order-\\[18\\]{
    order: 18;
  }

  .md\\:order-\\[19\\]{
    order: 19;
  }

  .md\\:order-\\[20\\]{
    order: 20;
  }

  .md\\:order-\\[21\\]{
    order: 21;
  }

  .md\\:order-\\[22\\]{
    order: 22;
  }

  .md\\:order-\\[23\\]{
    order: 23;
  }

  .md\\:order-\\[24\\]{
    order: 24;
  }

  .md\\:order-\\[25\\]{
    order: 25;
  }

  .md\\:order-\\[26\\]{
    order: 26;
  }

  .md\\:order-\\[27\\]{
    order: 27;
  }

  .md\\:order-\\[28\\]{
    order: 28;
  }

  .md\\:order-\\[29\\]{
    order: 29;
  }

  .md\\:order-\\[30\\]{
    order: 30;
  }

  .md\\:order-\\[31\\]{
    order: 31;
  }

  .md\\:order-\\[32\\]{
    order: 32;
  }

  .md\\:order-\\[33\\]{
    order: 33;
  }

  .md\\:order-\\[34\\]{
    order: 34;
  }

  .md\\:order-\\[35\\]{
    order: 35;
  }

  .md\\:order-\\[36\\]{
    order: 36;
  }

  .md\\:order-\\[37\\]{
    order: 37;
  }

  .md\\:order-\\[38\\]{
    order: 38;
  }

  .md\\:order-\\[39\\]{
    order: 39;
  }

  .md\\:order-\\[40\\]{
    order: 40;
  }

  .md\\:order-\\[41\\]{
    order: 41;
  }

  .md\\:order-\\[42\\]{
    order: 42;
  }

  .md\\:order-\\[43\\]{
    order: 43;
  }

  .md\\:order-\\[44\\]{
    order: 44;
  }

  .md\\:order-\\[45\\]{
    order: 45;
  }

  .md\\:order-\\[46\\]{
    order: 46;
  }

  .md\\:order-\\[47\\]{
    order: 47;
  }

  .md\\:order-\\[48\\]{
    order: 48;
  }

  .md\\:order-\\[49\\]{
    order: 49;
  }

  .md\\:col-start-2{
    grid-column-start: 2;
  }

  .md\\:-mx-6{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .md\\:my-6{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .md\\:-mb-0{
    margin-bottom: -0px;
  }

  .md\\:-ml-1{
    margin-left: -0.25rem;
  }

  .md\\:mb-16{
    margin-bottom: 4rem;
  }

  .md\\:mb-20{
    margin-bottom: 5rem;
  }

  .md\\:mb-4{
    margin-bottom: 1rem;
  }

  .md\\:mb-8{
    margin-bottom: 2rem;
  }

  .md\\:mb-\\[8vh\\]{
    margin-bottom: 8vh;
  }

  .md\\:ml-10{
    margin-left: 2.5rem;
  }

  .md\\:mr-10{
    margin-right: 2.5rem;
  }

  .md\\:mr-2{
    margin-right: 0.5rem;
  }

  .md\\:mr-3{
    margin-right: 0.75rem;
  }

  .md\\:mr-4{
    margin-right: 1rem;
  }

  .md\\:mt-0{
    margin-top: 0px;
  }

  .md\\:mt-10{
    margin-top: 2.5rem;
  }

  .md\\:mt-16{
    margin-top: 4rem;
  }

  .md\\:mt-20{
    margin-top: 5rem;
  }

  .md\\:mt-4{
    margin-top: 1rem;
  }

  .md\\:mt-40{
    margin-top: 10rem;
  }

  .md\\:mt-5{
    margin-top: 1.25rem;
  }

  .md\\:mt-8{
    margin-top: 2rem;
  }

  .md\\:block{
    display: block;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:grid{
    display: grid;
  }

  .md\\:contents{
    display: contents;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:h-10{
    height: 2.5rem;
  }

  .md\\:h-5{
    height: 1.25rem;
  }

  .md\\:h-6{
    height: 1.5rem;
  }

  .md\\:h-8{
    height: 2rem;
  }

  .md\\:h-\\[111px\\]{
    height: 111px;
  }

  .md\\:max-h-screen{
    max-height: 100vh;
  }

  .md\\:min-h-\\[180px\\]{
    min-height: 180px;
  }

  .md\\:w-10{
    width: 2.5rem;
  }

  .md\\:w-24{
    width: 6rem;
  }

  .md\\:w-6{
    width: 1.5rem;
  }

  .md\\:w-8{
    width: 2rem;
  }

  .md\\:w-96{
    width: 24rem;
  }

  .md\\:w-\\[523px\\]{
    width: 523px;
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:max-w-7xl{
    max-width: 80rem;
  }

  .md\\:max-w-full{
    max-width: 100%;
  }

  .md\\:max-w-lg{
    max-width: 32rem;
  }

  .md\\:max-w-md{
    max-width: 28rem;
  }

  .md\\:max-w-none{
    max-width: none;
  }

  .md\\:max-w-prose{
    max-width: 65ch;
  }

  .md\\:flex-grow{
    flex-grow: 1;
  }

  .md\\:grow-0{
    flex-grow: 0;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:flex-row-reverse{
    flex-direction: row-reverse;
  }

  .md\\:flex-col{
    flex-direction: column;
  }

  .md\\:flex-wrap{
    flex-wrap: wrap;
  }

  .md\\:place-content-center{
    place-content: center;
  }

  .md\\:place-items-start{
    place-items: start;
  }

  .md\\:items-start{
    align-items: flex-start;
  }

  .md\\:items-end{
    align-items: flex-end;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:justify-start{
    justify-content: flex-start;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:justify-items-start{
    justify-items: start;
  }

  .md\\:gap-4{
    gap: 1rem;
  }

  .md\\:gap-6{
    gap: 1.5rem;
  }

  .md\\:space-x-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0px * 0);
    margin-right: calc(0px * var(--tw-space-x-reverse));
    margin-left: calc(0px * calc(1 - 0));
    margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(4rem * 0);
    margin-right: calc(4rem * var(--tw-space-x-reverse));
    margin-left: calc(4rem * calc(1 - 0));
    margin-left: calc(4rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * 0);
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - 0));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * 0);
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - 0));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * 0);
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - 0));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(2rem * 0);
    margin-right: calc(2rem * var(--tw-space-x-reverse));
    margin-left: calc(2rem * calc(1 - 0));
    margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - 0));
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * 0);
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .md\\:space-y-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(4rem * calc(1 - 0));
    margin-top: calc(4rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(4rem * 0);
    margin-bottom: calc(4rem * var(--tw-space-y-reverse));
  }

  .md\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - 0));
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * 0);
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .md\\:space-y-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - 0));
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2rem * 0);
    margin-bottom: calc(2rem * var(--tw-space-y-reverse));
  }

  .md\\:place-self-start{
    place-self: start;
  }

  .md\\:rounded-lg{
    border-radius: 0.5rem;
  }

  .md\\:border{
    border-width: 1px;
  }

  .md\\:border-2{
    border-width: 2px;
  }

  .md\\:border-b{
    border-bottom-width: 1px;
  }

  .md\\:border-slate-300{
    --tw-border-opacity: 1;
    border-color: rgb(203 213 225 / 1);
  }

@supports (color: rgb(0 0 0 / 0)){
.md\\:border-slate-300{
      border-color: rgb(203 213 225 / var(--tw-border-opacity));
    }
}

  .md\\:bg-neutral-100{
    --tw-bg-opacity: 1;
    background-color: rgb(245 245 245 / 1);
  }

@supports (color: rgb(0 0 0 / 0)){
.md\\:bg-neutral-100{
      background-color: rgb(245 245 245 / var(--tw-bg-opacity));
    }
}

  .md\\:p-0{
    padding: 0px;
  }

  .md\\:p-12{
    padding: 3rem;
  }

  .md\\:p-4{
    padding: 1rem;
  }

  .md\\:p-6{
    padding: 1.5rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .md\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:pb-2{
    padding-bottom: 0.5rem;
  }

  .md\\:pb-20{
    padding-bottom: 5rem;
  }

  .md\\:pb-4{
    padding-bottom: 1rem;
  }

  .md\\:pb-8{
    padding-bottom: 2rem;
  }

  .md\\:pl-2{
    padding-left: 0.5rem;
  }

  .md\\:pr-4{
    padding-right: 1rem;
  }

  .md\\:pt-2{
    padding-top: 0.5rem;
  }

  .md\\:pt-4{
    padding-top: 1rem;
  }

  .md\\:pt-8{
    padding-top: 2rem;
  }

  .md\\:text-left{
    text-align: left;
  }

  .md\\:text-center{
    text-align: center;
  }

  .md\\:text-right{
    text-align: right;
  }

  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-8xl{
    font-size: 6rem;
    line-height: 1;
  }

  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .md\\:font-normal{
    font-weight: 400;
  }

  .md\\:not-italic{
    font-style: normal;
  }

  .md\\:leading-snug{
    line-height: 1.375;
  }

  .md\\:text-black{
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / 1);
  }

@supports (color: rgb(0 0 0 / 0)){
.md\\:text-black{
      color: rgb(0 0 0 / var(--tw-text-opacity));
    }
}
}

@media (min-width: 1024px){

  .lg\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:flex-wrap{
    flex-wrap: wrap;
  }

  .lg\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (min-width: 1280px){

  .xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}

@media (min-width: 1536px){

  .\\32xl\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
}

.\\[\\&\\>div\\:first-child\\]\\:rounded-t-2xl>div:first-child{
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}

.\\[\\&\\>div\\:first-child\\]\\:pt-10>div:first-child{
  padding-top: 2.5rem;
}

.\\[\\&\\>div\\:last-child\\]\\:rounded-b-2xl>div:last-child{
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}

.\\[\\&\\>div\\:last-child\\]\\:pb-10>div:last-child{
  padding-bottom: 2.5rem;
}`, "",{"version":3,"sources":["webpack://./config/tailwind/tailwind-main.css"],"names":[],"mappings":"AAEA;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,6EAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;KAAd,qBAAc;UAAd,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,sBAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,mGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,wCAAc;EAAd,4BAAc;EAAd,4BAAc;EAAd,qBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,sBAAc;EAAd,yBAAc;EAAd,wBAAc;EAAd,4BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,0BAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,mCAAc;UAAd;AAAc;;AAAd;EAAA,wBAAc;KAAd,qBAAc;UAAd,gBAAc;EAAd,UAAc;EAAd,iCAAc;UAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;KAAd,sBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,mGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA,wBAAc;OAAd,qBAAc;YAAd;EAAc;AAAA;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA,wBAAc;OAAd,qBAAc;YAAd;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,4BAAc;AAAA;;AAAd;;EAAA;IAAA,wBAAc;OAAd,qBAAc;YAAd;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iFAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,kBAAc;EAAd;AAAc;;AAAd;EAAA,6BAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,sOAAc;EAAd;AAAc;;AAAd;IAAA,qBAAc;IAAd,4DAAc;IAAd,mBAAc;IAAd,kBAAc;EAAA;;AAAd;IAAA,qBAAc;IAAd,4DAAc;IAAd,iBAAc;IAAd,oBAAc;IAAd,kBAAc;EAAA;;AAAd;IAAA,qEAAc;IAAd,mBAAc;IAAd,iCAAc;EAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,2BAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,iBAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,4BAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,qBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,gCAAoB;EAApB,qBAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,kBAAoB;EAApB,6BAAoB;EAApB,kCAAoB;EAApB,wDAAoB;EAApB,oCAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,aAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,oBAAoB;EAApB,0BAAoB;EAApB,4GAAoB;EAApB,kBAAoB;EAApB,wBAAoB;EAApB,qBAAoB;EAApB,2BAAoB;EAApB,wBAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,wCAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB,uBAAoB;EAApB,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,UAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,sBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,qBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,yBAAoB;EAApB,wBAAoB;EAApB,4BAAoB;EAApB,2BAAoB;EAApB,sBAAoB;EAApB,0BAAoB;EAApB,iCAAoB;EAApB,4BAAoB;EAApB,uBAAoB;EAApB,gCAAoB;EAApB,wBAAoB;EAApB,4BAAoB;EAApB,0BAAoB;EAApB,8BAAoB;EAApB,8BAAoB;EAApB,+BAAoB;EAApB,gCAAoB;EAApB,+BAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,mCAAoB;EAApB,kCAAoB;EAApB,6BAAoB;EAApB,iCAAoB;EAApB,wCAAoB;EAApB,mCAAoB;EAApB,2BAAoB;EAApB,0CAAoB;EAApB,4BAAoB;EAApB,mCAAoB;EAApB,0CAAoB;EAApB,qCAAoB;EAApB,qCAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,mBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,aAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,wBAAoB;EAApB,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB,sBAAoB;EAApB,wBAAoB;EAApB,uBAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,uBAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,yBAAoB;EAApB,wBAAoB;EAApB,4BAAoB;EAApB,2BAAoB;EAApB,sBAAoB;EAApB,0BAAoB;EAApB,iCAAoB;EAApB,4BAAoB;EAApB,uBAAoB;EAApB,gCAAoB;EAApB,wBAAoB;EAApB,4BAAoB;EAApB,0BAAoB;EAApB,8BAAoB;EAApB,8BAAoB;EAApB,+BAAoB;EAApB,gCAAoB;EAApB,+BAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,mCAAoB;EAApB,kCAAoB;EAApB,6BAAoB;EAApB,iCAAoB;EAApB,wCAAoB;EAApB,mCAAoB;EAApB,2BAAoB;EAApB,0CAAoB;EAApB,4BAAoB;EAApB,mCAAoB;EAApB,0CAAoB;EAApB,qCAAoB;EAApB;AAAoB;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,WAAmB;EAAnB,YAAmB;EAAnB,UAAmB;EAAnB,SAAmB;EAAnB,iBAAmB;EAAnB,UAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,qLAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB,qKAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB,mKAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB,iKAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB,mKAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2BAAmB;EAAnB,mDAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+BAAmB;EAAnB,uDAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8BAAmB;EAAnB,sDAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4BAAmB;EAAnB,oDAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4BAAmB;EAAnB,oDAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uCAAmB;EAAnB,+DAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sCAAmB;EAAnB,8DAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oCAAmB;EAAnB,4DAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sCAAmB;EAAnB,8DAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oCAAmB;EAAnB,4DAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,yCAAmB;EAAnB,kEAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;AAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB,+FAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB,2GAAmB;EAAnB,uHAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB,qGAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,4FAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB,4OAAmB;EAAnB;AAAmB;AAAnB;EAAA,qGAAmB;EAAnB,+OAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iQAAmB;UAAnB,yPAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;;;AA4BjB;EAAA,yCAAsH;EAAtH,qBAAsH;EAAtH,mBAAsH;EAAtH,sBAAsH;EAAtH,kBAAsH;EAAtH,mBAAsH;EAAtH,sOAAsH;EAAtH,gBAAsH;EAAtH,6EAAsH;EAAtH,iGAAsH;EAAtH,kGAAsH;EAAtH;AAAsH;;;;AAAtH;EAAA,8BAAsH;EAAtH,mBAAsH;EAAtH,2GAAsH;EAAtH,yGAAsH;EAAtH,4FAAsH;EAAtH,4FAAsH;EAAtH;AAAsH;;AAItH;EAAA,yCAAuE;EAAvE,sOAAuE;EAAvE,iBAAuE;EAAvE,iBAAuE;EAAvE,gBAAuE;EAAvE,4BAAuE;EAAvE;AAAuE;;AAAvE;;EAAA;IAAA,mBAAuE;IAAvE;EAAuE;AAAA;;AAGzE,WAAW;;AAGT;EAAA,kBAA8B;EAA9B,oCAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;;AAA9B;AAAA;IAAA,uDAA8B;IAA9B;EAA8B;AAAA;;AAI9B;EAAA,kBAAgC;EAAhC,oCAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;;AAAhC;AAAA;IAAA,uDAAgC;IAAhC;EAAgC;AAAA;;AAIhC;EAAA,qCAAgD;EAAhD,oBAAgD;EAAhD,oBAAgD;EAAhD;AAAgD;;AAAhD;AAAA;IAAA,sDAAgD;IAAhD;EAAgD;AAAA;;AAGlD,YAAY;;AAGV;EAAA,eAA2J;EAA3J,yBAA2J;KAA3J,sBAA2J;UAA3J,iBAA2J;EAA3J,kBAA2J;EAA3J,gBAA2J;EAA3J,8BAA2J;EAA3J,mBAA2J;EAA3J,gKAA2J;EAA3J,wJAA2J;EAA3J,iLAA2J;EAA3J,0BAA2J;EAA3J;AAA2J;;AAA3J;EAAA,mBAA2J;EAA3J;AAA2J;;;AAI7J,mBAAmB;;AAGjB;EAAA,uBAAmC;EAAnC,oBAAmC;EAAnC,uBAAmC;EAAnC,oBAAmC;EAAnC,qBAAmC;EAAnC,mBAAmC;EAAnC;AAAmC;;AAInC;EAAA,uBAAmC;EAAnC,mBAAmC;EAAnC,sBAAmC;EAAnC,qBAAmC;EAAnC,sBAAmC;EAAnC,mBAAmC;EAAnC;AAAmC;;AAInC;EAAA,qBAA8D;EAA9D,mBAA8D;EAA9D,sBAA8D;EAA9D,kBAA8D;EAA9D,mBAA8D;EAA9D,mBAA8D;EAA9D;AAA8D;;AAA9D;;EAAA;IAAA,oBAA8D;IAA9D,uBAA8D;IAA9D,oBAA8D;IAA9D,qBAA8D;IAA9D,mBAA8D;IAA9D;EAA8D;AAAA;;AAI9D;EAAA,sBAAsD;EAAtD,mBAAsD;EAAtD,sBAAsD;EAAtD,kBAAsD;EAAtD,mBAAsD;EAAtD,mBAAsD;EAAtD;AAAsD;;AAAtD;;EAAA;IAAA,oBAAsD;IAAtD,uBAAsD;IAAtD,kBAAsD;IAAtD;EAAsD;AAAA;;;;AAKxD;;EAEE,UAAU;;EACV,eAA8F;;EAA9F,yBAA8F;;KAA9F,sBAA8F;;UAA9F,iBAA8F;;EAA9F,8BAA8F;;EAA9F,mBAA8F;;AAgBhG;;;;AAhBE;EAAA,mBAA8F;EAA9F;AAA8F;;;;AAE9F;EAAA,aASsB;EATtB,YASsB;EATtB,WASsB;EATtB,+LASsB;EATtB,mBASsB;EATtB,uBASsB;EATtB,qBASsB;EATtB,iBASsB;EATtB,sBASsB;EATtB,kCASsB;EATtB,mEASsB;EATtB,4DASsB;EATtB,mEASsB;EATtB,mEASsB;EATtB,4GASsB;EATtB,wDASsB;EATtB,eASsB;EATtB,kBASsB;EATtB,mBASsB;EATtB,kBASsB;EATtB,mBASsB;EATtB,oBASsB;EATtB,gBASsB;EATtB,oBASsB;EATtB,2BASsB;EATtB,gFASsB;EATtB,oGASsB;EATtB,qGASsB;EATtB,uGASsB;EATtB,gKASsB;EATtB,wJASsB;EATtB,iLASsB;EATtB,0BASsB;EATtB;AASsB;;;;AATtB;AAAA;IAAA,yDASsB;IATtB,qEASsB;IATtB;EASsB;AAAA;;;;AATtB;EAAA,kBASsB;EATtB,kBASsB;EATtB,qKASsB;EATtB;AASsB;;;;AATtB;EAAA,8BASsB;EATtB,mBASsB;EATtB,2GASsB;EATtB,yGASsB;EATtB,wEASsB;EATtB,4FASsB;EATtB,oBASsB;EATtB;AASsB;;;;AATtB;EAAA,eASsB;EATtB,eASsB;EATtB,+JASsB;EATtB;AASsB;;;;AATtB;;EAAA;IAAA,YASsB;IATtB,WASsB;IATtB,mBASsB;IATtB;EASsB;AAAA;;;;AAdxB;;EAgBE,0BAA0B;EAC1B,gFAAgF;;AAElF;;AAEA;;AAEA,UAAU;;AACV,eAA8F;;AAA9F,yBAA8F;;GAA9F,sBAA8F;;QAA9F,iBAA8F;;AAA9F,8BAA8F;;AAA9F,mBAA8F;;AAgB9F;;AAhBA;EAAA,mBAA8F;EAA9F;AAA8F;;AAE9F;EAAA,aASsB;EATtB,+LASsB;EATtB,mBASsB;EATtB,uBASsB;EATtB,uBASsB;EATtB,iBASsB;EATtB,sBASsB;EATtB,gCASsB;EATtB,kBASsB;EATtB,sCASsB;EATtB,gBASsB;EATtB,oBASsB;EATtB,qBASsB;EATtB,kBASsB;EATtB,kBASsB;EATtB,iBASsB;EATtB,gBASsB;EATtB,oBASsB;EATtB,yBASsB;EATtB,6EASsB;EATtB,iGASsB;EATtB,kGASsB;EATtB,uGASsB;EATtB,gKASsB;EATtB,wJASsB;EATtB,iLASsB;EATtB,0BASsB;EATtB;AASsB;;AATtB;AAAA;IAAA,uDASsB;IATtB,yDASsB;IATtB;EASsB;AAAA;;AATtB;EAAA,8BASsB;EATtB,mBASsB;EATtB,2GASsB;EATtB,yGASsB;EATtB,wEASsB;EATtB,4FASsB;EATtB,oBASsB;EATtB;AASsB;;AATtB;EAAA,eASsB;EATtB,eASsB;EATtB,+JASsB;EATtB;AASsB;;AATtB;;EAAA;IAAA,eASsB;IATtB;EASsB;;EATtB;IAAA,kBASsB;IATtB,kBASsB;IATtB,qKASsB;IATtB;EASsB;AAAA;;AAdtB;;AAgBA,0BAA0B;AAC1B,gFAAgF;;AAEhF;;;AAGA,oBAAoB;;;AAIlB;EAAA,iBACsG;EADtG,sCACsG;EADtG,kBACsG;EADtG,4BACsG;EADtG,wDACsG;EADtG;AACsG;;;AADtG;AAAA;IAAA;EACsG;AAAA;;;AADtG;EAAA;AACsG;;;AADtG;EAAA;AACsG;;;AADtG;EAAA,iBACsG;EADtG;AACsG;;AAItG;EAAA,qCAAuD;EAAvD,oBAAuD;EAAvD,oBAAuD;EAAvD,wBAAuD;EAAvD,eAAuD;EAAvD,yBAAuD;KAAvD,sBAAuD;UAAvD,iBAAuD;EAAvD,kBAAuD;EAAvD,gBAAuD;EAAvD,8BAAuD;EAAvD,mBAAuD;EAAvD,gKAAuD;EAAvD,wJAAuD;EAAvD,iLAAuD;EAAvD,0BAAuD;EAAvD;AAAuD;;AAAvD;AAAA;IAAA,sDAAuD;IAAvD;EAAuD;AAAA;;AAAvD;EAAA,mBAAuD;EAAvD;AAAuD;;AAAvD;EAAA;AAAuD;;AAIvD;EAAA,kBAA2G;EAA3G,oCAA2G;EAA3G,oBAA2G;EAA3G,2BAA2G;EAA3G,eAA2G;EAA3G,yBAA2G;KAA3G,sBAA2G;UAA3G,iBAA2G;EAA3G,kBAA2G;EAA3G,gBAA2G;EAA3G,8BAA2G;EAA3G,mBAA2G;EAA3G,gKAA2G;EAA3G,wJAA2G;EAA3G,iLAA2G;EAA3G,0BAA2G;EAA3G;AAA2G;;AAA3G;AAAA;IAAA,uDAA2G;IAA3G;EAA2G;AAAA;;AAA3G;EAAA,mBAA2G;EAA3G;AAA2G;;AAA3G;EAAA,0BAA2G;EAA3G,qCAA2G;EAA3G,0DAA2G;EAA3G,oMAA2G;EAA3G;AAA2G;;AAIzG;EAAA,kBAAsH;EAAtH,oCAAsH;EAAtH,oBAAsH;EAAtH,2BAAsH;EAAtH,eAAsH;EAAtH,yBAAsH;KAAtH,sBAAsH;UAAtH,iBAAsH;EAAtH,kBAAsH;EAAtH,gBAAsH;EAAtH,8BAAsH;EAAtH,mBAAsH;EAAtH,gKAAsH;EAAtH,wJAAsH;EAAtH,iLAAsH;EAAtH,0BAAsH;EAAtH;AAAsH;;AAAtH;AAAA;IAAA,uDAAsH;IAAtH;EAAsH;AAAA;;AAAtH;EAAA,mBAAsH;EAAtH;AAAsH;;AAAtH;EAAA,0BAAsH;EAAtH,qCAAsH;EAAtH,0DAAsH;EAAtH,oMAAsH;EAAtH;AAAsH;;AAG1H,wBAAwB;;AAGpB;EAAA,uBAAiC;EAAjC,oBAAiC;EAAjC,uBAAiC;EAAjC,oBAAiC;EAAjC,qBAAiC;EAAjC,mBAAiC;EAAjC,oBAAiC;EAAjC,iBAAiC;EAAjC,sCAAiC;EAAjC,kBAAiC;EAAjC,4BAAiC;EAAjC,wDAAiC;EAAjC;AAAiC;;AAAjC;AAAA;IAAA;EAAiC;AAAA;;AAAjC;EAAA;AAAiC;;AAAjC;EAAA;AAAiC;;AAAjC;EAAA,iBAAiC;EAAjC;AAAiC;;AAInC;EAAA,uBAAiC;EAAjC,mBAAiC;EAAjC,sBAAiC;EAAjC,qBAAiC;EAAjC,sBAAiC;EAAjC,mBAAiC;EAAjC,oBAAiC;EAAjC,iBAAiC;EAAjC,sCAAiC;EAAjC,kBAAiC;EAAjC,4BAAiC;EAAjC,wDAAiC;EAAjC;AAAiC;;AAAjC;AAAA;IAAA;EAAiC;AAAA;;AAAjC;EAAA;AAAiC;;AAAjC;EAAA;AAAiC;;AAAjC;EAAA,iBAAiC;EAAjC;AAAiC;;AAIjC;EAAA,uBAAqC;EAArC,mBAAqC;EAArC,sBAAqC;EAArC,qBAAqC;EAArC,sBAAqC;EAArC,mBAAqC;EAArC,oBAAqC;EAArC,qCAAqC;EAArC,oBAAqC;EAArC,oBAAqC;EAArC,wBAAqC;EAArC,eAAqC;EAArC,yBAAqC;KAArC,sBAAqC;UAArC,iBAAqC;EAArC,kBAAqC;EAArC,gBAAqC;EAArC,8BAAqC;EAArC,mBAAqC;EAArC,gKAAqC;EAArC,wJAAqC;EAArC,iLAAqC;EAArC,0BAAqC;EAArC;AAAqC;;AAArC;AAAA;IAAA,sDAAqC;IAArC;EAAqC;AAAA;;AAArC;EAAA,mBAAqC;EAArC;AAAqC;;AAArC;EAAA;AAAqC;;AAIrC;EAAA,uBAAqC;EAArC,oBAAqC;EAArC,uBAAqC;EAArC,oBAAqC;EAArC,qBAAqC;EAArC,mBAAqC;EAArC,oBAAqC;EAArC,qCAAqC;EAArC,oBAAqC;EAArC,oBAAqC;EAArC,wBAAqC;EAArC,eAAqC;EAArC,yBAAqC;KAArC,sBAAqC;UAArC,iBAAqC;EAArC,kBAAqC;EAArC,gBAAqC;EAArC,8BAAqC;EAArC,mBAAqC;EAArC,gKAAqC;EAArC,wJAAqC;EAArC,iLAAqC;EAArC,0BAAqC;EAArC;AAAqC;;AAArC;AAAA;IAAA,sDAAqC;IAArC;EAAqC;AAAA;;AAArC;EAAA,mBAAqC;EAArC;AAAqC;;AAArC;EAAA;AAAqC;;AAIrC;EAAA,uBAAmC;EAAnC,mBAAmC;EAAnC,sBAAmC;EAAnC,qBAAmC;EAAnC,sBAAmC;EAAnC,mBAAmC;EAAnC,oBAAmC;EAAnC,kBAAmC;EAAnC,oCAAmC;EAAnC,oBAAmC;EAAnC,2BAAmC;EAAnC,eAAmC;EAAnC,yBAAmC;KAAnC,sBAAmC;UAAnC,iBAAmC;EAAnC,kBAAmC;EAAnC,gBAAmC;EAAnC,8BAAmC;EAAnC,mBAAmC;EAAnC,gKAAmC;EAAnC,wJAAmC;EAAnC,iLAAmC;EAAnC,0BAAmC;EAAnC;AAAmC;;AAAnC;AAAA;IAAA,uDAAmC;IAAnC;EAAmC;AAAA;;AAAnC;EAAA,mBAAmC;EAAnC;AAAmC;;AAAnC;EAAA,0BAAmC;EAAnC,qCAAmC;EAAnC,0DAAmC;EAAnC,oMAAmC;EAAnC;AAAmC;;AAInC;;EAAA,UAAsB;;EAAtB,eAAsB;;EAAtB,yBAAsB;;KAAtB,sBAAsB;;UAAtB,iBAAsB;;EAAtB,8BAAsB;;EAAtB,mBAAsB;;AAAA;;AAAtB;EAAA,mBAAsB;EAAtB;AAAsB;;AAAtB;EAAA,aAAsB;EAAtB,YAAsB;EAAtB,WAAsB;EAAtB,+LAAsB;EAAtB,mBAAsB;EAAtB,uBAAsB;EAAtB,qBAAsB;EAAtB,iBAAsB;EAAtB,sBAAsB;EAAtB,kCAAsB;EAAtB,mEAAsB;EAAtB,4DAAsB;EAAtB,mEAAsB;EAAtB,mEAAsB;EAAtB,4GAAsB;EAAtB,wDAAsB;EAAtB,eAAsB;EAAtB,kBAAsB;EAAtB,mBAAsB;EAAtB,kBAAsB;EAAtB,mBAAsB;EAAtB,oBAAsB;EAAtB,gBAAsB;EAAtB,oBAAsB;EAAtB,2BAAsB;EAAtB,gFAAsB;EAAtB,oGAAsB;EAAtB,qGAAsB;EAAtB,uGAAsB;EAAtB,gKAAsB;EAAtB,wJAAsB;EAAtB,iLAAsB;EAAtB,0BAAsB;EAAtB;AAAsB;;AAAtB;AAAA;IAAA,yDAAsB;IAAtB,qEAAsB;IAAtB;EAAsB;AAAA;;AAAtB;EAAA,kBAAsB;EAAtB,kBAAsB;EAAtB,qKAAsB;EAAtB;AAAsB;;AAAtB;EAAA,8BAAsB;EAAtB,mBAAsB;EAAtB,2GAAsB;EAAtB,yGAAsB;EAAtB,wEAAsB;EAAtB,4FAAsB;EAAtB,oBAAsB;EAAtB;AAAsB;;AAAtB;EAAA,eAAsB;EAAtB,eAAsB;EAAtB,+JAAsB;EAAtB;AAAsB;;AAAtB;;EAAA;IAAA,YAAsB;IAAtB,WAAsB;IAAtB,mBAAsB;IAAtB;EAAsB;AAAA;;AAAtB;;EAAA,0BAAsB;EAAtB,gFAAsB;;AAAA;;AAItB;EAAA,uBAA6C;EAA7C,mBAA6C;EAA7C,sBAA6C;EAA7C,qBAA6C;EAA7C,sBAA6C;EAA7C,mBAA6C;EAA7C,oBAA6C;EAA7C,kBAA6C;EAA7C,oCAA6C;EAA7C,oBAA6C;EAA7C,2BAA6C;EAA7C,eAA6C;EAA7C,yBAA6C;KAA7C,sBAA6C;UAA7C,iBAA6C;EAA7C,kBAA6C;EAA7C,gBAA6C;EAA7C,8BAA6C;EAA7C,mBAA6C;EAA7C,gKAA6C;EAA7C,wJAA6C;EAA7C,iLAA6C;EAA7C,0BAA6C;EAA7C;AAA6C;;AAA7C;AAAA;IAAA,uDAA6C;IAA7C;EAA6C;AAAA;;AAA7C;EAAA,mBAA6C;EAA7C;AAA6C;;AAA7C;EAAA,0BAA6C;EAA7C,qCAA6C;EAA7C,0DAA6C;EAA7C,oMAA6C;EAA7C;AAA6C;;AAI7C;EAAA,qBAAqC;EAArC,mBAAqC;EAArC,sBAAqC;EAArC,kBAAqC;EAArC,mBAAqC;EAArC,mBAAqC;EAArC;AAAqC;;AAArC;;EAAA;IAAA,oBAAqC;IAArC,uBAAqC;IAArC,oBAAqC;IAArC,qBAAqC;IAArC,mBAAqC;IAArC;EAAqC;AAAA;;AAArC;EAAA,qCAAqC;EAArC,oBAAqC;EAArC,oBAAqC;EAArC,wBAAqC;EAArC,eAAqC;EAArC,yBAAqC;KAArC,sBAAqC;UAArC,iBAAqC;EAArC,kBAAqC;EAArC,gBAAqC;EAArC,8BAAqC;EAArC,mBAAqC;EAArC,gKAAqC;EAArC,wJAAqC;EAArC,iLAAqC;EAArC,0BAAqC;EAArC;AAAqC;;AAArC;AAAA;IAAA,sDAAqC;IAArC;EAAqC;AAAA;;AAArC;EAAA,mBAAqC;EAArC;AAAqC;;AAArC;EAAA;AAAqC;;AAIrC;EAAA,qBAAmC;EAAnC,mBAAmC;EAAnC,sBAAmC;EAAnC,kBAAmC;EAAnC,mBAAmC;EAAnC,mBAAmC;EAAnC;AAAmC;;AAAnC;;EAAA;IAAA,oBAAmC;IAAnC,uBAAmC;IAAnC,oBAAmC;IAAnC,qBAAmC;IAAnC,mBAAmC;IAAnC;EAAmC;AAAA;;AAAnC;EAAA,kBAAmC;EAAnC,oCAAmC;EAAnC,oBAAmC;EAAnC,2BAAmC;EAAnC,eAAmC;EAAnC,yBAAmC;KAAnC,sBAAmC;UAAnC,iBAAmC;EAAnC,kBAAmC;EAAnC,gBAAmC;EAAnC,8BAAmC;EAAnC,mBAAmC;EAAnC,gKAAmC;EAAnC,wJAAmC;EAAnC,iLAAmC;EAAnC,0BAAmC;EAAnC;AAAmC;;AAAnC;AAAA;IAAA,uDAAmC;IAAnC;EAAmC;AAAA;;AAAnC;EAAA,mBAAmC;EAAnC;AAAmC;;AAAnC;EAAA,0BAAmC;EAAnC,qCAAmC;EAAnC,0DAAmC;EAAnC,oMAAmC;EAAnC;AAAmC;;AAInC;EAAA,qBAA6C;EAA7C,mBAA6C;EAA7C,sBAA6C;EAA7C,kBAA6C;EAA7C,mBAA6C;EAA7C,mBAA6C;EAA7C;AAA6C;;AAA7C;;EAAA;IAAA,oBAA6C;IAA7C,uBAA6C;IAA7C,oBAA6C;IAA7C,qBAA6C;IAA7C,mBAA6C;IAA7C;EAA6C;AAAA;;AAA7C;EAAA,kBAA6C;EAA7C,oCAA6C;EAA7C,oBAA6C;EAA7C,2BAA6C;EAA7C,eAA6C;EAA7C,yBAA6C;KAA7C,sBAA6C;UAA7C,iBAA6C;EAA7C,kBAA6C;EAA7C,gBAA6C;EAA7C,8BAA6C;EAA7C,mBAA6C;EAA7C,gKAA6C;EAA7C,wJAA6C;EAA7C,iLAA6C;EAA7C,0BAA6C;EAA7C;AAA6C;;AAA7C;AAAA;IAAA,uDAA6C;IAA7C;EAA6C;AAAA;;AAA7C;EAAA,mBAA6C;EAA7C;AAA6C;;AAA7C;EAAA,0BAA6C;EAA7C,qCAA6C;EAA7C,0DAA6C;EAA7C,oMAA6C;EAA7C;AAA6C;;AAI7C;EAAA,sBAAqC;EAArC,mBAAqC;EAArC,sBAAqC;EAArC,kBAAqC;EAArC,mBAAqC;EAArC,mBAAqC;EAArC;AAAqC;;AAArC;;EAAA;IAAA,oBAAqC;IAArC,uBAAqC;IAArC,kBAAqC;IAArC;EAAqC;AAAA;;AAArC;EAAA,qCAAqC;EAArC,oBAAqC;EAArC,oBAAqC;EAArC,wBAAqC;EAArC,eAAqC;EAArC,yBAAqC;KAArC,sBAAqC;UAArC,iBAAqC;EAArC,kBAAqC;EAArC,gBAAqC;EAArC,8BAAqC;EAArC,mBAAqC;EAArC,gKAAqC;EAArC,wJAAqC;EAArC,iLAAqC;EAArC,0BAAqC;EAArC;AAAqC;;AAArC;AAAA;IAAA,sDAAqC;IAArC;EAAqC;AAAA;;AAArC;EAAA,mBAAqC;EAArC;AAAqC;;AAArC;EAAA;AAAqC;;AAIrC;EAAA,sBAAmC;EAAnC,mBAAmC;EAAnC,sBAAmC;EAAnC,kBAAmC;EAAnC,mBAAmC;EAAnC,mBAAmC;EAAnC;AAAmC;;AAAnC;;EAAA;IAAA,oBAAmC;IAAnC,uBAAmC;IAAnC,kBAAmC;IAAnC;EAAmC;AAAA;;AAAnC;EAAA,kBAAmC;EAAnC,oCAAmC;EAAnC,oBAAmC;EAAnC,2BAAmC;EAAnC,eAAmC;EAAnC,yBAAmC;KAAnC,sBAAmC;UAAnC,iBAAmC;EAAnC,kBAAmC;EAAnC,gBAAmC;EAAnC,8BAAmC;EAAnC,mBAAmC;EAAnC,gKAAmC;EAAnC,wJAAmC;EAAnC,iLAAmC;EAAnC,0BAAmC;EAAnC;AAAmC;;AAAnC;AAAA;IAAA,uDAAmC;IAAnC;EAAmC;AAAA;;AAAnC;EAAA,mBAAmC;EAAnC;AAAmC;;AAAnC;EAAA,0BAAmC;EAAnC,qCAAmC;EAAnC,0DAAmC;EAAnC,oMAAmC;EAAnC;AAAmC;;AAInC;EAAA,sBAA6C;EAA7C,mBAA6C;EAA7C,sBAA6C;EAA7C,kBAA6C;EAA7C,mBAA6C;EAA7C,mBAA6C;EAA7C;AAA6C;;AAA7C;;EAAA;IAAA,oBAA6C;IAA7C,uBAA6C;IAA7C,kBAA6C;IAA7C;EAA6C;AAAA;;AAA7C;EAAA,kBAA6C;EAA7C,oCAA6C;EAA7C,oBAA6C;EAA7C,2BAA6C;EAA7C,eAA6C;EAA7C,yBAA6C;KAA7C,sBAA6C;UAA7C,iBAA6C;EAA7C,kBAA6C;EAA7C,gBAA6C;EAA7C,8BAA6C;EAA7C,mBAA6C;EAA7C,gKAA6C;EAA7C,wJAA6C;EAA7C,iLAA6C;EAA7C,0BAA6C;EAA7C;AAA6C;;AAA7C;AAAA;IAAA,uDAA6C;IAA7C;EAA6C;AAAA;;AAA7C;EAAA,mBAA6C;EAA7C;AAA6C;;AAA7C;EAAA,0BAA6C;EAA7C,qCAA6C;EAA7C,0DAA6C;EAA7C,oMAA6C;EAA7C;AAA6C;;AAI7C;EAAA,qBAAyT;EAAzT,oBAAyT;EAAzT,mBAAyT;EAAzT,uBAAyT;EAAzT,uBAAyT;EAAzT,kBAAyT;EAAzT,qCAAyT;EAAzT,mBAAyT;EAAzT,sBAAyT;EAAzT,kBAAyT;EAAzT,mBAAyT;EAAzT,kBAAyT;EAAzT,mBAAyT;EAAzT,oBAAyT;EAAzT,gBAAyT;EAAzT,oBAAyT;EAAzT,2BAAyT;EAAzT,gKAAyT;EAAzT,wJAAyT;EAAzT,iLAAyT;EAAzT,0BAAyT;EAAzT;AAAyT;;AAAzT;AAAA;IAAA,wDAAyT;IAAzT;EAAyT;AAAA;;AAAzT;EAAA;AAAyT;;AAAzT;EAAA,8BAAyT;EAAzT,mBAAyT;EAAzT,2GAAyT;EAAzT,yGAAyT;EAAzT,wEAAyT;EAAzT,4FAAyT;EAAzT;AAAyT;;AAAzT;EAAA,mBAAyT;EAAzT;AAAyT;;AAAzT;;EAAA;IAAA,oBAAyT;IAAzT,uBAAyT;IAAzT,kBAAyT;IAAzT;EAAyT;AAAA;;AAG3T,WAAW;;AAGT;EAAA,cAA+G;EAA/G,WAA+G;EAA/G,uBAA+G;EAA/G,sBAA+G;EAA/G,kCAA+G;EAA/G,mBAA+G;EAA/G,oBAA+G;EAA/G,0CAA+G;EAA/G,uDAA+G;EAA/G,+DAA+G;EAA/G;AAA+G;;AAA/G;AAAA;IAAA;EAA+G;AAAA;;AAA/G;EAAA,sBAA+G;EAA/G,gCAA+G;EAA/G,oBAA+G;EAA/G;AAA+G;;AAA/G;AAAA;IAAA;EAA+G;AAAA;;AAI/G;EAAA,cAA+G;EAA/G,WAA+G;EAA/G,uBAA+G;EAA/G,sBAA+G;EAA/G,kCAA+G;EAA/G,mBAA+G;EAA/G,oBAA+G;EAA/G,0CAA+G;EAA/G,uDAA+G;EAA/G,+DAA+G;EAA/G;AAA+G;;AAA/G;AAAA;IAAA;EAA+G;AAAA;;AAA/G;EAAA,sBAA+G;EAA/G,gCAA+G;EAA/G,oBAA+G;EAA/G;AAA+G;;AAA/G;AAAA;IAAA;EAA+G;AAAA;;AAGjH,WAAW;;AAGT;EAAA,kBAAiG;EAAjG,gBAAiG;EAAjG,yBAAiG;EAAjG,oBAAiG;EAAjG,sBAAiG;EAAjG,oBAAiG;EAAjG,wBAAiG;EAAjG;AAAiG;;AAAjG;AAAA;IAAA;EAAiG;AAAA;;AAAjG;;EAAA;IAAA,kBAAiG;IAAjG;EAAiG;AAAA;;AAGnG,iBAAiB;;AAEjB,SAAS;;AAGP;EAAA,qBAAgE;EAAhE,iBAAgE;EAAhE,sBAAgE;EAAhE,kCAAgE;EAAhE;AAAgE;;AAAhE;AAAA;IAAA;EAAgE;AAAA;;AAAhE;;EAAA;IAAA,uBAAgE;IAAhE,4BAAgE;IAAhE,oDAAgE;IAAhE,qCAAgE;IAAhE;EAAgE;;EAAhE;IAAA;EAAgE;AAAA;;AAIhE;EAAA,eAAuW;EAAvW,aAAuW;EAAvW,YAAuW;EAAvW,SAAuW;EAAvW,eAAuW;EAAvW,yBAAuW;KAAvW,sBAAuW;UAAvW,iBAAuW;EAAvW,mBAAuW;EAAvW,uBAAuW;EAAvW,uBAAuW;EAAvW,kBAAuW;EAAvW,sCAAuW;EAAvW,oBAAuW;EAAvW,qBAAuW;EAAvW,mBAAuW;EAAvW,oBAAuW;EAAvW,cAAuW;EAAvW,oBAAuW;EAAvW,wBAAuW;EAAvW,8BAAuW;EAAvW;AAAuW;;AAAvW;AAAA;IAAA,yDAAuW;IAAvW;EAAuW;AAAA;;AAAvW;EAAA,oBAAuW;EAAvW;AAAuW;;AAAvW;AAAA;IAAA;EAAuW;AAAA;;AAAvW;EAAA,kBAAuW;EAAvW,sCAAuW;EAAvW,gBAAuW;EAAvW,oBAAuW;EAAvW;AAAuW;;AAAvW;AAAA;IAAA,yDAAuW;IAAvW;EAAuW;AAAA;;AAAvW;EAAA;AAAuW;;AAAvW;;EAAA;IAAA,WAAuW;IAAvW,YAAuW;IAAvW,kBAAuW;IAAvW,mBAAuW;IAAvW,eAAuW;IAAvW;EAAuW;AAAA;;AAGzW,cAAc;;AAGZ;EAAA,aAA8F;EAA9F,yBAA8F;KAA9F,sBAA8F;UAA9F,iBAA8F;EAA9F,mBAA8F;EAA9F,sBAA8F;EAA9F,mBAA8F;EAA9F,sBAA8F;EAA9F,oBAA8F;EAA9F,8BAA8F;EAA9F;AAA8F;;AAA9F;EAAA,oBAA8F;EAA9F;AAA8F;;AAA9F;AAAA;IAAA;EAA8F;AAAA;;AAxOhG;;EAAA;IAAA,mBAyOC;IAzOD,sBAyOC;EAAA;;EAzOD;IAAA,uBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,sBAyOC;IAzOD,sBAyOC;IAzOD,uBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,0BAyOC;IAzOD;EAyOC;;EAzOD;IAAA,sBAyOC;IAzOD,aAyOC;IAzOD,oBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,sBAyOC;IAzOD,iBAyOC;IAzOD,oBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,sBAyOC;IAzOD,uBAyOC;IAzOD,0BAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,0BAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,aAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,sBAyOC;IAzOD,wBAyOC;IAzOD,wBAyOC;IAzOD,+BAyOC;IAzOD,2BAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,sBAyOC;IAzOD,sBAyOC;IAzOD,uBAyOC;IAzOD,0BAyOC;IAzOD,sBAyOC;IAzOD,wBAyOC;IAzOD,uBAyOC;IAzOD,2BAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,0BAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,0BAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,sBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,2BAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,wBAyOC;IAzOD,uBAyOC;IAzOD,2BAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,aAyOC;IAzOD;EAyOC;;EAzOD;IAAA,sBAyOC;IAzOD,sBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;AAAA;;AAzOD;;EAAA;IAAA;EAyOC;;EAzOD;;IAAA;MAAA;IAyOC;EAAA;;EAzOD;;IAAA;MAAA;IAyOC;EAAA;;EAzOD;;IAAA;MAAA;IAyOC;EAAA;;EAzOD;;IAAA;MAAA;IAyOC;EAAA;;EAzOD;;IAAA;MAAA;IAyOC;EAAA;;EAzOD;IAAA,eAyOC;IAzOD,iBAyOC;EAAA;;EAzOD;IAAA,kBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,iBAyOC;IAzOD,gBAyOC;IAzOD,iBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,iBAyOC;IAzOD,oBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,iBAyOC;IAzOD,aAyOC;IAzOD,0BAyOC;IAzOD;EAyOC;;EAzOD;IAAA,gBAyOC;IAzOD,eAyOC;IAzOD,kBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,iBAyOC;IAzOD,iBAyOC;IAzOD,oBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,iBAyOC;IAzOD,oBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,eAyOC;IAzOD;EAyOC;;EAzOD;IAAA,eAyOC;IAzOD;EAyOC;;EAzOD;IAAA,aAyOC;IAzOD;EAyOC;;EAzOD;IAAA,eAyOC;IAzOD;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD,wBAyOC;IAzOD,qBAyOC;IAzOD,2BAyOC;IAzOD,wBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD,sBAyOC;IAzOD,uBAyOC;IAzOD,0BAyOC;IAzOD,uBAyOC;IAzOD,wBAyOC;IAzOD,+BAyOC;IAzOD,2BAyOC;IAzOD;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD,qBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD,qBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,iBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,iBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,eAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,+BAyOC;IAzOD,2BAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,wBAyOC;IAzOD,+BAyOC;IAzOD,2BAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,eAyOC;IAzOD;EAyOC;;EAzOD;IAAA,aAyOC;IAzOD;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD,sBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;AAAA;;AAzOD;;EAAA;IAAA;EAyOC;;EAzOD;;IAAA;MAAA;IAyOC;EAAA;;EAzOD;;IAAA;MAAA;IAyOC;EAAA;;EAzOD;;IAAA;MAAA;IAyOC;EAAA;;EAzOD;;IAAA;MAAA;IAyOC;EAAA;;EAzOD;;IAAA;MAAA;IAyOC;EAAA;AAAA;;AAzOD;EAAA,0BAyOC;EAzOD;AAyOC;;AAzOD;EAAA,0BAyOC;EAzOD;AAyOC;;AAzOD;EAAA,0BAyOC;EAzOD;AAyOC;;AAzOD;EAAA,0BAyOC;EAzOD,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,0BAyOC;EAzOD,0CAyOC;EAzOD,uDAyOC;EAzOD,+DAyOC;EAzOD;AAyOC;;AAzOD;EAAA,0BAyOC;EAzOD,8BAyOC;EAzOD,wDAyOC;EAzOD;AAyOC;;AAzOD;EAAA,0BAyOC;EAzOD;AAyOC;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA,sBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,eAyOC;EAzOD,eAyOC;EAzOD,+JAyOC;EAzOD;AAyOC;;AAzOD;EAAA,sBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,sBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,sBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA,oBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA,+EAyOC;EAzOD,mGAyOC;EAzOD,oGAyOC;EAzOD;AAyOC;;AAzOD;EAAA,sBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,sBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,sBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,sBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA,sBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,8BAyOC;EAzOD;AAyOC;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA,2GAyOC;EAzOD,yGAyOC;EAzOD,wEAyOC;EAzOD;AAyOC;;AAzOD;EAAA,2GAyOC;EAzOD,yGAyOC;EAzOD,4FAyOC;EAzOD;AAyOC;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA,oBAyOC;EAzOD;AAyOC;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,oBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,oBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,oBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,oBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,kBAyOC;EAzOD;AAyOC;;AAzOD;AAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,0BAyOC;EAzOD,sBAyOC;EAzOD,8KAyOC;EAzOD;AAyOC;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA;AAyOC;;AAzOD;;EAAA;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;AAAA;;AAzOD;;EAAA;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,oBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,gBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,iBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,gBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,wBAyOC;IAzOD,yCAyOC;IAzOD,kEAyOC;IAzOD,kCAyOC;IAzOD;EAyOC;;EAzOD;IAAA,sBAyOC;IAzOD;EAyOC;;AAzOD;AAAA;MAAA;IAyOC;AAAA;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,oBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,oBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,mBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,mBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;AAAA;;AAzOD;;EAAA;IAAA,kBAyOC;IAzOD,UAyOC;IAzOD,WAyOC;IAzOD,UAyOC;IAzOD,YAyOC;IAzOD,gBAyOC;IAzOD,sBAyOC;IAzOD,mBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,oBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,2BAyOC;IAzOD,mDAyOC;IAzOD,oCAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,4BAyOC;IAzOD,oDAyOC;IAzOD,qCAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,8BAyOC;IAzOD,sDAyOC;IAzOD,uCAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,+BAyOC;IAzOD,uDAyOC;IAzOD,wCAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,4BAyOC;IAzOD,oDAyOC;IAzOD,qCAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,4BAyOC;IAzOD,oDAyOC;IAzOD,qCAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,mCAyOC;IAzOD,2DAyOC;IAzOD,4BAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,oCAyOC;IAzOD,4DAyOC;IAzOD,6BAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,oCAyOC;IAzOD,4DAyOC;IAzOD,6BAyOC;IAzOD;EAyOC;;EAzOD;IAAA,uBAyOC;IAzOD,oCAyOC;IAzOD,4DAyOC;IAzOD,6BAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,sBAyOC;IAzOD;EAyOC;;AAzOD;AAAA;MAAA;IAyOC;AAAA;;EAzOD;IAAA,kBAyOC;IAzOD;EAyOC;;AAzOD;AAAA;MAAA;IAyOC;AAAA;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,qBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,mBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,mBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,mBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,iBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,mBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,eAyOC;IAzOD;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,eAyOC;IAzOD;EAyOC;;EAzOD;IAAA,eAyOC;IAzOD;EAyOC;;EAzOD;IAAA,mBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,mBAyOC;IAzOD;EAyOC;;EAzOD;IAAA,kBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,oBAyOC;IAzOD;EAyOC;;AAzOD;AAAA;MAAA;IAyOC;AAAA;AAAA;;AAzOD;;EAAA;IAAA,iBAyOC;IAzOD;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA;EAyOC;;EAzOD;IAAA,oBAyOC;IAzOD;EAyOC;AAAA;;AAzOD;;EAAA;IAAA;EAyOC;AAAA;;AAzOD;;EAAA;IAAA;EAyOC;AAAA;;AAzOD;EAAA,4BAyOC;EAzOD;AAyOC;;AAzOD;EAAA;AAyOC;;AAzOD;EAAA,gCAyOC;EAzOD;AAyOC;;AAzOD;EAAA;AAyOC","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&display=swap\");\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  @font-face {\n    font-family: \"Wallop\";\n    src: url(\"@proj-client/assets/fonts/wallop/Wallop-Medium.woff2\") format(\"woff2\");\n    font-weight: normal;\n    font-style: normal;\n  }\n\n  @font-face {\n    font-family: \"Wallop\";\n    src: url(\"@proj-client/assets/fonts/wallop/Wallop-Bold.woff2\") format(\"woff2\");\n    font-weight: bold;\n    font-weight: 600 700;\n    font-style: normal;\n  }\n\n  html {\n    font-feature-settings: \"calt\", \"clig\", \"kern\", \"liga\", \"locl\", \"rlig\";\n    font-weight: normal;\n    font-family: \"Lexend\", sans-serif;\n  }\n}\n\n\n\n.btn-indigo {\n  @apply py-2 px-4 font-display font-semibold rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-opacity-75;\n}\n\n.idtn-header-modal {\n  @apply text-2xl md:text-3xl font-bold font-display subpixel-antialiased;\n}\n\n/* Colors */\n\n.idtn-primary-bg-color {\n  @apply bg-rose-600  text-white;\n}\n\n.idtn-primary-bg-color-elevated {\n  @apply bg-indigo-600  text-white;\n}\n\n.idtn-secondary-bg-color {\n  @apply bg-slate-800 bg-opacity-10 text-slate-800;\n}\n\n/* Buttons */\n\n.idtn-btn {\n  @apply font-medium text-center outline-none disabled:opacity-30 disabled:cursor-not-allowed transition duration-300 ease-in-out cursor-pointer select-none ;\n}\n\n\n/* Buttons: Sizes */\n\n.idtn-btn-sm {\n  @apply text-sm py-1 px-2 rounded-sm;\n}\n\n.idtn-btn-md {\n  @apply text-sm py-2 px-3 rounded-md;\n}\n\n.idtn-btn-lg {\n  @apply text-lg md:text-lg py-2 md:py-3 px-4 md:px-6 rounded-lg;\n}\n\n.idtn-btn-xl {\n  @apply text-lg md:text-xl py-2 md:py-3 px-8 rounded-xl;\n}\n\n\n\n.idtn-btn-circle {\n\n  /*button */\n  @apply outline-none disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer select-none;\n\n  @apply flex justify-center items-center text-center \n  text-sm font-semibold md:text-lg text-white\n  p-6 px-8 w-20 h-20 md:h-24 md:w-24\n  rounded-full \n  shadow-xl\n  bg-[conic-gradient(at_left,_var(--tw-gradient-stops))] from-rose-600 via-pink-600 to-indigo-600\n  border-4 border-white\n  transition duration-150 ease-in-out transform \n   hover:scale-125 active:scale-100 focus:outline-none focus:ring-4\n   focus:ring-yellow-300;\n\n  /* Beveled Border Effect */\n  box-shadow: inset 0 1px 2px rgba(255, 255, 0, 0.3), 0 2px 6px rgba(0, 0, 0, 0.3);\n\n}\n\n.idtn-btn-floating {\n\n/*button */\n@apply outline-none disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer select-none;\n\n@apply flex justify-center items-center text-center \ntext-xs font-semibold md:text-base text-rose-600\np-1 px-2\nrounded-md\nshadow-md\nbg-white\nborder-2 border-rose-600\ntransition duration-150 ease-in-out transform \n md:hover:scale-125 active:scale-100 focus:outline-none focus:ring-4\n focus:ring-yellow-300;\n\n/* Beveled Border Effect */\nbox-shadow: inset 0 1px 2px rgba(255, 255, 0, 0.3), 0 2px 6px rgba(0, 0, 0, 0.3);\n\n}\n\n\n/* Buttons: Colors */\n\n\n.idtn-btn-naked {\n  @apply  bg-slate-100 bg-opacity-0 hover:bg-opacity-100 active:bg-opacity-100 border-0 transition-opacity duration-200 active:border-0 focus:border-0\n  /*@apply idtn-btn bg-slate-800 bg-opacity-0 hover:bg-opacity-10 active:bg-opacity-10  text-slate-800;*/\n}\n\n.idtn-btn-secondary {\n  @apply idtn-btn idtn-secondary-bg-color hover:opacity-80\n}\n\n.idtn-btn-primary {\n  @apply idtn-btn idtn-primary-bg-color hover:drop-shadow-[0_0_5px_rgba(244,63,94,0.6)] hover:shadow-rose-500;\n}\n\n.idtn-btn-primary-elevated {\n    @apply idtn-btn idtn-primary-bg-color-elevated hover:drop-shadow-[0_0_5px_rgba(244,63,94,0.6)] hover:shadow-indigo-500;\n}\n\n/* Buttons: Composites */\n\n.idtn-btn-naked-sm {\n    @apply idtn-btn-naked idtn-btn-sm;\n}\n\n.idtn-btn-naked-md {\n  @apply idtn-btn-naked idtn-btn-md;\n}\n\n.idtn-btn-secondary-md {\n  @apply idtn-btn-secondary idtn-btn-md;\n}\n\n.idtn-btn-secondary-sm {\n  @apply idtn-btn-secondary idtn-btn-sm;\n}\n\n.idtn-btn-primary-md {\n  @apply idtn-btn-primary idtn-btn-md;\n}\n\n.idtn-btn-primary-circle {\n  @apply idtn-btn-circle;\n}\n\n.idtn-btn-primary-elevated-md {\n  @apply idtn-btn-primary-elevated idtn-btn-md ;\n}\n\n.idtn-btn-secondary-lg {\n  @apply idtn-btn-secondary idtn-btn-lg;\n}\n\n.idtn-btn-primary-lg {\n  @apply idtn-btn-primary idtn-btn-lg;\n}\n\n.idtn-btn-primary-elevated-lg {\n  @apply idtn-btn-primary-elevated idtn-btn-lg ;\n}\n\n.idtn-btn-secondary-xl {\n  @apply idtn-btn-secondary idtn-btn-xl;\n}\n\n.idtn-btn-primary-xl {\n  @apply idtn-btn-primary idtn-btn-xl;\n}\n\n.idtn-btn-primary-elevated-xl {\n  @apply idtn-btn-primary-elevated idtn-btn-xl ;\n}\n\n.idtn-btn-google-xl {\n  @apply text-white bg-[#4285F4] hover:bg-[#4285F4]/90 disabled:bg-[#4285F4]/70 disabled:cursor-not-allowed transition duration-300 ease-in-out focus:ring-4 focus:outline-none focus:ring-[#4285F4]/50 font-medium text-lg md:text-xl py-2 md:py-3 px-8 rounded-md text-center inline-flex items-center justify-center mb-2\n}\n\n/* Inputs */\n\n.textarea {\n  @apply block w-full text-sm rounded-md border-slate-300 shadow-sm focus:border-indigo-600 focus:ring-indigo-600;\n}\n\n.input {\n  @apply block w-full text-sm rounded-md border-slate-300 shadow-sm focus:border-indigo-600 focus:ring-indigo-600;\n}\n\n/* Labels */\n\n.idtn-label {\n  @apply text-xs md:text-xs font-medium leading-5 text-gray-900 opacity-50 uppercase tracking-wider;\n}\n\n/* Radix styles */\n\n/* Tabs */\n\n.tabs-list {\n  @apply md:space-x-4 border rounded-lg border-gray-200 p-1 md:p-4;\n}\n\n.tabs-trigger {\n  @apply m-1 md:m-0 bg-white px-2 md:px-8 rounded-md h-[35px] md:h-[45px] flex-1 flex items-center justify-center text-sm md:text-base leading-none text-slate-800 select-none hover:text-slate-600 data-[state=active]:text-indigo-800 data-[state=active]:font-semibold data-[state=active]:bg-indigo-200 data-[state=active]:focus:relative outline-none cursor-default\n}\n\n/* Drop-down */\n\n.nav-dropdown-item {\n  @apply flex items-center px-1 pl-6 py-2 select-none outline-none data-[disabled]:text-slate-600\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
